import { DailyAudioTrack, DailyVideo, useActiveSpeakerId, useAppMessage, useAudioLevelObserver, useCPULoad, useDaily, useDailyEvent, useDevices, useLocalSessionId, useMeetingSessionState, useMeetingState, useNetwork, useParticipantIds, useParticipantProperty, useRecording, useScreenShare, useWaitingParticipants } from "@daily-co/daily-react";
import { Excalidraw, MainMenu } from "@excalidraw/excalidraw";
import { Fragment, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { isMobile, isTablet } from "react-device-detect";
import { PackedGrid } from 'react-packed-grid';
import TextareaAutosize from 'react-textarea-autosize';
import { v4 as uuidv4 } from 'uuid';
import api from "../api";
import { ReactComponent as DocumentIcon } from "../assets/images/icons/ic-document.svg";
import { ReactComponent as BackgroundEffectsIcon } from "../assets/images/icons/ic-background-effects.svg";
import { ReactComponent as ModuleIcon } from "../assets/images/icons/ic-book-active.svg";
import { ReactComponent as CalendarIcon } from "../assets/images/icons/ic-calendar-filled.svg";
import { ReactComponent as ExitIcon } from "../assets/images/icons/ic-call-end.svg";
import { ReactComponent as CamOffIcon } from "../assets/images/icons/ic-camera-off.svg";
import { ReactComponent as CamIcon } from "../assets/images/icons/ic-camera.svg";
import { ReactComponent as ChatIcon } from "../assets/images/icons/ic-chat-active.svg";
import { ReactComponent as ChatHourglassIcon } from "../assets/images/icons/ic-chat-hourglass.svg";
import { ReactComponent as ChatWarningIcon } from "../assets/images/icons/ic-chat-warning.svg";
import { ReactComponent as CheckmarkCircleIcon } from "../assets/images/icons/ic-checkmark-circle.svg";
import { ReactComponent as ClockIcon } from "../assets/images/icons/ic-clock.svg";
import { ReactComponent as CloseIcon } from "../assets/images/icons/ic-close.svg";
import { ReactComponent as CopIcon } from "../assets/images/icons/ic-cop.svg";
import { ReactComponent as DesktopIcon } from "../assets/images/icons/ic-desktop.svg";
import { ReactComponent as DismissCircleIcon } from "../assets/images/icons/ic-dismiss-circle.svg";
import { ReactComponent as DownloadIcon } from "../assets/images/icons/ic-download.svg";
import { ReactComponent as FileIcon } from "../assets/images/icons/ic-file.svg";
import { ReactComponent as FolderIcon } from "../assets/images/icons/ic-folder-simple.svg";
import { ReactComponent as FullIcon } from "../assets/images/icons/ic-full-layout.svg";
import { ReactComponent as TeacherIcon } from "../assets/images/icons/ic-graduation.svg";
import { ReactComponent as GridIcon } from "../assets/images/icons/ic-grid.svg";
import { ReactComponent as HandIcon } from "../assets/images/icons/ic-hand.svg";
import { ReactComponent as HourglassIcon } from "../assets/images/icons/ic-hourglass.svg";
import { ReactComponent as InfoIcon } from "../assets/images/icons/ic-info.svg";
import { ReactComponent as LessonIcon } from "../assets/images/icons/ic-lessons-active.svg";
import { ReactComponent as LockClosedIcon } from "../assets/images/icons/ic-lock-closed.svg";
import { ReactComponent as LockOpenIcon } from "../assets/images/icons/ic-lock-open.svg";
import { ReactComponent as MicOffIcon } from "../assets/images/icons/ic-mic-off.svg";
import { ReactComponent as MicIcon } from "../assets/images/icons/ic-mic.svg";
import { ReactComponent as MoonIcon } from "../assets/images/icons/ic-moon.svg";
import { ReactComponent as MoreIcon } from "../assets/images/icons/ic-more.svg";
import { ReactComponent as NetworkCheckIcon } from "../assets/images/icons/ic-network-check.svg";
import { ReactComponent as NoiseCancellationIcon } from "../assets/images/icons/ic-noise-cancellation.svg";
import { ReactComponent as NotificationIcon } from "../assets/images/icons/ic-notification-active.svg";
import { ReactComponent as NotificationOffIcon } from "../assets/images/icons/ic-notification-off.svg";
import { ReactComponent as EditIcon } from "../assets/images/icons/ic-pencil.svg";
import { ReactComponent as PeopleCheckIcon } from "../assets/images/icons/ic-people-check.svg";
import { ReactComponent as PersonDeleteIcon } from "../assets/images/icons/ic-person-delete.svg";
import { ReactComponent as PinIcon } from "../assets/images/icons/ic-pin.svg";
import { ReactComponent as PulseIcon } from "../assets/images/icons/ic-pulse.svg";
import { ReactComponent as ReactionIcon } from "../assets/images/icons/ic-reaction.svg";
import { ReactComponent as ScreenMaximizeIcon } from "../assets/images/icons/ic-screen-maximize.svg";
import { ReactComponent as ScreenMinimizeIcon } from "../assets/images/icons/ic-screen-minimize.svg";
import { ReactComponent as ScreenSharePersonIcon } from "../assets/images/icons/ic-screenshare-person.svg";
import { ReactComponent as ScreenShareStopIcon } from "../assets/images/icons/ic-screenshare-stop.svg";
import { ReactComponent as ScreenShareIcon } from "../assets/images/icons/ic-screenshare.svg";
import { ReactComponent as SendIcon } from "../assets/images/icons/ic-send.svg";
import { ReactComponent as SettingsIcon } from "../assets/images/icons/ic-settings.svg";
import { ReactComponent as ShareIcon } from "../assets/images/icons/ic-share.svg";
import { ReactComponent as SpeakerOffIcon } from "../assets/images/icons/ic-speaker-off.svg";
import { ReactComponent as SpeakerIcon } from "../assets/images/icons/ic-speaker.svg";
import { ReactComponent as SunIcon } from "../assets/images/icons/ic-sun.svg";
import { ReactComponent as ThemeIcon } from "../assets/images/icons/ic-theme.svg";
import { ReactComponent as TutorIcon } from "../assets/images/icons/ic-tutor.svg";
import { ReactComponent as UserIcon } from "../assets/images/icons/ic-user.svg";
import { ReactComponent as UsersIcon } from "../assets/images/icons/ic-users.svg";
import { ReactComponent as WhiteboardIcon } from "../assets/images/icons/ic-whiteboard.svg";
import { ReactComponent as WifiOffIcon } from "../assets/images/icons/ic-wifi-off.svg";
import { ReactComponent as WifiWarningIcon } from "../assets/images/icons/ic-wifi-warning.svg";
import { ReactComponent as WifiIcon } from "../assets/images/icons/ic-wifi.svg";
import UserPlaceholder from "../assets/images/placeholders/user-placeholder.png";
import { ReactComponent as VelvLogo } from "../assets/images/starting-finance-minimized.svg";
import { ButtonStatus, DailyAccessState, darkPalette, palette } from "../common/constants";
import { Each } from "../common/Each";
import useClickOutside from "../common/hooks/useClickOutside";
import { usePiPWindow } from "../common/hooks/usePiPWindow";
import useWindowDimensions from "../common/hooks/useWindowDimensions";
import MainContext from "../common/MainContext";
import Linkify from "../components/Linkify";
import TabIconSwitcher from "../components/TabIconSwitcher";
import TooltipWrapper from "../components/TooltipWrapper";
import { DialogStatus } from "../enums";
import typo from "../typography.module.css";
import { formatDateV2, formatFileSize, formatSeconds, formatTimeV2, getLocaleISOString } from "../utils";
import Button from "./Button";
import Checkbox from "./Checkbox";
import AlertDialog from "./dialogs/AlertDialog";
import Dialog from "./dialogs/Dialog";
import LiveBadge from "./LiveBadge";
import MeatBallsMenu from "./MeatBallsMenu";
import PiPWindow from "./PiPWindow";
import styles from "./Room.module.css";
import Select from "./Select";
import Slider from "./Slider";
import Spinner from "./Spinner";
import TextInput from "./TextInput";
import Toggle from "./Toggle";
import PDFCanvas from "./PDFCanvas";
import _ from "loadsh";

const AudioObserver = ({ session_id, onVolumeChange }) => {

    useAudioLevelObserver(
        session_id,
        useCallback((volume) => {
            onVolumeChange(volume)
        }, [session_id, onVolumeChange])
    );

    return (
        <></>
    );
};

const Reactions = ({ open, reactions, onClick, onSend, onClickOutside, tooltipStyle }) => {


    const reactionsRef = useRef(null)
    useClickOutside(reactionsRef, onClickOutside)

    return (
        <div className={styles.controlButtonWrapper} ref={reactionsRef} style={{ position: 'relative' }}>
            <div className={`${styles.reactions} ${open ? styles.open : ''}`} >
                <Each of={reactions} render={(reaction, index) => {
                    return (
                        <div className={styles.reaction} onClick={() => {
                            onSend(reaction)
                        }}>{reaction}</div>
                    )
                }} />
            </div>
            <TooltipWrapper text={'Reazioni'} style={{ ...tooltipStyle, display: (open || isMobile) ? 'none' : 'block' }}>
                <div style={{ position: 'relative' }}>
                    <ReactionIcon className={`${styles.controlButton} ${open ? styles.active : ''}`} onClick={onClick} />
                </div>
            </TooltipWrapper >
        </div >
    )
}

const Room = ({ lesson }) => {

    const context = useContext(MainContext)
    const { width, height } = useWindowDimensions()
    const { isSupported, requestPipWindow, pipWindow, closePipWindow } = usePiPWindow();

    const call = useDaily()
    const [meetingId, setMeetingId] = useState(null)
    const [meetingStartTime, setMeetingStartTime] = useState(null)
    const [meetingSeconds, setMeetingSeconds] = useState(null)
    const [meetingInterval, setMeetingInterval] = useState(null)
    const localSessionId = useLocalSessionId()
    const localParticipant = useParticipantProperty(localSessionId, ['audio', 'video'])
    const devices = useDevices()
    const activeSpeakerId = useActiveSpeakerId({ ignoreLocal: false })

    const { waitingParticipants, grantAccess } = useWaitingParticipants()
    const rawParticipants = useParticipantIds({
        sort: 'session_id'
    })

    const [pinnedIds, setPinnedIds] = useState([])
    const [handRaisedIds, setHandRaisedIds] = useState([])
    const [activeSpeakersOrder, setActiveSpeakersOrder] = useState([])
    const [camMicActiveOrder, setCamMicActiveOrder] = useState([])

    const findParticipantBySessionId = (sessionId) => {
        let key = sessionId === localSessionId ? 'local' : sessionId
        return call.participants()[key] ?? null
    }
    const isSharing = (session_id) => {
        const participant = findParticipantBySessionId(session_id)
        return participant?.tracks.screenVideo.state === 'playable'
    }
    const sortParticipants = (a, b) => {
        // Prioritize pinned participants
        const isPinnedA = pinnedIds.includes(a);
        const isPinnedB = pinnedIds.includes(b);
        if (isPinnedA && !isPinnedB) return -1;
        if (!isPinnedA && isPinnedB) return 1;

        const isSharingA = isSharing(a);
        const isSharingB = isSharing(b);

        if (isSharingA && !isSharingB) return -1;
        if (!isSharingA && isSharingB) return 1;

        // Follow the order of activeSpeakersOrder
        const indexA = activeSpeakersOrder.indexOf(a);
        const indexB = activeSpeakersOrder.indexOf(b);
        if (indexA !== -1 && indexB !== -1) return indexA - indexB;
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;

        const pinnedIndexA = pinnedIds.indexOf(a);
        const pinnedIndexB = pinnedIds.indexOf(b);
        if (pinnedIndexA !== -1 && pinnedIndexB !== -1) return pinnedIndexA - pinnedIndexB;
        if (pinnedIndexA !== -1) return -1;
        if (pinnedIndexB !== -1) return 1;


        const isHandRaisedA = handRaisedIds.includes(a);
        const isHandRaisedB = handRaisedIds.includes(b);
        if (isHandRaisedA && !isHandRaisedB) return -1;
        if (!isHandRaisedA && isHandRaisedB) return 1;

        const camMicActiveIndexA = camMicActiveOrder.indexOf(a);
        const camMicActiveIndexB = camMicActiveOrder.indexOf(b);
        if (camMicActiveIndexA !== -1 && camMicActiveIndexB !== -1) return camMicActiveIndexA - camMicActiveIndexB;
        if (camMicActiveIndexA !== -1) return -1;
        if (camMicActiveIndexB !== -1) return 1;

        // Place participants with the 'local' field set to true after others
        if (a === localSessionId && b !== localSessionId) return -1;
        if (b === localSessionId && a !== localSessionId) return 1;

        // Default to no specific order
        return a.localeCompare(b);
    }

    const sortPipParticipants = (a, b) => {
        // Local participant always first in PiP
        if (a === localSessionId && b !== localSessionId) return -1;
        if (b === localSessionId && a !== localSessionId) return 1;

        // Prioritize pinned participants
        const isPinnedA = pinnedIds.includes(a);
        const isPinnedB = pinnedIds.includes(b);
        if (isPinnedA && !isPinnedB) return -1;
        if (!isPinnedA && isPinnedB) return 1;

        const isSharingA = isSharing(a);
        const isSharingB = isSharing(b);

        if (isSharingA && !isSharingB) return -1;
        if (!isSharingA && isSharingB) return 1;

        // Follow the order of activeSpeakersOrder
        const indexA = activeSpeakersOrder.indexOf(a);
        const indexB = activeSpeakersOrder.indexOf(b);
        if (indexA !== -1 && indexB !== -1) return indexA - indexB;
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;

        const pinnedIndexA = pinnedIds.indexOf(a);
        const pinnedIndexB = pinnedIds.indexOf(b);
        if (pinnedIndexA !== -1 && pinnedIndexB !== -1) return pinnedIndexA - pinnedIndexB;
        if (pinnedIndexA !== -1) return -1;
        if (pinnedIndexB !== -1) return 1;


        const isHandRaisedA = handRaisedIds.includes(a);
        const isHandRaisedB = handRaisedIds.includes(b);
        if (isHandRaisedA && !isHandRaisedB) return -1;
        if (!isHandRaisedA && isHandRaisedB) return 1;

        const camMicActiveIndexA = camMicActiveOrder.indexOf(a);
        const camMicActiveIndexB = camMicActiveOrder.indexOf(b);
        if (camMicActiveIndexA !== -1 && camMicActiveIndexB !== -1) return camMicActiveIndexA - camMicActiveIndexB;
        if (camMicActiveIndexA !== -1) return -1;
        if (camMicActiveIndexB !== -1) return 1;

        // Default to no specific order
        return a.localeCompare(b);
    }

    const participants = [...rawParticipants].sort(sortParticipants)

    const rawPipParticipants = useParticipantIds({
        sort: 'session_id'
    })

    const pipParticipants = [...rawPipParticipants].sort(sortPipParticipants)

    const rawGroupParticipants = useParticipantIds({
        filter: (p) => {
            const sessionId = p.session_id
            const studentGroup = groupsMap?.current?.[`students_group_${sessionId}`]
            const teacherGroup = groupsMap?.current?.[`teachers_group_${sessionId}`]

            if (selectedGroup) {
                return studentGroup === selectedGroup || teacherGroup === selectedGroup || p.local
            } else {
                return (!studentGroup && !teacherGroup) || p.local
            }
        },
        sort: 'session_id'
    })

    const groupParticipants = [...rawGroupParticipants].sort(sortParticipants)

    const rawGroupPipParticipants = useParticipantIds({
        filter: (p) => {
            const sessionId = p.session_id
            const studentGroup = groupsMap?.current?.[`students_group_${sessionId}`]
            const teacherGroup = groupsMap?.current?.[`teachers_group_${sessionId}`]

            if (selectedGroup) {
                return studentGroup === selectedGroup || teacherGroup === selectedGroup || p.local
            } else {
                return (!studentGroup && !teacherGroup) || p.local
            }
        },
        sort: 'session_id'
    })

    const groupPipParticipants = [...rawGroupPipParticipants].sort(sortParticipants)

    const studentsParticipants = useParticipantIds({
        sort: (a, b) => {
            return a.userData?.name?.localeCompare(b.userData?.name)
        },
        filter: (p) => {
            return !p.userData?.role
        }
    })

    const teachersAdminParticipants = useParticipantIds({
        filter: (p) => {
            return p.userData?.role
        }
    })

    const [ghostAdmins, setGhostAdmins] = useState([])

    const [pipWidth, setPipWidth] = useState(500)
    const [pipHeight, setPipHeight] = useState(500)
    const teachers = useParticipantIds({ filter: (p) => p.userData?.role })

    const [screenSharingRequests, setScreenSharingRequests] = useState({})
    const { data: sessionData } = useMeetingSessionState()
    const meetingState = useMeetingState()
    const { isSharingScreen, startScreenShare, stopScreenShare } = useScreenShare()

    const [microphones, setMicrophones] = useState([])
    const [cameras, setCameras] = useState([])
    const [speakers, setSpeakers] = useState([])
    const [deviceError, setDeviceError] = useState(false)
    const [nonFatalError, setNonFatalError] = useState(null)
    const [deviceNotFoundText, setDeviceNotFoundText] = useState('')
    const { networkState } = useNetwork()
    const { state } = useCPULoad()

    const onRecordingError = async (event) => {
        try {
            // document.dispatchEvent(new CustomEvent('api-error', { detail: { title: "Errore Registrazione Cloud", message: event?.errorMsg ?? '' } }));
            startRecording({
                layout: {
                    preset: "active-participant"
                }
            })
        }
        catch (e) {
            console.error(e)
        }
    }

    const onRecordingStopped = async (event) => {
        try {
            // context.setNotificationBanner({
            //     title: "Registrazione Cloud Terminata",
            //     body: event.errorMsg
            // })
            startRecording({
                layout: {
                    preset: "active-participant"
                }
            })
        } catch (e) {
            console.error(e)
        }
    }

    const { isRecording, startRecording } = useRecording({ onRecordingError: onRecordingError, onRecordingStopped: onRecordingStopped })

    const [accessState, setAccessState] = useState(DailyAccessState.Unknown)
    const [view, setView] = useState('full')
    const [theme, setTheme] = useState('light')
    const [prevTheme, setPrevTheme] = useState('light')
    const [sidebar, _setSidebar] = useState(false)
    const sidebarRef = useRef(sidebar)
    const setSidebar = (data) => {
        sidebarRef.current = data
        _setSidebar(data)
    }

    const [pipSidebar, setPipSidebar] = useState(false)
    const [selectedPipTab, setSelectedPipTab] = useState(0)
    const [selectedTab, _setSelectedTab] = useState(0)
    const selectedTabRef = useRef(selectedTab)
    const setSelectedTab = (data) => {
        selectedTabRef.current = data
        _setSelectedTab(data)
    }

    const [selectedChatTab, _setSelectedChatTab] = useState(0)
    const selectedChatTabRef = useRef(selectedChatTab)
    const setSelectedChatTab = (data) => {
        selectedChatTabRef.current = data
        _setSelectedChatTab(data)
    }

    const [materialBadge, setMaterialBadge] = useState(0)
    const [expanded, setExpanded] = useState(false)
    const [toggleSelfView, setToggleSelfView] = useState(true)

    const audioRef = useRef(null)
    const [audioErrors, _setAudioErrors] = useState([])
    const audioErrorsRef = useRef(audioErrors)
    const setAudioErrors = (data) => {
        audioErrorsRef.current = data;
        _setAudioErrors(data)
    }
    const [muted, setMuted] = useState(false)
    const remoteAudioLevels = useRef({})
    const [speakingMap, setSpeakingMap] = useState({})
    const SPEAK_ON = 0.06 // start highlight above this level
    const SPEAK_OFF = 0.04 // stop highlight below this level (hysteresis)

    const inputRef = useRef(null)
    const [messages, setMessages] = useState([])
    const [groupMessages, setGroupMessages] = useState([])
    const [lobbyMessages, setLobbyMessages] = useState(null)
    const [teachersMessages, setTeachersMessages] = useState(null)
    const [message, setMessage] = useState({ sender: null, sender_type: 'teacher', created_at: null, body: '', type: null })
    const [sendDisabled, setSendDisabled] = useState(true)
    const [sending, setSending] = useState(false)
    const [unread, setUnread] = useState(0)
    const [lobbyUnread, setLobbyUnread] = useState(0)
    const [teachersUnread, setTeachersUnread] = useState(0)
    const [file, setFile] = useState(null)
    const fileRef = useRef(null)
    const [fileAlert, setFileAlert] = useState(false)
    const [localAudioLevel, setLocalAudioLevel] = useState(0)
    const [privacyUser, setPrivacyUser] = useState(null)

    const [screenShareDialog, setScreenShareDialog] = useState(false)
    const [selectedBackgroundEffect, setSelectedBackgroundEffect] = useState('none')
    const [blurStrength, setBlurStrength] = useState(50)
    const [noiseCancellation, setNoiseCancellation] = useState(false)
    const [selectedBackgroundImage, setSelectedBackgroundImage] = useState(null)
    const [openBackgroundsDialog, setOpenBackgroundsDialog] = useState(false)
    const [exitDialog, setExitDialog] = useState(false)
    const [confirmTerminateLessonDialog, setConfirmTerminateLessonDialog] = useState(false)
    const [terminateStatus, setTerminateStatus] = useState(null)
    const [removeParticipant, setRemoveParticipant] = useState(null)
    const [students, setStudents] = useState(null)
    const [notified, setNotified] = useState([])
    const [pipSupportDialog, setPipSupportDialog] = useState(false)
    const [confirmGroupsDeleteDialog, setConfirmGroupsDeleteDialog] = useState(false)

    const [browser, setBrowser] = useState({ name: '', version: '' })
    const [roomLocked, setRoomLocked] = useState(true)
    const [unlockRoom, setUnlockRoom] = useState(false)
    const [lockLoading, setLockLoading] = useState(false)
    const [messageInterval, setMessageInterval] = useState(null)
    const [micWarning, setMicWarning] = useState(false)
    const [deleteGroupsLoading, setDeleteGroupsLoading] = useState(false)
    const [addGroupParticipantQuery, setAddGroupParticipantQuery] = useState('')
    const [confirmGroupReplace, setConfirmGroupReplace] = useState(false)

    const mainRef = useRef(null)
    const mainPipRef = useRef(null)
    const participantsRef = useRef(null)
    const pipParticipantsRef = useRef(null)
    const otherParticipantsRef = useRef(null)
    const fixedParticipantsRef = useRef(null)
    const fixedParticipantsContainerRef = useRef(null)
    const otherParticipantsContainerRef = useRef(null)
    const activeParticipantRef = useRef(null)
    const [isLandscape, setIsLandscape] = useState(width > height)
    const [fullScreenParticipant, setFullScreenParticipant] = useState(null)
    const [fixedOthersOpen, setFixedOthersOpen] = useState(false)

    // Draggable self-view (participantCam) within the active participant tile
    const selfCamRef = useRef(null)
    const selfCamDraggingRef = useRef(false)
    const selfCamDragOffsetRef = useRef({ x: 0, y: 0 })
    const selfCamDownPosRef = useRef({ x: 0, y: 0 })
    const selfCamClickPreventRef = useRef(false)
    const selfCamPosRef = useRef({ x: null, y: null })
    const prevSelfCamPosRef = useRef({ x: null, y: null })
    const [selfCamExpanded, setSelfCamExpanded] = useState(false)

    const [maxVisible, setMaxVisible] = useState(48)
    const [maxPipVisible, setMaxPipVisible] = useState(48)

    const [networkQualityMap, setNetworkQualityMap] = useState({})

    const reactions = ['❤️', '😂', '👍', '👏', '🤔', '🔥', '😱', '🎉', '😔']
    const [reactionsOpen, setReactionsOpen] = useState(false)
    const [floatingReactions, setFloatingReactions] = useState([])

    const [pdf, setPdf] = useState(null)
    const [pdfAlert, setPdfAlert] = useState(false)

    const [whiteboard, setWhiteboard] = useState(false)
    const [whiteboardAlert, setWhiteboardAlert] = useState(false)
    const [screenShareAlert, setScreenShareAlert] = useState(false)
    // Riferimenti al MediaStream della lavagna e al timer di keep-alive
    const whiteboardStreamRef = useRef(null)
    const whiteboardKeepAliveRef = useRef(null)

    const [sharingOpen, setSharingOpen] = useState(false)
    const sharingRef = useRef(null)

    const groupsMap = useRef({})

    useClickOutside(sharingRef, () => {
        setSharingOpen(false)
    })

    const tooltipStyle = {
        backgroundColor: 'var(--background-secondary)',
        color: 'var(--text)',
        boxShadow: '0 0 0px 1px rgba(var(--text-rgb), 0.12)',
        display: isMobile ? 'none' : 'block'
    }

    const backgroundEffects = [
        {
            id: 0,
            name: 'Nessuno',
            value: 'none',
        },
        {
            id: 1,
            name: 'Sfocatura',
            value: 'blur',
        },
        {
            id: 2,
            name: 'Immagine',
            value: 'image',
        }
    ]

    const backgroundImages = [
        {
            name: 'Office',
            url: 'https://starting-finance-dev.fra1.cdn.digitaloceanspaces.com/backgrounds/office_sfbs.jpg'
        },
        {
            name: 'Reception',
            url: 'https://starting-finance-dev.fra1.cdn.digitaloceanspaces.com/backgrounds/reception_sfbs.jpg'
        },
        {
            name: 'White Wall',
            url: 'https://starting-finance-dev.fra1.cdn.digitaloceanspaces.com/backgrounds/white_wall_sfbs.jpg'
        }
    ]

    let lobbyCursor = null

    const [groupsDialog, setGroupsDialog] = useState(false)
    const groupDivisionOptions = [
        {
            id: 0,
            name: 'Casuale',
            value: 'random',
        },
        {
            id: 1,
            name: 'Alfabeticamente per nome',
            value: 'alphabetical_name',
        },
        {
            id: 2,
            name: 'Alfabeticamente per cognome',
            value: 'alphabetical_surname',
        }
    ]
    const [selectedGroup, setSelectedGroup] = useState(null)

    const [groupOptions, setGroupOptions] = useState({
        nGroups: null,
        autoDivision: false,
        autoDivisionType: 'random',
        allowGroupChange: false,
    })

    const [editGroupOptions, setEditGroupOptions] = useState({
        nGroups: null,
        autoDivision: false,
        autoDivisionType: 'random',
        allowGroupChange: false,
    })

    const [groups, setGroups] = useState([])

    const [editGroups, setEditGroups] = useState([])

    useDailyEvent('camera-error', (event) => {
        setDeviceError(event.error)
    });

    useDailyEvent('nonfatal-error', (event) => {
        processNonFatalError(event)
    });

    useDailyEvent('participant-left', (event) => {
        call.setMeetingSessionData({
            [`students_group_${event.participant.session_id}`]: null,
            [`teachers_group_${event.participant.session_id}`]: null
        }, 'shallow-merge')
        groupsMap.current = {
            ...groupsMap.current,
            [`students_group_${event.participant.session_id}`]: null,
            [`teachers_group_${event.participant.session_id}`]: null
        }
    })

    const startPiP = useCallback(() => {
        requestPipWindow(500, 500);
    }, [requestPipWindow]);


    useEffect(() => {
        context.setSidenav({ open: false, visible: false })

        let lessonTheme = localStorage.getItem('lesson-theme')
        if (lessonTheme) {
            setTheme(lessonTheme)
        }



        getLessonMessages(lesson.id)

        return () => {
            let app = document.getElementById('app-content')
            document.body.style.overflow = 'auto'
            if (app) {
                app.classList.remove('no-transitions')
            }

            if (messageInterval) {
                clearInterval(messageInterval);
            }
        }

    }, [startPiP, closePipWindow])

    useEffect(() => {
        if (sidebar) {
            if (selectedTab === 1 && selectedChatTab === 0) {
                setUnread(0)
            }
            if (selectedTab === 1 && selectedChatTab === 1) {
                setLobbyUnread(0)
            }
            if (selectedTab === 1 && selectedChatTab === 2) {
                setTeachersUnread(0)
            }
        }
    }, [sidebar])

    useEffect(() => {
        if (message) {
            if (message.body.trim().length === 0 && !file) {
                setSendDisabled(true)
            }
            else {
                setSendDisabled(false)
            }
        }
    }, [message, file])

    useEffect(() => {
        if (theme) {
            localStorage.setItem('lesson-theme', theme)
            if (theme === 'dark') {
                document.body.style.backgroundColor = '#262626'
                document.documentElement.style = '#262626'
            }
            else {
                document.body.style.backgroundColor = '#fcfcfc'
                document.documentElement.style = '#fcfcfc'
            }
        }
    }, [theme])

    useEffect(() => {
        if (localSessionId) {
            let accessState = call.accessState()
            setAccessState(accessState.access.level)
            call.setUserName(`${context.user.name} ${context.user.surname}`)

            const colorIndex = Math.floor(Math.random() * palette.length)
            let color = palette[colorIndex]
            let darkColor = darkPalette[colorIndex]
            call.setUserData({ ...context.user, color, darkColor })
            call.setLocalAudio(false)
            call.setLocalVideo(false)
        }
    }, [localSessionId])

    useEffect(() => {
        if (lesson) {
            const getStudents = async (moduleId) => {
                try {
                    let students = await api.get(`/teacher/modules/${moduleId}/students`)
                    setStudents(students)
                }
                catch (e) {
                    console.error(e)
                }
            }
            if (!students) {
                getStudents(lesson.module.id)
            }
            getRoomLocked(lesson.room_name)
        }
        if (lesson && lesson.materials) {
            setMaterialBadge(lesson.materials.length)
        }
        if (lesson && localSessionId) {
            addUserParticipantId()
        }
    }, [lesson, localSessionId])

    useEffect(() => {
        if (['joined-meeting'].includes(meetingState)) {
            const data = call.meetingSessionState().data
            setPinnedIds(data.pinned ?? [])
            setHandRaisedIds(data.handRaised ?? [])

            if (lesson?.options?.groups) {
                setGroups(lesson.options.groups)
                setEditGroups(lesson.options.groups)
                setGroupOptions(lesson.options.groupOptions)
                setEditGroupOptions(lesson.options.groupOptions)
                call.setMeetingSessionData({
                    groups: lesson.options.groups,
                    groupOptions: lesson.options.groupOptions
                }, 'shallow-merge')
            }
            else {
                setGroups(data.groups ?? groups)
                setEditGroups(data.groups ?? groups)
                setGroupOptions(data.groupOptions ?? groupOptions)
                setEditGroupOptions(data.groupOptions ?? groupOptions)
            }

            let meeting = call.meetingSessionSummary()
            setMeetingId(meeting.id)

            // for (const i of Array(47).fill(null)) {
            //     call.addFakeParticipant()
            // }
        }
    }, [meetingState])

    useEffect(() => {
        const getSession = async (session_id) => {
            try {
                let s = await api.get('/meetings/' + session_id, { showError: false })
                setMeetingStartTime(s.start_time)
            }
            catch (e) {
                console.error(e)
            }
        }

        if (meetingId) {
            getSession(meetingId)
        }
    }, [meetingId])

    useEffect(() => {
        if (meetingStartTime) {
            const interval = setInterval(() => {
                setMeetingSeconds(parseInt((new Date().getTime()) / 1000 - meetingStartTime))
            }, 1000);

            setMeetingInterval(interval)
        }

        return () => {
            setMeetingInterval(null)
            clearInterval(meetingInterval);
        }
    }, [meetingStartTime])

    useEffect(() => {
        if (activeSpeakerId) {
            setActiveSpeakersOrder((prevOrder) => {
                const filteredOrder = prevOrder.filter(id => id !== activeSpeakerId);
                return [activeSpeakerId, ...filteredOrder];
            });
        }
    }, [activeSpeakerId])

    // DEVICES
    useEffect(() => {
        setMicrophones(devices.microphones.map((microphone) => {
            return {
                id: microphone.device.deviceId,
                name: microphone.device.label,
                value: microphone.device.deviceId,
                selected: microphone.selected
            }
        }))
    }, [devices.microphones])

    useEffect(() => {
        setCameras(devices.cameras.map((camera) => {
            return {
                id: camera.device.deviceId,
                name: camera.device.label,
                value: camera.device.deviceId,
                selected: camera.selected
            }
        }))
    }, [devices.cameras])

    useEffect(() => {
        setSpeakers(devices.speakers.map((speaker) => {
            return {
                id: speaker.device.deviceId,
                name: speaker.device.label,
                value: speaker.device.deviceId,
                selected: speaker.selected
            }
        }))
    }, [devices.cameras])

    useEffect(() => {
        // if (audioRef && audioRef.current.getAllAudio()) {
        //     for (const audio of audioRef.current.getAllAudio()) {
        //         audio.muted = muted
        //     }
        // }
        const audioElements = document.querySelectorAll('audio[data-session-id]');
        for (let audio of audioElements) {
            if (audio.getAttribute('data-session-id') !== localSessionId) {
                audio.muted = muted
            }
        }
    }, [muted])

    useEffect(() => {
        const filteredSharingRequests = Object.fromEntries(
            Object.entries(sessionData?.screenSharingRequests ?? {}).filter(([key, value]) => participants.includes(key) && value === 'pending')
        );
        if (Object.keys(filteredSharingRequests).length > Object.keys(screenSharingRequests).length) {
            context.setNotificationBanner({
                title: "🖥️ Richiesta di condivisione schermo",
                body: "Hai una nuova richiesta di condivisione schermo",
                onClick: () => {
                    setSidebar(true)
                    setSelectedTab(0)
                }
            })
        }
        setScreenSharingRequests(filteredSharingRequests);
        setPinnedIds(sessionData?.pinned ?? [])
        setGroups(sessionData?.groups ?? [])
        setGroupOptions(sessionData?.groupOptions ?? groupOptions)

        if (!editGroups.find(g => g.adding) && !groupsDialog) {
            setEditGroups(sessionData?.groups ?? [])
            setEditGroupOptions(sessionData?.groupOptions ?? editGroupOptions)
        }

        if (!sessionData?.groups) {
            setSelectedGroup(null)
        }

        let online = call.participants()
        setHandRaisedIds(sessionData?.handRaised?.filter((h) => {
            return online[h] !== undefined
        }) ?? [])

        if (sessionData) {
            for (const entry of Object.entries(sessionData)) {
                if ((entry[0].includes('students_group_') || entry[0].includes('teachers_group_')) && !Object.keys(groupsMap.current).includes(entry[0])) {
                    groupsMap.current[entry[0]] = entry[1]
                }
            }
        }

    }, [sessionData])

    useEffect(() => {
        const filteredSharingRequests = Object.fromEntries(
            Object.entries(sessionData?.screenSharingRequests ?? {}).filter(([key, value]) => participants.includes(key) && value === 'pending')
        );

        if (Object.keys(filteredSharingRequests).length > Object.keys(screenSharingRequests).length) {
            context.setNotificationBanner({
                title: "Richiesta di condivisione schermo",
                body: "Hai una nuova richiesta di condivisione schermo",
                onClick: () => {
                    setSidebar(true)
                    setSelectedTab(0)
                }
            })
        }

        setScreenSharingRequests(filteredSharingRequests);

        for (const p of participants) {
            if (isSharing(p)) {
                setView('full')
            }
            if (hasCam(p) || hasMic(p)) {
                setCamMicActiveOrder((prevOrder) => {
                    const filteredOrder = prevOrder.filter(id => id !== p);
                    return [p, ...filteredOrder];
                });
            }
        }

        const audioElements = document.querySelectorAll('audio[data-session-id]');
        for (let audio of audioElements) {
            if (audio.getAttribute('data-session-id') !== localSessionId) {
                audio.muted = muted
            }
        }
    }, [rawParticipants])

    useEffect(() => {
        if (deviceError && deviceError.type === 'not-found') {
            let msg = ''
            if (deviceError.missingMedia.includes('video')) {
                msg += 'Videocamera non trovata, gli altri utenti potrebbero non vederti. '
            }
            if (deviceError.missingMedia.includes('audio')) {
                msg += 'Microfono non trovato, gli altri utenti potrebbero non sentirti. '
            }
            setDeviceNotFoundText(msg)
        }
    }, [deviceError])

    useEffect(() => {
        if (!isSupported) {
            setPipSupportDialog(true)
        }
    }, [isSupported])

    useEffect(() => {
        if (waitingParticipants) {
            if (waitingParticipants.length === 0) {
                setSelectedChatTab(0)
                clearInterval(messageInterval)
                setMessageInterval(null)
            }
            else {
                const eventSource = new EventSource(`${process.env.REACT_APP_API_URL}teacher/lessons/${lesson.id}/messages_events`);

                eventSource.onmessage = (event) => {
                    try {
                        let data = JSON.parse(event.data);
                        if (data && data.message && data.message.env === 'lobby') {
                            data.message.type = 'received'
                            if (data.message.sender.id === context.user.id && data.message.sender_type === 'teacher') {
                                // Do nothing
                            }
                            else {
                                setLobbyMessages(prev => [data.message, ...prev])
                            }
                            if (selectedTabRef.current === 1 && selectedChatTabRef.current === 1 && sidebarRef.current) {
                                setLobbyUnread(0)
                            }
                            else {
                                setLobbyUnread(prev => prev + 1)
                            }
                        }
                    }
                    catch (e) {
                        console.error(e)
                    }
                };

                return () => {
                    eventSource.close();
                };

                // const messageInterval = setInterval(() => {
                //     getLessonMessages(lesson.id)
                // }, 1000);

                // setMessageInterval(messageInterval)
            }
        }
    }, [waitingParticipants])

    useEffect(() => {
        if (hasMic(localSessionId) && localAudioLevel === 0) {
            setMicWarning(true)
        }
        else {
            setMicWarning(false)
        }
    }, [localAudioLevel, localSessionId, localParticipant])

    useEffect(() => {
        if (['joined-meeting'].includes(meetingState)) {
            if (selectedGroup !== null) {
                call.setMeetingSessionData({
                    [`teachers_group_${localSessionId}`]: selectedGroup
                }, 'shallow-merge')
                sendAppMessage({ type: 'group-change', profile_type: 'teachers', group: selectedGroup }, '*')
                setGroupMessages(messages.filter(m => m.group === selectedGroup))
            }
            else {
                call.setMeetingSessionData({
                    [`teachers_group_${localSessionId}`]: null
                }, 'shallow-merge')
                sendAppMessage({ type: 'group-change', profile_type: 'teachers', group: null }, '*')
            }
        }
    }, [selectedGroup])

    const generateGroups = () => {
        if (editGroupOptions.autoDivision && editGroupOptions.nGroups && students && groupsDialog) {

            let participantsGroups = []
            switch (editGroupOptions.autoDivisionType) {
                case 'random':
                    participantsGroups = randomGroup(editGroupOptions.nGroups)
                    break;
                case 'alphabetical_name':
                    participantsGroups = alphabeticalNameGroup(editGroupOptions.nGroups)
                    break;
                case 'alphabetical_surname':
                    participantsGroups = alphabeticalSurnameGroup(editGroupOptions.nGroups)
                    break;
                default:
                    break;
            }

            setEditGroups(Array.from({ length: editGroupOptions.nGroups }, (_, i) => {
                return {
                    id: uuidv4(),
                    name: `Gruppo ${i + 1}`,
                    participants: participantsGroups[i] ?? [],
                    selected: i === 0,
                    adding: false,
                    toAdd: []
                }
            }))
        }
    }

    const randomGroup = (nGroups) => {
        let shuffledStudents = studentsParticipants.sort(() => Math.random() - 0.5);
        let groups = Array.from({ length: nGroups }, () => []);
        shuffledStudents.forEach((student, index) => {
            let user = getUser(student)
            groups[index % nGroups].push(user.id);
        });
        return groups
    }

    const alphabeticalNameGroup = (nGroups) => {
        let users = studentsParticipants.map(s => getUser(s));
        let sortedStudents = users.sort((a, b) => a.name.localeCompare(b.name));
        let groups = Array.from({ length: nGroups }, () => []);
        let participantsPerGroup = Math.floor(users.length / nGroups);
        let remainingParticipants = users.length % nGroups;

        let start = 0;
        for (let i = 0; i < nGroups; i++) {
            let groupSize = participantsPerGroup + (i < remainingParticipants ? 1 : 0);
            let groupSlice = sortedStudents.slice(start, start + groupSize).map(s => s.id);
            groups[i] = groupSlice;
            start += groupSize;
        }
        return groups;
    }

    const alphabeticalSurnameGroup = (nGroups) => {
        let users = studentsParticipants.map(s => getUser(s));
        let sortedStudents = users.sort((a, b) => a.surname.localeCompare(b.surname));
        let groups = Array.from({ length: nGroups }, () => []);
        let participantsPerGroup = Math.floor(users.length / nGroups);
        let remainingParticipants = users.length % nGroups;

        let start = 0;
        for (let i = 0; i < nGroups; i++) {
            let groupSize = participantsPerGroup + (i < remainingParticipants ? 1 : 0);
            let groupSlice = sortedStudents.slice(start, start + groupSize).map(s => s.id);
            groups[i] = groupSlice;
            start += groupSize;
        }
        return groups;
    }

    const getLessonMessages = async (lesson_id) => {
        try {
            let lesson_messages = await api.get(`/teacher/lessons/${lesson_id}/messages`)

            let messagesData = lesson_messages.sort((a, b) => {
                return new Date(b.created_at) - new Date(a.created_at)
            }).filter(lm => !['lobby', 'teachers'].includes(lm.message.env)).map(lm => {
                lm.message.type = lm.message.sender.id === context.user.id && lm.sender_type === 'teacher' ? 'sent' : 'received'
                return lm.message
            })
            setMessages(messagesData)

            let lobbyMessagesData = lesson_messages.sort((a, b) => {
                return new Date(b.created_at) - new Date(a.created_at)
            }).filter(lm => lm.message.env === 'lobby').map(lm => {
                lm.message.type = lm.message.sender.id === context.user.id && lm.sender_type === 'teacher' ? 'sent' : 'received'
                return lm.message
            })

            setLobbyMessages(lobbyMessagesData)

            if (lobbyCursor) {
                if (lobbyMessagesData.length > lobbyCursor) {
                    if (sidebarRef.current && selectedChatTabRef.current === 1) {
                        setLobbyUnread(0)
                    }
                    else {
                        setLobbyUnread((prev) => {
                            return prev + 1;
                        })
                    }
                }
            }

            lobbyCursor = lobbyMessagesData.length

            let teachersMessagesData = lesson_messages.sort((a, b) => {
                return new Date(b.created_at) - new Date(a.created_at)
            }).filter(lm => lm.message.env === 'teachers').map(lm => {
                lm.message.type = lm.message.sender.id === context.user.id && lm.sender_type === 'teacher' ? 'sent' : 'received'
                return lm.message
            })

            setTeachersMessages(teachersMessagesData)

        }
        catch (e) {
            console.error(e)
        }
    }

    const onAppMessage = (ev) => {

        if (!['sent', 'network', 'reaction', 'group-change'].includes(ev.data.type)) return;

        if (ev.data.type === 'ghost') {
            if (!ghostAdmins.find(g => g === ev.fromId)) {
                setGhostAdmins(prev => [...prev, ev.fromId])
            }
            return
        }


        if (ev.data?.body?.trim() === '' && !ev.data.media && !Object.keys(ev.data).includes('group')) {
            return
        }
        
        if (ev.data.type === 'network') {
            setNetworkQualityMap((prev) => ({
                ...prev,
                [ev.fromId]: ev.data.body
            }))
            return
        }

        if (ev.data.type === 'reaction') {
            setFloatingReactions((prev) => [...prev, { id: uuidv4(), left: Math.floor(Math.random() * (30 - 10 + 1)) + 10, sessionId: ev.fromId, user: getUser(ev.fromId), reaction: ev.data.body, timestamp: Date.now(), group: ev.data.group }])
            return
        }
        if (ev.data.type === 'group-change') {
            groupsMap.current[`${ev.data.profile_type}_group_${ev.fromId}`] = ev.data.group
            return;
        }

        const newMessage = {
            ...ev.data,
            type: 'received'
        }

        if (ev.data.env === 'teachers') {
            setTeachersMessages((prev) => [newMessage, ...prev])
        }
        else if (ev.data.env === 'lobby') {
            setLobbyMessages((prev) => [newMessage, ...prev])
        }
        else if (ev.data.group && ev.data.group === selectedGroup) {
            setGroupMessages((prev) => [newMessage, ...prev])
        }
        else {
            setMessages((prev) => [newMessage, ...prev])
        }

        if (!['lobby', 'teachers'].includes(ev.data.env) && (!ev.data.group || ev.data.group === selectedGroup)) {
            setUnread((prev) => prev + 1)
        }
        else if (ev.data.env === 'lobby') {
            setLobbyUnread((prev) => prev + 1)
        }
        else if (ev.data.env === 'teachers') {
            setTeachersUnread((prev) => prev + 1)
        }

        if (sidebar && selectedTab === 1 && selectedChatTabRef.current === 0) {
            setUnread(0)
        }
        else if (sidebar && selectedTab === 1 && selectedChatTabRef.current === 1) {
            setLobbyUnread(0)
        }
        else if (sidebar && selectedTab === 1 && selectedChatTabRef.current === 2) {
            setTeachersUnread(0)
        }

    }

    const sendAppMessage = useAppMessage({
        onAppMessage: onAppMessage
    });

    const handleMessageChange = async (event) => {
        if (message.length > event.target.value.length) {
            setMessage((prev) => {
                prev.sender_type = 'teacher'
                prev.sender = context.user
                prev.created_at = getLocaleISOString()
                prev.body = event.target.value
                return { ...prev }
            })
            if ((event.target.value.length > 0 && event.target.value.trim().length > 0) || file) {
                setSendDisabled(false)
            }
            return
        }
        setMessage((prev) => {
            prev.sender_type = 'teacher'
            prev.sender = context.user
            prev.created_at = getLocaleISOString()
            prev.body = event.target.value

            return { ...prev }
        })
        if ((event.target.value.length > 0 && event.target.value.trim().length > 0) || file) {
            setSendDisabled(false)
        }
    }

    const handleMessageKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault()
            if (!sendDisabled) {
                sendMessage()
            }
            inputRef.current.focus()
        }
    };

    const sendMessage = async () => {
        if (sendDisabled) return;

        setSending(true)
        setSendDisabled(true)
        let mediaUrl = null

        if (file) {
            let uploaded = await uploadMessageFile(file, uuidv4())
            if (uploaded && uploaded.url) {
                mediaUrl = uploaded.url
            }
        }

        let msgObj = {
            sender: message.sender ?? context.user,
            sender_type: message.sender_type ?? 'teacher',
            created_at: message.created_at ?? getLocaleISOString(),
            body: message.body,
            media: mediaUrl && file ? { url: mediaUrl, name: file.name, size: file.size } : null,
            type: 'sent',
            group: selectedGroup,
        }

        if (selectedChatTab === 1) {
            msgObj.env = 'lobby'
        }

        if (selectedChatTab === 2) {
            msgObj.env = 'teachers'
        }

        if (msgObj.env !== 'teachers') {
            sendAppMessage(msgObj, '*')
        }
        else {
            sendAppMessage(msgObj, [...teachersAdminParticipants, ...ghostAdmins])
        }

        if (msgObj.env === 'lobby') {
            setLobbyMessages((prev) => [msgObj, ...prev])
        }
        else if (msgObj.env === 'teachers') {
            setTeachersMessages((prev) => [msgObj, ...prev])
        }
        else {
            setMessages((prev) => [msgObj, ...prev])
            if (selectedGroup) {
                setGroupMessages((prev) => [msgObj, ...prev])
            }
        }

        setMessage({ sender: null, created_at: null, body: '' })

        inputRef.current.focus()
        setSendDisabled(false)
        setSending(false)
        setFile(null)
        await saveBackendMessage(lesson.id, msgObj)

    }

    const saveBackendMessage = async (lesson_id, message) => {
        try {
            await api.post(`/lessons/${lesson_id}/messages`, { message })
        }
        catch (e) {
            console.error(e)
            setSendDisabled(false)
            setSending(false)
        }
    }

    const uploadMessageFile = async (file, upload_id) => {
        const formData = new FormData();
        formData.append("upload_id", upload_id)
        formData.append("file", file, file.name);


        return await api.post("/teacher/messages/upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
    }

    const handleFileChange = (event) => {
        let file = event.target.files[0]
        if (file.size > 16 * 1024 * 1024) { // 16 MB
            setFileAlert(true)
            event.target.value = null
            return;
        }

        setFile(file)
        setMessage((prev) => {
            prev.sender_type = 'teacher'
            prev.sender = context.user
            prev.created_at = getLocaleISOString()
            prev.body = event.target.value
            return { ...prev }
        })
        event.target.value = null
    }


    // useEffect(() => {
    //     if(teachersAdminParticipants.length > 0 && ghostAdmins.length > 0) {
    //         let newGhostAdmins = ghostAdmins.filter(ga => !teachersAdminParticipants.includes(ga))
    //         setGhostAdmins(newGhostAdmins)
    //     }
    // }, [teachersAdminParticipants, ghostAdmins]);

    const onPlayFailed = useCallback((event) => {
        console.error(event)
        setAudioErrors([...audioErrorsRef.current, event.target])
    }, [])

    const onPlayRetry = () => {
        for (let audioElm of audioErrors) {
            try {
                audioElm.play()
                setAudioErrors(audioErrors.filter(a => a !== audioElm))
            }
            catch (e) {
                console.error(e)
            }
        }
    }

    const addUserParticipantId = async () => {
        try {
            await api.put(`/teacher/lessons/${lesson.id}/participant`, { participant_id: localSessionId })
        }
        catch (e) {
            console.error(e)
        }
    }

    const isOnline = (user_id) => {
        for (const p of participants) {
            let user = getUser(p)
            if (user && user.id === user_id) {
                return true
            }
        }
        return false
    }

    const hasMic = (session_id) => {
        const participant = findParticipantBySessionId(session_id)
        return participant?.tracks.audio.state === 'playable'
    }

    const hasCam = (session_id) => {
        const participant = findParticipantBySessionId(session_id)
        return participant?.tracks.video.state === 'playable'
    }

    const isMuted = (session_id) => {
        let audio = document.querySelector(`audio[data-session-id="${session_id}"]`)
        return audio?.muted ?? false
        // if (audioRef && audioRef.current) {
        //     return audioRef.current.getAudioBySessionId(session_id)?.muted ?? false
        // }
    }

    const hasHandRaised = (session_id) => {
        let user = getUser(session_id)
        return handRaisedIds.includes(session_id) || user?.handRaised
    }

    const getUser = (session_id) => {
        const participant = findParticipantBySessionId(session_id)
        const isTeacher = participant?.userData?.role === 'teacher'
        const isTutor = participant?.userData?.role === 'tutor'
        const isAdmin = participant?.userData?.role && !['teacher', 'tutor'].includes(participant?.userData?.role)
        return { ...participant?.userData, isTeacher, isTutor, isAdmin }
    }

    const handleRaiseHand = (session_id) => {
        let handRaised = call.meetingSessionState().data.handRaised ?? []
        if (handRaised.includes(session_id)) {
            handRaised = [...new Set(handRaised.filter((id) => id !== session_id))];
            call.setMeetingSessionData({ handRaised: handRaised }, 'shallow-merge')
        }
        else {
            call.setMeetingSessionData({ handRaised: [...handRaised, session_id] }, 'shallow-merge')
        }
    }

    const togglePinned = (session_id) => {
        let pinned = call.meetingSessionState().data.pinned ?? []
        if (pinned.includes(session_id)) {
            pinned = [...new Set(pinned.filter((id) => id !== session_id))];
            call.setMeetingSessionData({ pinned: pinned }, 'shallow-merge')
        }
        else {
            call.setMeetingSessionData({ pinned: [...pinned, session_id] }, 'shallow-merge')
        }
    }

    const shouldHighlightWhenSpeaks = (session_id) => {
        if (view === 'full') {
            if (session_id === participants[0]) {
                if (!hasCam(session_id) && !isSharing(session_id)) {
                    return true
                }
                return false
            }
            return true
        }
        if (view === 'grid') {
            return true
        }
        return true
    }

    const acceptBackendParticipant = async (participant_id) => {
        try {
            await api.post(`/teacher/lessons/${lesson.id}/participants/${participant_id}/accept`)
        }
        catch (e) {
            console.error(e)
        }
    }

    const acceptScreenSharingRequest = async (session_id) => {
        let screenSharingRequests = call.meetingSessionState().data.screenSharingRequests ?? {}
        if (screenSharingRequests[session_id]) {
            screenSharingRequests[session_id] = 'accepted'
            call.setMeetingSessionData({ screenSharingRequests: screenSharingRequests }, 'shallow-merge')
        }
    }

    const denyScreenSharingRequest = async (session_id) => {
        let screenSharingRequests = call.meetingSessionState().data.screenSharingRequests ?? {}
        if (screenSharingRequests[session_id]) {
            delete screenSharingRequests[session_id]
            call.setMeetingSessionData({ screenSharingRequests: screenSharingRequests }, 'shallow-merge')
        }
    }

    const notifyAbsents = async (absents) => {
        try {
            await api.post(`/teacher/rooms/${lesson.room_name}/notify-absents`, { absents: absents })
            setNotified([...notified, ...absents])
        }
        catch (e) {
            console.error(e)
        }
    }

    const getRoomLocked = async (roomName) => {
        try {
            let roomInfo = await api.get(`/teacher/rooms/${roomName}`)
            setRoomLocked(roomInfo.privacy === 'private')
        }
        catch (e) {
            console.error(e)
        }
    }

    const lockRoom = async (locked) => {
        setLockLoading(true)
        try {
            const body = { locked: locked }
            await api.put(`/teacher/rooms/${lesson.room_name}/lock`, body)
            getRoomLocked(lesson.room_name)
        }
        catch (e) {
            console.error(e)
        }
        setLockLoading(false)
    }

    const processNonFatalError = (event) => {
        let error = {
            title: 'Errore',
            message: event.errorMsg,
        }
        if (event.type === 'screen-share-error') {
            if (event.details?.blockedBy === 'browser') {
                stopCapture()
                stopScreenShare()
                return;
            }
            error.title = 'Errore condivisione schermo'
            error.message = (event.details?.category === 'permissions') ? 'Non hai concesso i permessi per la condivisione dello schermo' : 'Si è verificato un errore durante la condivisione dello schermo'
        }
        setNonFatalError(error)
    }

    const onGroupDelete = async (id) => {
        let newGroups = editGroups.filter((g) => g.id !== id)
        setEditGroups(newGroups.map((g, i) => {
            g.name = `Gruppo ${i + 1}`
            return g
        }))
    }

    const terminateLesson = async () => {
        try {
            await api.get(`/teacher/lessons/${lesson.id}/terminate`)
        }
        catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        setTimeout(() => {
            if (participantsRef.current) {
                participantsRef.current()
            }
            if (otherParticipantsRef.current) {
                otherParticipantsRef.current()
            }
        }, 300);
    }, [sidebar, isLandscape, selectedGroup])

    // Ensure PiP PackedGrid recalculates on PiP window resize/toggles
    useEffect(() => {
        if (pipParticipantsRef.current) {
            pipParticipantsRef.current()
        }
    }, [pipWidth, pipHeight, pipSidebar, selectedPipTab, selectedGroup])

    const visibleParticipants = useMemo(
        () => (sessionData?.groups ? groupParticipants : participants).slice(0, maxVisible),
        [sessionData?.groups, groupParticipants, participants, maxVisible]
    );

    const pipVisibleParticipants = useMemo(
        () => (sessionData?.groups ? groupPipParticipants : pipParticipants).slice(0, maxPipVisible),
        [sessionData?.groups, groupPipParticipants, pipParticipants, maxPipVisible]
    );

    useEffect(() => {
        if (height > width) {
            setIsLandscape(false)
        }
        else {
            setIsLandscape(true)
        }
    }, [width, height])

    // useEffect(() => {
    //     if (fullScreenParticipant || whiteboard) {
    //         setPrevTheme(theme)
    //         setTheme('dark')
    //     }
    //     else {
    //         setTheme(prevTheme || 'light')
    //     }
    // }, [fullScreenParticipant, whiteboard])

    useEffect(() => {
        if (fullScreenParticipant) {
            if (!isSharing(fullScreenParticipant) && !hasCam(fullScreenParticipant) && !whiteboard && !pdf) {
                setFullScreenParticipant(null)
            }
        }
    }, [fullScreenParticipant, participants, isSharing, hasCam, whiteboard, pdf])

    useEffect(() => {
        let msgObj = {
            type: 'network',
            body: networkState
        }

        if (['joined-meeting'].includes(meetingState)) {
            sendAppMessage(msgObj, '*')
        }
    }, [networkState])

    /* ---- SELF VIEW ---------------------------------------------------*/

    const applySelfCamStyle = useCallback((x, y) => {
        const el = selfCamRef.current
        if (!el) return
        el.style.right = 'auto'
        el.style.bottom = 'auto'
        el.style.left = `${x}px`
        el.style.top = `${y}px`
    }, [])

    const clampAndApplySelfCamPos = useCallback(() => {
        if (selfCamExpanded) return
        const el = selfCamRef.current
        const container = el?.offsetParent
        if (!el || !container) return
        if (selfCamPosRef.current.x == null || selfCamPosRef.current.y == null) return
        const camW = el.offsetWidth
        const camH = el.offsetHeight
        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize || '16')
        const pad = 0.5 * rem
        // Compute bounds relative to the container's padding edge so 0.5rem padding
        // is respected on bottom and right as well
        const cs = getComputedStyle(container)
        const paddingLeft = parseFloat(cs.paddingLeft) || 0
        const paddingTop = parseFloat(cs.paddingTop) || 0
        const clientW = container.clientWidth
        const clientH = container.clientHeight
        const maxX = Math.max(pad, (clientW - paddingLeft) - camW - pad)
        const maxY = Math.max(pad, (clientH - paddingTop) - camH - pad)
        const x = Math.min(Math.max(selfCamPosRef.current.x, pad), maxX)
        const y = Math.min(Math.max(selfCamPosRef.current.y, pad), maxY)
        selfCamPosRef.current = { x, y }
        applySelfCamStyle(x, y)
    }, [applySelfCamStyle, selfCamExpanded])

    useEffect(() => {
        // Re-clamp on viewport/layout changes
        clampAndApplySelfCamPos()
    }, [width, height, view, expanded, clampAndApplySelfCamPos])

    const onSelfCamPointerDown = useCallback((e) => {
        if (expanded) return
        if (selfCamExpanded) return
        const el = selfCamRef.current
        const container = el?.offsetParent
        if (!el || !container) return
        if (e.cancelable) e.preventDefault()
        try { el.setPointerCapture(e.pointerId) } catch (_) { /* noop */ }
        // Current position relative to offset parent
        const camRect = el.getBoundingClientRect()
        const currentX = el.offsetLeft
        const currentY = el.offsetTop
        selfCamPosRef.current = {
            x: isNaN(currentX) ? 0 : currentX,
            y: isNaN(currentY) ? 0 : currentY
        }
        // Initialize styles to absolute left/top positioning for smooth drag
        el.style.transition = 'none'
        applySelfCamStyle(selfCamPosRef.current.x, selfCamPosRef.current.y)

        selfCamDragOffsetRef.current = { x: e.clientX - camRect.left, y: e.clientY - camRect.top }
        selfCamDownPosRef.current = { x: e.clientX, y: e.clientY }
        selfCamClickPreventRef.current = false
        selfCamDraggingRef.current = true
    }, [expanded, selfCamExpanded, applySelfCamStyle])

    const onSelfCamPointerMove = useCallback((e) => {
        if (!selfCamDraggingRef.current || expanded) return
        if (selfCamExpanded) return
        const el = selfCamRef.current
        const container = el?.offsetParent
        if (!el || !container) return
        if (e.cancelable) e.preventDefault()

        const containerRect = container.getBoundingClientRect()
        const camW = el.offsetWidth
        const camH = el.offsetHeight
        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize || '16')
        const pad = 0.5 * rem
        const cs = getComputedStyle(container)
        const paddingLeft = parseFloat(cs.paddingLeft) || 0
        const paddingTop = parseFloat(cs.paddingTop) || 0
        const clientW = container.clientWidth
        const clientH = container.clientHeight
        // Translate pointer to container's padding-box coordinates
        let newX = e.clientX - containerRect.left - paddingLeft - selfCamDragOffsetRef.current.x
        let newY = e.clientY - containerRect.top - paddingTop - selfCamDragOffsetRef.current.y
        const maxX = Math.max(pad, (clientW - paddingLeft) - camW - pad)
        const maxY = Math.max(pad, (clientH - paddingTop) - camH - pad)
        newX = Math.min(Math.max(newX, pad), maxX)
        newY = Math.min(Math.max(newY, pad), maxY)
        selfCamPosRef.current = { x: newX, y: newY }
        applySelfCamStyle(newX, newY)

        // If moved more than a small threshold, prevent the click toggle
        const dx = Math.abs(e.clientX - selfCamDownPosRef.current.x)
        const dy = Math.abs(e.clientY - selfCamDownPosRef.current.y)
        if (dx > 5 || dy > 5) {
            selfCamClickPreventRef.current = true
        }
    }, [expanded, selfCamExpanded, applySelfCamStyle])

    const onSelfCamPointerUp = useCallback((e) => {
        if (!selfCamDraggingRef.current) return
        selfCamDraggingRef.current = false
        const el = selfCamRef.current
        const container = el?.offsetParent
        try { el?.releasePointerCapture(e.pointerId) } catch (_) { /* noop */ }
        if (!el || !container) return

        // Horizontal snap to nearest side, keep Y (clamped) and keep 0.5rem padding
        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize || '16')
        const pad = 0.5 * rem
        const cs = getComputedStyle(container)
        const paddingLeft = parseFloat(cs.paddingLeft) || 0
        const paddingTop = parseFloat(cs.paddingTop) || 0
        const clientW = container.clientWidth
        const clientH = container.clientHeight
        const camW = el.offsetWidth
        const camH = el.offsetHeight
        const maxY = Math.max(pad, (clientH - paddingTop) - camH - pad)
        const cur = selfCamPosRef.current
        if (cur.x == null || cur.y == null) return
        const snapLeft = (cur.x + camW / 2) < ((clientW) / 2)
        const targetX = snapLeft ? pad : ((clientW - paddingLeft) - camW - pad)
        const targetY = Math.min(Math.max(cur.y, pad), maxY)
        selfCamPosRef.current = { x: targetX, y: targetY }
        // Restore transitions to animate snap
        el.style.transition = ''
        applySelfCamStyle(targetX, targetY)
    }, [applySelfCamStyle])

    // When toggling expanded state, clear inline left/top and restore on collapse
    useEffect(() => {
        const el = selfCamRef.current
        if (!el) return
        if (selfCamExpanded) {
            // Save current position
            const x = el.offsetLeft
            const y = el.offsetTop
            prevSelfCamPosRef.current = { x, y }
            // Clear inline to let CSS expanded fill container
            el.style.left = '0.5rem'
            el.style.top = '0.5rem'
            el.style.right = ''
            el.style.bottom = ''
        } else {
            const { x, y } = prevSelfCamPosRef.current || {}
            if (x != null && y != null) {
                applySelfCamStyle(x, y)
                selfCamPosRef.current = { x, y }
            }
        }
    }, [selfCamExpanded, applySelfCamStyle])

    /* ---- GRID MANAGEMENT ---------------------------------------------------*/

    /**
     * Calcola quanti elementi di dimensione minima possono stare in un container.
     * @param {HTMLElement} containerRef - riferimento al container (es. ref.current in React)
     * @param {number} minWidth - larghezza minima di un singolo elemento (in px)
     * @param {number} minHeight - altezza minima di un singolo elemento (in px)
     * @returns {{ cols: number, rows: number, total: number }}
     */
    const getMaxElementsInContainer = useCallback((containerRef, minWidth, minHeight) => {
        if (!containerRef) return { cols: 0, rows: 0, total: 0 };

        const { clientWidth, clientHeight } = containerRef;

        // Calcola quante colonne entrano
        let cols = 0;
        while ((cols + 1) * minWidth + cols * 4 <= clientWidth) {
            cols++;
        }

        // Calcola quante righe entrano
        let rows = 0;
        while ((rows + 1) * minHeight + rows * 4 <= clientHeight) {
            rows++;
        }

        const total = cols * rows;

        return { cols, rows, total };
    }, [width, height, isLandscape]);

    const MAX_VISIBLE_FIXED = useMemo(() => {
        if (width > 932) {
            return 8
        }
        if (width > 768) {
            return 6
        }
        if (width > 540) {
            return 3
        }
        if (width > 375) {
            return 2
        }
        else {
            return 2
        }

    }, [width, height])

    const MAX_VISIBLE_OTHER = useMemo(() => {
        if (!isLandscape) {
            if (width <= 375) {
                return 6
            }
            if (width <= 540) {
                return 8
            }
            if (width <= 1024) {
                return 9
            }
            else {
                return 9
            }

        }
        else {
            if (width <= 667) {
                return 2
            }
            if (width <= 932) {
                return 4
            }
            if (width <= 1440) {
                return 9
            }
            if (width <= 1920) {
                return 5
            }
        }

        return 12
    }, [width, height, isLandscape])

    useEffect(() => {

        let cancelled = false;

        // Promise che restituisce il valore dopo 300ms
        const getMaxVisibleAsync = () =>
            new Promise((resolve) => {
                setTimeout(() => {
                    const { total } = getMaxElementsInContainer(mainRef.current, 150, 110);
                    resolve(total);
                }, 300);
            });

        getMaxVisibleAsync().then((value) => {
            if (!cancelled && value <= 48) {
                if (value <= 0) {
                    setMaxPipVisible(1)
                }
                else {
                    setMaxVisible(value)
                }
            } else setMaxVisible(48);
        });

        return () => {
            cancelled = true;
        };
    }, [mainRef, getMaxElementsInContainer]);


    // Ricalcola dinamicamente il numero massimo visibile nel PiP al variare delle dimensioni del container PiP
    useEffect(() => {
        const el = mainPipRef.current
        if (!el) return

        let rafId = null
        let timeoutId = null

        const recalc = () => {
            const { total } = getMaxElementsInContainer(el, 180, 140)
            let max = total <= 48 ? total : 48
            if (max === 0) {
                max = 1
            }
            setMaxPipVisible(max)
        }

        // calcolo immediato alla mount e a cambi espliciti
        recalc()

        const ro = new ResizeObserver(() => {
            if (rafId) cancelAnimationFrame(rafId)
            if (timeoutId) clearTimeout(timeoutId)
            // throttling leggero per evitare ricalcoli eccessivi durante il resize
            rafId = requestAnimationFrame(() => {
                timeoutId = setTimeout(recalc, 50)
            })
        })
        ro.observe(el)

        return () => {
            if (rafId) cancelAnimationFrame(rafId)
            if (timeoutId) clearTimeout(timeoutId)
            try { ro.disconnect() } catch { }
        }
    }, [mainPipRef, getMaxElementsInContainer, pipWidth, pipHeight, pipSidebar, selectedPipTab, pipWindow]);


    useEffect(() => {
        // Remove expired floating reactions via state, not direct DOM,
        // to avoid React reconciliation errors (e.g., insertBefore NotFoundError)
        if (!floatingReactions || floatingReactions.length === 0) return;

        const now = Date.now();
        const remaining = floatingReactions.filter(fr => (now - fr.timestamp) <= 4000);

        // If anything expired, prune state immediately (React will unmount them safely)
        if (remaining.length !== floatingReactions.length) {
            setFloatingReactions(remaining);
            return; // effect will re-run with updated state
        }

        // Schedule the next prune close to the nearest expiry to keep DOM clean
        const msToNextExpiry = Math.max(50, Math.min(
            ...floatingReactions.map(fr => 4000 - (now - fr.timestamp))
        ));

        const timer = setTimeout(() => {
            setFloatingReactions(curr => {
                const tNow = Date.now();
                return curr.filter(fr => (tNow - fr.timestamp) <= 4000);
            });
        }, msToNextExpiry);

        return () => clearTimeout(timer);
    }, [floatingReactions]);


    const [chatLocked, setChatLocked] = useState(false);
    const messageRef = useRef(null);
    const pipMessageRef = useRef(null)
    const [messageLength, setMessageLength] = useState(30);
    const [pipMessageLength, setPipMessageLength] = useState(30);

    useEffect(() => {
        setChatLocked(isSharingScreen && !(whiteboard || pdf));
    }, [isSharingScreen, whiteboard, pdf])

    useEffect(() => {
        const el = messageRef.current;
        if (!el) return;

        const approxCharWidth = 8;

        // ✅ callback sicura per l’observer
        const handleResize = (entries) => {
            for (const entry of entries) {
                const width = entry.contentRect.width;
                const calculatedLength = Math.floor(width / approxCharWidth) - 7;
                setMessageLength(calculatedLength);
            }
        };

        const observer = new ResizeObserver(handleResize);
        observer.observe(el);

        // cleanup
        return () => {
            observer.unobserve(el);
            observer.disconnect();
        };
    }, [selectedChatTab, sidebar, selectedTab]);

    useEffect(() => {
        let rafId = 0;
        let observer;
        let observedEl = null;

        const approxCharWidth = 8;

        const handleResize = (entries) => {
            const entry = entries && entries[0];
            const target = entry?.target || pipMessageRef.current;
            if (!target) return;
            const width = entry?.contentRect?.width ?? target.clientWidth;
            const calculatedLength = Math.floor(width / approxCharWidth) - 7;
            setPipMessageLength(calculatedLength);
        };

        const tryAttach = () => {
            const el = pipMessageRef.current;
            if (!el) {
                // PiP DOM might mount after the effect runs; retry next frame
                rafId = window.requestAnimationFrame(tryAttach);
                return;
            }
            observer = new ResizeObserver(handleResize);
            observer.observe(el);
            observedEl = el;
            // prime with an initial measurement
            handleResize([{ contentRect: el.getBoundingClientRect(), target: el }]);
        };

        tryAttach();

        // cleanup
        return () => {
            if (rafId) window.cancelAnimationFrame(rafId);
            if (observer) {
                if (observedEl) observer.unobserve(observedEl);
                observer.disconnect();
            }
        };
    }, [pipWindow, pipWidth, pipHeight, pipSidebar, selectedPipTab]);

    function farMultipleOf(text, length) {
        const len = text.length;

        // 1️⃣ è più lungo di messageLength?
        const long = len > length;

        // 2️⃣ è entro ±5 da un multiplo di messageLength?
        const remainder = len % length;
        const distance = Math.min(remainder, length - remainder);

        return distance >= 3 && long;
    }


    const [excalidrawAPI, setExcalidrawAPI] = useState(null);
    const [excalidrawState, setExcalidrawState] = useState({ elements: [], appState: null, files: [] });

    // Avvia la condivisione della lavagna con Region Capture (CropTarget) se possibile, altrimenti fallback su canvas.captureStream
    const startShareWithCrop = useCallback(async (containerClass) => {
        if (isSharingScreen) return;

        let keepAliveInterval = null;
        try {
            // Usa un selettore stabile dell'elemento canvas di Excalidraw
            const el = document.querySelector(containerClass);
            if (!el) {
                console.warn('Elemento non trovato per condivisione: ', containerClass);
            }

            // Path 1: Region Capture con CropTarget (solo Chrome/Edge)
            if (window.CropTarget?.fromElement && el) {
                try {
                    const stream = await navigator.mediaDevices.getDisplayMedia({
                        preferCurrentTab: true,
                        video: {
                            displaySurface: 'browser',
                            surfaceSwitching: 'include',
                            selfBrowserSurface: 'include',
                            cursor: 'always'
                        },
                        audio: false
                    });

                    const [track] = stream.getVideoTracks();
                    const target = await window.CropTarget.fromElement(el);
                    await track.cropTo(target);

                    // Salva il riferimento allo stream per poter fermare tutte le tracce allo stop
                    whiteboardStreamRef.current = stream;
                    // Se l'utente interrompe dalla barra di Chrome, sincronizza lo stato UI
                    if (track) track.addEventListener('ended', () => {
                        whiteboardStreamRef.current = null;
                        try { stopScreenShare(); } catch (_) { }
                        setWhiteboard(false);
                        setPdf(null)
                    });
                    startScreenShare({ mediaStream: stream });
                    return; // finito con il percorso CropTarget
                } catch (err) {
                    // Se l'utente rifiuta o chiude il prompt di condivisione, NON fare fallback: chiudi la lavagna.
                    const name = err?.name || err?.code || '';
                    const msg = (err?.message || '').toLowerCase();
                    const userDenied = name === 'NotAllowedError' ||
                        name === 'AbortError' ||
                        name === 'SecurityError' ||
                        msg.includes('denied') ||
                        msg.includes('permission') ||
                        msg.includes('aborted');

                    if (userDenied) {
                        console.warn('Condivisione schermo negata/annullata dall\'utente; chiudo la lavagna.', err);
                        whiteboardStreamRef.current = null;
                        try { stopScreenShare(); } catch (_) { }
                        setWhiteboard(false);
                        setPdf(null)
                        return; // interrompi qui, niente fallback
                    }

                    console.warn('CropTarget non riuscito o scheda non compatibile; fallback a canvas.captureStream()', err);
                    // se fallisce per altro motivo, prosegui sul fallback
                }
            }

            // Path 2: Fallback – cattura direttamente il canvas della lavagna
            const canvas = document.querySelector(whiteboard ? containerClass : '#presentation');
            if (!canvas) return;
            const ctx = canvas.getContext('2d');

            // ogni 100ms, ridisegna un pixel trasparente per mantenere vivo lo stream
            keepAliveInterval = setInterval(() => {
                try {
                    ctx.fillStyle = 'rgba(0,0,0,0)'; // trasparente
                    ctx.fillRect(0, 0, 1, 1);
                } catch (_) { /* noop */ }
            }, 100);

            const stream = canvas.captureStream(30);
            whiteboardStreamRef.current = stream;
            const vtrack = stream.getVideoTracks()[0];
            if (vtrack) vtrack.addEventListener('ended', () => {
                if (keepAliveInterval) clearInterval(keepAliveInterval);
                whiteboardKeepAliveRef.current = null;
                whiteboardStreamRef.current = null;
                try { stopScreenShare(); } catch (_) { }
                setWhiteboard(false);
                setPdf(null)
            });
            whiteboardKeepAliveRef.current = keepAliveInterval;
            startScreenShare({ mediaStream: stream });

        } catch (e) {
            console.error('Errore avvio condivisione lavagna', e);
        }
    }, [isSharingScreen, startScreenShare, stopScreenShare]);

    // Chiude davvero la cattura della lavagna (ferma tutte le tracce e pulisce i timer)
    const stopCapture = useCallback(() => {
        if (whiteboardKeepAliveRef.current) {
            clearInterval(whiteboardKeepAliveRef.current);
            whiteboardKeepAliveRef.current = null;
        }
        const stream = whiteboardStreamRef.current;
        if (stream) {
            try { stream.getTracks().forEach(t => t.stop()); } catch (_) { }
            whiteboardStreamRef.current = null;
        }
    }, []);

    useEffect(() => {
        // Avvia la condivisione della scheda con CropTarget quando disponibile, altrimenti fallback su canvas.captureStream
        // Esegui solo quando la lavagna è aperta e non stiamo già condividendo.
        setFixedOthersOpen(whiteboard || pdf);
        if (isSharingScreen || (!whiteboard && !pdf)) return;
        if (whiteboard) {
            if (!excalidrawAPI) return;
            startShareWithCrop('.excalidraw__canvas.static');
        }
        if (pdf) {
            startShareWithCrop('.pdf-container');
        }
    }, [excalidrawAPI, whiteboard, pdf, isSharingScreen, startShareWithCrop])

    // Cleanup all'unmount o quando necessario
    useEffect(() => {
        return () => {
            stopCapture();
        };
    }, [stopCapture])

    const pickPdfFile = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'application/pdf';
        input.style.display = 'none'; // non visibile ma nel DOM

        input.onchange = e => {
            const file = e.target.files[0];
            if (file) {
                setPdf(file);
                setFullScreenParticipant(localSessionId);
            }
            document.body.removeChild(input); // rimuovi dopo l’uso
        };

        document.body.appendChild(input); // Safari lo richiede
        input.click();
    }

    return (
        <div className={`${styles.container} ${theme === 'dark' ? styles.dark : ''}`}>
            <div className={styles.header}>
                <VelvLogo className={styles.logo} />
                <div className={styles.info}>
                    <div className={styles.title}>{lesson?.name}</div>
                    <div className={styles.subtitle}>
                        {width > 540 &&
                            <>
                                <div className={styles.infoBox}><CalendarIcon className={styles.calendarIcon} />{formatDateV2(lesson?.starts_at, { day: 'numeric', month: 'long', year: 'numeric' }, 'it', true, true)}</div>
                                <span className={styles.divider}>|</span>
                            </>
                        }
                        <div className={styles.infoBox}><ClockIcon className={styles.calendarIcon} />{formatTimeV2(lesson?.starts_at)} - {formatTimeV2(lesson?.ends_at)}</div>
                        <span className={styles.divider}>|</span>
                        <div className={styles.infoBox}><UsersIcon className={styles.calendarIcon} />{call.participantCounts().present} utenti</div>
                        {meetingSeconds && width < 540 && accessState === DailyAccessState.Full && !['left-meeting', 'error'].includes(meetingState) &&
                            <>
                                <span className={styles.divider}>|</span>
                                <div className={styles.infoBox}>
                                    {isRecording &&
                                        <LiveBadge label='' style={{ border: '0px' }} />
                                    }
                                    {formatSeconds(meetingSeconds)}</div>
                            </>
                        }
                    </div>
                </div>
                {width > 540 &&
                    <div className={styles.spacer}></div>
                }
                {meetingSeconds && width > 540 && accessState === DailyAccessState.Full && !['left-meeting', 'error'].includes(meetingState) &&
                    <div className={styles.meetingTime}>
                        {isRecording &&
                            <LiveBadge label='' style={{ border: '0px' }} />
                        }
                        {formatSeconds(meetingSeconds)}
                    </div>
                }
                {accessState === DailyAccessState.Full && width > 768 && !['left-meeting', 'error'].includes(meetingState) &&
                    <>
                        <>
                            {roomLocked &&
                                <TooltipWrapper style={tooltipStyle} text={"Sblocca Stanza"}>
                                    {lockLoading ? <Spinner color={'var(--text)'}></Spinner> :
                                        <LockClosedIcon className={`${styles.controlButton}`} onClick={() => { setUnlockRoom(true) }} />
                                    }
                                </TooltipWrapper>
                            }
                            {!roomLocked &&
                                <TooltipWrapper style={{ backgroundColor: 'var(--background)', color: 'var(--text)' }} text={"Blocca Stanza"}>
                                    {lockLoading ? <Spinner color={'var(--text)'}></Spinner> :
                                        <LockOpenIcon className={`${styles.controlButton}`} onClick={() => { setUnlockRoom(true) }} />
                                    }
                                </TooltipWrapper>
                            }
                        </>
                        {networkState === 'good' &&
                            <TooltipWrapper style={tooltipStyle} html={"<b>Connessione:</b> buona"}>
                                <WifiIcon className={`${styles.controlButton}`} style={{ color: 'var(--sf-green)', cursor: 'default' }} />
                            </TooltipWrapper>
                        }
                        {networkState === 'warning' &&
                            <TooltipWrapper style={tooltipStyle} html={"<b>Connessione:</b> scarsa, potresti riscontrare ritardi nel video o nell'audio."}>
                                <WifiWarningIcon className={`${styles.controlButton}`} style={{ color: 'var(--sf-yellow)', cursor: 'default' }} />
                            </TooltipWrapper>
                        }
                        {networkState === 'bad' &&
                            <TooltipWrapper style={tooltipStyle} html={"<b>Connessione:</b> molto scarsa, potresti non vedere o sentire i partecipanti."}>
                                <WifiOffIcon className={`${styles.controlButton}`} style={{ color: 'var(--sf-red)', cursor: 'default' }} />
                            </TooltipWrapper>
                        }
                        {state === 'high' &&
                            <TooltipWrapper style={tooltipStyle} html={"<b>Carico CPU:</b> alto"}>
                                <PulseIcon className={`${styles.controlButton}`} style={{ color: 'var(--sf-yellow)', cursor: 'default' }} />
                            </TooltipWrapper>
                        }
                        {state === 'low' &&
                            <TooltipWrapper style={tooltipStyle} html={"<b>Carico CPU:</b> basso"}>
                                <PulseIcon className={`${styles.controlButton}`} style={{ color: 'var(--sf-green)', cursor: 'default' }} />
                            </TooltipWrapper>
                        }
                        <div className={styles.viewSwitch}>
                            <div className={`${styles.viewSwitchBack} ${view === 'grid' ? styles.active : ''}`}></div>
                            <TooltipWrapper text={"Partecipante Attivo"} style={tooltipStyle}>
                                <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <FullIcon className={`${styles.viewSwitchIcon} ${view === 'full' ? styles.active : ''}`} onClick={() => { setView('full') }} />
                                </div>
                            </TooltipWrapper>
                            <TooltipWrapper text={"Griglia"} style={tooltipStyle}>
                                <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <GridIcon className={`${styles.viewSwitchIcon} ${view === 'grid' ? styles.active : ''}`} onClick={() => { setView('grid') }} />
                                </div>
                            </TooltipWrapper>
                        </div>
                        {!pipWindow && isSupported &&
                            <TooltipWrapper text={"Picture in Picture"} style={tooltipStyle}>
                                <ShareIcon className={`${styles.controlButton}`} onClick={() => { pipWindow ? closePipWindow() : startPiP() }} />
                            </TooltipWrapper>
                        }
                    </>
                }
                {accessState === DailyAccessState.Full && width <= 768 && !['left-meeting', 'error'].includes(meetingState) &&
                    <>
                        {view === 'grid' &&
                            <div style={{ position: 'relative' }}>
                                <GridIcon className={`${styles.controlButton}`} onClick={() => {
                                    setView('full')
                                }} />
                            </div>
                        }
                        {view === 'full' &&
                            <div style={{ position: 'relative' }}>
                                <FullIcon className={`${styles.controlButton}`} onClick={() => {
                                    setView('grid')
                                }} />
                            </div>
                        }
                        <div style={{ position: 'relative' }}>
                            <MoreIcon className={`${styles.controlButton}`} onClick={() => {
                                setSidebar(true)
                                if (selectedTab === 1) {
                                    setUnread(0)
                                }
                                if (selectedTab === 2) {
                                    setMaterialBadge(0)
                                }
                            }} />
                            {unread + lobbyUnread + teachersUnread + materialBadge > 0 &&
                                <div className={styles.unread}>{unread + materialBadge + lobbyUnread + teachersUnread}</div>
                            }
                        </div>
                    </>
                }
            </div>

            {!sessionData?.groups &&
                <Each of={participants.filter((p) => p !== localSessionId)} render={(session_id, index) => {
                    return (
                        <Fragment key={`audio-track-${session_id}`}>
                            <DailyAudioTrack sessionId={session_id} type="audio" muted={muted} onPlayFailed={onPlayFailed} />
                            <DailyAudioTrack sessionId={session_id} type="screenAudio" muted={muted} onPlayFailed={onPlayFailed} />
                        </Fragment>
                    )

                }} />
            }
            {sessionData?.groups &&
                <Each of={groupParticipants.filter((p) => p !== localSessionId)} render={(session_id, index) => {
                    return (
                        <Fragment key={`group-audio-track-${session_id}`}>
                            <DailyAudioTrack sessionId={session_id} type="audio" muted={muted} onPlayFailed={onPlayFailed} />
                            <DailyAudioTrack sessionId={session_id} type="screenAudio" muted={muted} onPlayFailed={onPlayFailed} />
                        </Fragment>
                    )

                }} />
            }

            {sessionData?.groups &&
                <div className={styles.sessionGroups}>
                    <div className={`${styles.sessionGroup} ${selectedGroup === null ? styles.selected : ''}`} onClick={() => {
                        setSelectedGroup(null)
                    }}>Stanza Principale</div>
                    <Each of={sessionData.groups} render={(group, index) => {
                        return (
                            <div className={`${styles.sessionGroup} ${selectedGroup === group.id ? styles.selected : ''}`}
                                key={`group-${group.id}`}
                                onClick={() => {
                                    setSelectedGroup(group.id)
                                }}>
                                {group.name}
                                {handRaisedIds?.find((h) =>
                                    Object.entries(groupsMap?.current)
                                        .find(([key, value]) => {
                                            return key === `students_group_${h}` && value === group.id
                                        })) &&
                                    <div className={styles.groupBadge} />
                                }
                            </div>
                        )
                    }} />
                </div>
            }

            <div className={styles.content}>
                <div className={styles.main} ref={mainRef}>

                    {accessState === DailyAccessState.Full && !['left-meeting', 'error'].includes(meetingState) &&
                        <>
                            {view === 'grid' &&
                                <PackedGrid
                                    boxAspectRatio={16 / 9}
                                    className={styles.grid}
                                    updateLayoutRef={participantsRef}
                                    boxClassName={styles.participant}
                                >
                                    {visibleParticipants.map((session_id, index) => {
                                        let color = palette[index % palette.length];
                                        let darkColor = darkPalette[index % darkPalette.length];

                                        let appendix = null
                                        const element = <div className={`${(shouldHighlightWhenSpeaks(session_id) && speakingMap?.[session_id] > 0) ? styles.active : ''}`} key={session_id}
                                        >
                                            <div className={theme === 'light' ? styles.participantBackground : styles.participantBackgroundDark}
                                                style={{
                                                    '--color': isSharing(session_id) ? '#212121' : getUser(session_id)?.color ?? color,
                                                    '--colorDark': isSharing(session_id) ? '#212121' : getUser(session_id)?.darkColor ?? darkColor
                                                }} />
                                            {(hasCam(session_id) || isSharing(session_id)) &&
                                                <DailyVideo
                                                    key={`video-${session_id}`}
                                                    controls={false}
                                                    type={isSharing(session_id) ? 'screenVideo' : 'video'}
                                                    sessionId={session_id}
                                                    className={styles.participantVideo}
                                                    automirror={!isSharing(session_id) && session_id === localSessionId}
                                                    style={{ objectFit: isSharing(session_id) ? 'contain' : 'cover' }} />
                                            }

                                            <PinIcon className={`${styles.participantPin} ${pinnedIds.includes(session_id) ? styles.pinned : ''}`}
                                                onClick={() => {
                                                    togglePinned(session_id)
                                                }} />
                                            {!hasCam(session_id) && !isSharing(session_id) &&
                                                <CamOffIcon className={styles.participantCamOff} />
                                            }
                                            <div className={styles.participantIndicators}>
                                                {networkQualityMap?.[session_id] === 'warning' &&
                                                    <WifiWarningIcon className={styles.participantNetwork} style={{ color: 'var(--sf-yellow)' }} />
                                                }
                                                {networkQualityMap?.[session_id] === 'bad' &&
                                                    <WifiOffIcon className={styles.participantNetwork} style={{ color: 'var(--sf-red)' }} />
                                                }
                                                {handRaisedIds.includes(session_id) &&
                                                    <HandIcon className={styles.participantHand} />
                                                }
                                                {(hasCam(session_id) || isSharing(session_id)) &&
                                                    <ScreenMaximizeIcon className={styles.participantFullscreen} onClick={() => {
                                                        setFullScreenParticipant(session_id)
                                                    }} />
                                                }
                                            </div>
                                            {isMuted(session_id) &&
                                                <div className={`${styles.participantMuted} ${isMuted(session_id) ? styles.disabled : ''}`}>
                                                    <SpeakerOffIcon />
                                                </div>
                                            }
                                            <div className={`${styles.participantMic} ${!hasMic(session_id) ? styles.disabled : ''}`}>
                                                {hasMic(session_id) &&
                                                    <MicIcon onClick={() => {
                                                        call.updateParticipant(session_id, { setAudio: false })
                                                    }} />
                                                }
                                                {!hasMic(session_id) &&
                                                    <MicOffIcon onClick={() => {
                                                        if (session_id === localSessionId) {
                                                            call.updateParticipant(session_id, { setAudio: true })
                                                        }
                                                        else {
                                                            return
                                                            // setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                        }
                                                    }} />
                                                }
                                            </div>
                                            <div className={styles.participantName}>
                                                {getUser(session_id)?.role &&
                                                    <div className={styles.participantNameText}>
                                                        {getUser(session_id)?.isTeacher && <TeacherIcon className={styles.participantIcon} />}
                                                        {getUser(session_id)?.isTutor && <TutorIcon className={styles.participantIcon} />}
                                                        {getUser(session_id)?.isAdmin && <CopIcon className={styles.participantIcon} />}
                                                        {getUser(session_id)?.name} {session_id === localSessionId ? `${getUser(session_id)?.surname} (Tu)` : getUser(session_id)?.surname}
                                                        {isSharing(session_id) && ' - Condivisione'}
                                                    </div>
                                                }
                                                {!getUser(session_id)?.role &&
                                                    <div className={styles.participantNameText}>
                                                        <UserIcon className={styles.participantIcon} />
                                                        {getUser(session_id)?.name} {session_id === localSessionId ? `${getUser(session_id)?.surname} (Tu)` : (getUser(session_id)?.surname ? (isSharing(localSessionId) ? `${getUser(session_id)?.surname?.[0]}.` : getUser(session_id)?.surname) : '')}
                                                        {isSharing(session_id) && ' - Condivisione'}
                                                    </div>
                                                }
                                            </div>
                                            <AudioObserver key={`audio-observer-${session_id}`} session_id={session_id} onVolumeChange={(level) => {
                                                const lvl = parseFloat(level) || 0
                                                remoteAudioLevels.current[session_id] = lvl
                                                setSpeakingMap(prev => {
                                                    const prevSpeaking = !!prev[session_id]
                                                    const nowSpeaking = prevSpeaking ? (lvl > SPEAK_OFF) : (lvl > SPEAK_ON)
                                                    if (nowSpeaking === prevSpeaking) return prev
                                                    return { ...prev, [session_id]: nowSpeaking }
                                                })
                                                if (session_id === localSessionId) {
                                                    setLocalAudioLevel(lvl)
                                                }
                                            }} />
                                        </div>

                                        if (isSharing(session_id) && hasCam(session_id)) {
                                            appendix = <div id={`appendix-${session_id}`} key={`appendix-${session_id}`}>
                                                <div className={theme === 'light' ? styles.participantBackground : styles.participantBackgroundDark}
                                                    style={{
                                                        '--color': isSharing(session_id) ? '#212121' : getUser(session_id)?.color ?? '#212121',
                                                        '--colorDark': isSharing(session_id) ? '#212121' : getUser(session_id)?.darkColor ?? '#212121'
                                                    }} />
                                                {(hasCam(session_id) || isSharing(session_id)) &&
                                                    <DailyVideo
                                                        key={`video-${session_id}`}
                                                        controls={false}
                                                        type={'video'}
                                                        sessionId={session_id}
                                                        className={styles.participantVideo}
                                                        automirror={session_id === localSessionId}
                                                        style={{ objectFit: 'cover' }} />
                                                }
                                                <PinIcon className={`${styles.participantPin} ${pinnedIds.includes(session_id) ? styles.pinned : ''}`}
                                                    onClick={() => {
                                                        togglePinned(session_id)
                                                    }} />
                                                {!hasCam(session_id) && !isSharing(session_id) &&
                                                    <CamOffIcon className={styles.participantCamOff} />
                                                }
                                                {isMuted(session_id) &&
                                                    <div className={`${styles.participantMuted} ${isMuted(session_id) ? styles.disabled : ''}`}>
                                                        <SpeakerOffIcon />
                                                    </div>
                                                }
                                                <div className={styles.participantIndicators}>
                                                    {networkQualityMap?.[session_id] === 'warning' &&
                                                        <WifiWarningIcon className={styles.participantNetwork} style={{ color: 'var(--sf-yellow)' }} />
                                                    }
                                                    {networkQualityMap?.[session_id] === 'bad' &&
                                                        <WifiOffIcon className={styles.participantNetwork} style={{ color: 'var(--sf-red)' }} />
                                                    }
                                                    {handRaisedIds.includes(session_id) &&
                                                        <HandIcon className={styles.participantHand} />
                                                    }
                                                    {(hasCam(session_id) || isSharing(session_id)) &&
                                                        <ScreenMaximizeIcon className={styles.participantFullscreen} onClick={() => {
                                                            setFullScreenParticipant(session_id)
                                                        }} />
                                                    }
                                                </div>
                                                <div className={`${styles.participantMic} ${!hasMic(session_id) ? styles.disabled : ''}`}>
                                                    {hasMic(session_id) &&
                                                        <MicIcon onClick={() => {
                                                            call.updateParticipant(session_id, { setAudio: false })
                                                        }} />
                                                    }
                                                    {!hasMic(session_id) &&
                                                        <MicOffIcon onClick={() => {
                                                            if (session_id === localSessionId) {
                                                                call.updateParticipant(session_id, { setAudio: true })
                                                            }
                                                            else {
                                                                return
                                                                // setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                            }
                                                        }} />
                                                    }
                                                </div>
                                                <div className={styles.participantName}>
                                                    {getUser(session_id)?.role &&
                                                        <div className={styles.participantNameText}>
                                                            {getUser(session_id)?.isTeacher && <TeacherIcon className={styles.participantIcon} />}
                                                            {getUser(session_id)?.isTutor && <TutorIcon className={styles.participantIcon} />}
                                                            {getUser(session_id)?.isAdmin && <CopIcon className={styles.participantIcon} />}
                                                            {getUser(session_id)?.name} {session_id === localSessionId ? `${getUser(session_id)?.surname} (Tu)` : getUser(session_id)?.surname}
                                                        </div>
                                                    }
                                                    {!getUser(session_id)?.role &&
                                                        <div className={styles.participantNameText}>
                                                            <UserIcon className={styles.participantIcon} />
                                                            {getUser(session_id)?.name} {session_id === localSessionId ? `${getUser(session_id)?.surname} (Tu)` : (getUser(session_id)?.surname ? (isSharing(localSessionId) ? `${getUser(session_id)?.surname?.[0]}.` : getUser(session_id)?.surname) : '')}
                                                        </div>
                                                    }
                                                </div>
                                                <AudioObserver key={`audio-observer-${session_id}`} session_id={session_id} onVolumeChange={(level) => {
                                                    const lvl = parseFloat(level) || 0
                                                    remoteAudioLevels.current[session_id] = lvl
                                                    setSpeakingMap(prev => {
                                                        const prevSpeaking = !!prev[session_id]
                                                        const nowSpeaking = prevSpeaking ? (lvl > SPEAK_OFF) : (lvl > SPEAK_ON)
                                                        if (nowSpeaking === prevSpeaking) return prev
                                                        return { ...prev, [session_id]: nowSpeaking }
                                                    })
                                                    if (session_id === localSessionId) {
                                                        setLocalAudioLevel(lvl)
                                                    }
                                                }} />
                                            </div>
                                        }

                                        return appendix ? [element, appendix] : element

                                    })}

                                </PackedGrid>
                            }
                            {view === 'full' &&
                                <>
                                    <div className={styles.activeParticipant}>
                                        <PackedGrid
                                            boxAspectRatio={16 / 9}
                                            className={styles.grid}
                                            updateLayoutRef={participantsRef}
                                            boxClassName={styles.participant}
                                        >
                                            {!fullScreenParticipant &&
                                                <div key={visibleParticipants[0]} ref={activeParticipantRef}>
                                                    <div className={theme === 'light' ? styles.participantBackground : styles.participantBackgroundDark}
                                                        style={{
                                                            '--color': isSharing(visibleParticipants[0]) ? '#212121' : getUser(visibleParticipants[0])?.color ?? '#212121',
                                                            '--colorDark': isSharing(visibleParticipants[0]) ? '#212121' : getUser(visibleParticipants[0])?.darkColor ?? '#212121'
                                                        }} />

                                                    {(hasCam(visibleParticipants[0]) || isSharing(visibleParticipants[0])) &&
                                                        <DailyVideo
                                                            key={`video-${visibleParticipants[0]}`}
                                                            controls={false}
                                                            type={isSharing(visibleParticipants[0]) ? 'screenVideo' : 'video'}
                                                            sessionId={visibleParticipants[0]}
                                                            className={styles.participantVideo}
                                                            automirror={!isSharing(visibleParticipants[0]) && visibleParticipants[0] === localSessionId}
                                                            style={{ objectFit: isSharing(visibleParticipants[0]) ? 'contain' : 'cover' }} />
                                                    }

                                                    <PinIcon className={`${styles.participantPin} ${pinnedIds.includes(visibleParticipants[0]) ? styles.pinned : ''}`}
                                                        onClick={() => {
                                                            togglePinned(visibleParticipants[0])
                                                        }} />
                                                    {!hasCam(visibleParticipants[0]) && !isSharing(visibleParticipants[0]) &&
                                                        <CamOffIcon className={styles.participantCamOff} />
                                                    }
                                                    <div className={styles.participantIndicators}>
                                                        {networkQualityMap?.[visibleParticipants[0]] === 'warning' &&
                                                            <WifiWarningIcon className={styles.participantNetwork} style={{ color: 'var(--sf-yellow)' }} />
                                                        }
                                                        {networkQualityMap?.[visibleParticipants[0]] === 'bad' &&
                                                            <WifiOffIcon className={styles.participantNetwork} style={{ color: 'var(--sf-red)' }} />
                                                        }
                                                        {handRaisedIds.includes(visibleParticipants[0]) &&
                                                            <HandIcon className={styles.participantHand} />
                                                        }
                                                        {(hasCam(visibleParticipants[0]) || isSharing(visibleParticipants[0])) &&
                                                            <ScreenMaximizeIcon className={styles.participantFullscreen} onClick={() => {
                                                                setFullScreenParticipant(visibleParticipants[0])
                                                            }} />
                                                        }
                                                    </div>
                                                    {isMuted(visibleParticipants[0]) &&
                                                        <div className={`${styles.participantMuted} ${isMuted(visibleParticipants[0]) ? styles.disabled : ''}`}>
                                                            <SpeakerOffIcon />
                                                        </div>
                                                    }
                                                    {isSharing(visibleParticipants[0]) && view === 'full' && hasCam(visibleParticipants[0]) &&
                                                        <div
                                                            className={`${styles.participantCam} ${selfCamExpanded ? styles.expanded : ''}`}
                                                            ref={selfCamRef}
                                                            onPointerDown={onSelfCamPointerDown}
                                                            onPointerMove={onSelfCamPointerMove}
                                                            onPointerUp={onSelfCamPointerUp}
                                                            onPointerCancel={onSelfCamPointerUp}
                                                            onClick={(ev) => {
                                                                if (selfCamClickPreventRef.current) {
                                                                    ev.preventDefault()
                                                                    ev.stopPropagation()
                                                                    selfCamClickPreventRef.current = false
                                                                    return
                                                                }
                                                                setSelfCamExpanded(prev => !prev)
                                                                setExpanded(!expanded)
                                                            }}
                                                        >
                                                            {/* <ScreenSharePersonIcon /> */}
                                                            <div className={styles.selfView}>
                                                                <DailyVideo
                                                                    controls={false}
                                                                    type={'video'}
                                                                    sessionId={visibleParticipants[0]}
                                                                    automirror={visibleParticipants[0] === localSessionId}
                                                                    style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
                                                            </div>
                                                        </div>
                                                    }
                                                    <div className={`${styles.participantMic} ${!hasMic(visibleParticipants[0]) ? styles.disabled : ''}`}>
                                                        {hasMic(visibleParticipants[0]) &&
                                                            <MicIcon onClick={() => {
                                                                call.updateParticipant(visibleParticipants[0], { setAudio: false })
                                                            }} />
                                                        }
                                                        {!hasMic(visibleParticipants[0]) &&
                                                            <MicOffIcon onClick={() => {
                                                                if (visibleParticipants[0] === localSessionId) {
                                                                    call.updateParticipant(visibleParticipants[0], { setAudio: true })
                                                                }
                                                                else {
                                                                    return
                                                                    // setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                                }
                                                            }} />
                                                        }
                                                    </div>
                                                    <div className={styles.participantName}>
                                                        {getUser(visibleParticipants[0])?.role &&
                                                            <div className={styles.participantNameText}>
                                                                {getUser(visibleParticipants[0])?.isTeacher && <TeacherIcon className={styles.participantIcon} />}
                                                                {getUser(visibleParticipants[0])?.isTutor && <TutorIcon className={styles.participantIcon} />}
                                                                {getUser(visibleParticipants[0])?.isAdmin && <CopIcon className={styles.participantIcon} />}
                                                                {getUser(visibleParticipants[0])?.name} {visibleParticipants[0] === localSessionId ? `${getUser(visibleParticipants[0])?.surname} (Tu)` : getUser(visibleParticipants[0])?.surname}
                                                            </div>
                                                        }
                                                        {!getUser(visibleParticipants[0])?.role &&
                                                            <div className={styles.participantNameText}>
                                                                <UserIcon className={styles.participantIcon} />
                                                                {getUser(visibleParticipants[0])?.name} {visibleParticipants[0] === localSessionId ? `${getUser(visibleParticipants[0])?.surname} (Tu)` : (getUser(visibleParticipants[0])?.surname ? (isSharing(localSessionId) ? `${getUser(visibleParticipants[0])?.surname?.[0]}.` : getUser(visibleParticipants[0])?.surname) : '')}
                                                            </div>
                                                        }
                                                    </div>
                                                    <AudioObserver key={`audio-observer-${visibleParticipants[0]}`} session_id={visibleParticipants[0]} onVolumeChange={(level) => {
                                                        const id = visibleParticipants[0]
                                                        const lvl = parseFloat(level) || 0
                                                        remoteAudioLevels.current[id] = lvl
                                                        setSpeakingMap(prev => {
                                                            const prevSpeaking = !!prev[id]
                                                            const nowSpeaking = prevSpeaking ? (lvl > SPEAK_OFF) : (lvl > SPEAK_ON)
                                                            if (nowSpeaking === prevSpeaking) return prev
                                                            return { ...prev, [id]: nowSpeaking }
                                                        })
                                                        if (id === localSessionId) {
                                                            setLocalAudioLevel(lvl)
                                                        }
                                                    }} />
                                                </div>
                                            }
                                        </PackedGrid>
                                    </div>

                                    {visibleParticipants.slice(1, MAX_VISIBLE_OTHER + 1).length > 0 &&
                                        <div className={styles.othersParticipants} ref={otherParticipantsContainerRef}>
                                            <PackedGrid
                                                boxAspectRatio={16 / 9}
                                                className={styles.grid}
                                                updateLayoutRef={otherParticipantsRef}
                                                boxClassName={styles.participant}
                                            >

                                                {visibleParticipants.slice(1, MAX_VISIBLE_OTHER + 1).map((session_id, index) => {
                                                    return (
                                                        <div key={session_id} className={`${(shouldHighlightWhenSpeaks(session_id) && speakingMap?.[session_id] > 0) ? styles.active : ''}`}>
                                                            <div className={theme === 'light' ? styles.participantBackground : styles.participantBackgroundDark}
                                                                style={{
                                                                    '--color': isSharing(session_id) ? '#212121' : getUser(session_id)?.color ?? '#212121',
                                                                    '--colorDark': isSharing(session_id) ? '#212121' : getUser(session_id)?.darkColor ?? '#212121'
                                                                }} />
                                                            {(hasCam(session_id) || isSharing(session_id)) &&
                                                                <DailyVideo
                                                                    key={`video-${session_id}`}
                                                                    controls={false}
                                                                    type={isSharing(session_id) ? 'screenVideo' : 'video'}
                                                                    sessionId={session_id}
                                                                    className={styles.participantVideo}
                                                                    automirror={!isSharing(session_id) && session_id === localSessionId}
                                                                    style={{ objectFit: isSharing(session_id) ? 'contain' : 'cover' }} />
                                                            }
                                                            <PinIcon className={`${styles.participantPin} ${pinnedIds.includes(session_id) ? styles.pinned : ''}`}
                                                                onClick={() => {
                                                                    togglePinned(session_id)
                                                                }} />
                                                            {!hasCam(session_id) && !isSharing(session_id) &&
                                                                <CamOffIcon className={styles.participantCamOff} />
                                                            }
                                                            <div className={styles.participantIndicators}>
                                                                {networkQualityMap?.[session_id] === 'warning' &&
                                                                    <WifiWarningIcon className={styles.participantNetwork} style={{ color: 'var(--sf-yellow)' }} />
                                                                }
                                                                {networkQualityMap?.[session_id] === 'bad' &&
                                                                    <WifiOffIcon className={styles.participantNetwork} style={{ color: 'var(--sf-red)' }} />
                                                                }
                                                                {handRaisedIds.includes(session_id) &&
                                                                    <HandIcon className={styles.participantHand} />
                                                                }
                                                                {(hasCam(session_id) || isSharing(session_id)) &&
                                                                    <ScreenMaximizeIcon className={styles.participantFullscreen} onClick={() => {
                                                                        setFullScreenParticipant(session_id)
                                                                    }} />
                                                                }
                                                            </div>
                                                            {isMuted(session_id) &&
                                                                <div className={`${styles.participantMuted} ${isMuted(session_id) ? styles.disabled : ''}`}>
                                                                    <SpeakerOffIcon />
                                                                </div>
                                                            }
                                                            {isSharing(session_id) && view === 'full' && index === 0 && hasCam(session_id) &&
                                                                <div className={styles.participantCam} onClick={() => {
                                                                    setToggleSelfView(!toggleSelfView)
                                                                }}>
                                                                    <ScreenSharePersonIcon />
                                                                </div>
                                                            }
                                                            <div className={`${styles.participantMic} ${!hasMic(session_id) ? styles.disabled : ''}`}>
                                                                {hasMic(session_id) &&
                                                                    <MicIcon onClick={() => {
                                                                        call.updateParticipant(session_id, { setAudio: false })
                                                                    }} />
                                                                }
                                                                {!hasMic(session_id) &&
                                                                    <MicOffIcon onClick={() => {
                                                                        if (session_id === localSessionId) {
                                                                            call.updateParticipant(session_id, { setAudio: true })
                                                                        }
                                                                        else {
                                                                            return
                                                                            // setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                                        }
                                                                    }} />
                                                                }
                                                            </div>
                                                            <div className={styles.participantName}>
                                                                {getUser(session_id)?.role &&
                                                                    <div className={styles.participantNameText}>
                                                                        {getUser(session_id)?.isTeacher && <TeacherIcon className={styles.participantIcon} />}
                                                                        {getUser(session_id)?.isTutor && <TutorIcon className={styles.participantIcon} />}
                                                                        {getUser(session_id)?.isAdmin && <CopIcon className={styles.participantIcon} />}
                                                                        {getUser(session_id)?.name} {session_id === localSessionId ? `${getUser(session_id)?.surname} (Tu)` : getUser(session_id)?.surname}
                                                                    </div>
                                                                }
                                                                {!getUser(session_id)?.role &&
                                                                    <div className={styles.participantNameText}>
                                                                        <UserIcon className={styles.participantIcon} />
                                                                        {getUser(session_id)?.name} {session_id === localSessionId ? `${getUser(session_id)?.surname} (Tu)` : (getUser(session_id)?.surname ? (isSharing(localSessionId) ? `${getUser(session_id)?.surname?.[0]}.` : getUser(session_id)?.surname) : '')}
                                                                    </div>
                                                                }
                                                            </div>
                                                            <AudioObserver key={`audio-observer-${session_id}`} session_id={session_id} onVolumeChange={(level) => {
                                                                const lvl = parseFloat(level) || 0
                                                                remoteAudioLevels.current[session_id] = lvl
                                                                setSpeakingMap(prev => {
                                                                    const prevSpeaking = !!prev[session_id]
                                                                    const nowSpeaking = prevSpeaking ? (lvl > SPEAK_OFF) : (lvl > SPEAK_ON)
                                                                    if (nowSpeaking === prevSpeaking) return prev
                                                                    return { ...prev, [session_id]: nowSpeaking }
                                                                })
                                                                if (session_id === localSessionId) {
                                                                    setLocalAudioLevel(lvl)
                                                                }
                                                            }} />
                                                        </div>
                                                    )
                                                })}
                                            </PackedGrid>
                                        </div>
                                    }
                                </>
                            }

                            {(fullScreenParticipant || whiteboard || pdf) &&
                                <>
                                    <div className={`${styles.participant} ${styles.fullscreen} ${(fixedOthersOpen && visibleParticipants.filter(p => p !== fullScreenParticipant).slice(0, MAX_VISIBLE_FIXED + 1).length > 0) ? styles.othersOpen : ''} ${sidebar ? styles.withSidebar : ''}`}>
                                        <div className={theme === 'light' ? styles.participantBackground : styles.participantBackgroundDark}
                                            style={{
                                                '--color': isSharing(fullScreenParticipant) ? '#212121' : getUser(fullScreenParticipant)?.color ?? '#212121',
                                                '--colorDark': isSharing(fullScreenParticipant) ? '#212121' : getUser(fullScreenParticipant)?.darkColor ?? '#212121'
                                            }} />
                                        {whiteboard &&
                                            <div className={styles.excalidrawContainer}>
                                                <Excalidraw
                                                    initialData={{ elements: excalidrawState.elements, appState: excalidrawState.appState, files: excalidrawState.files }}
                                                    style={{ width: '100%', height: '100%', zIndex: 99 }}
                                                    excalidrawAPI={(api) => { setExcalidrawAPI(api) }}
                                                    onChange={(elements, appState, files) => {
                                                        if (!_.isEqual({ elements, appState, files }, excalidrawState)) {
                                                            setExcalidrawState({ elements, appState, files })
                                                        }
                                                    }}
                                                >
                                                    <UsersIcon className={styles.showOthers} onClick={() => {
                                                        setFixedOthersOpen(!fixedOthersOpen)
                                                    }} />
                                                </Excalidraw>
                                            </div>
                                        }
                                        {pdf &&
                                            <div className={`${styles.pdfContainer} pdf-container`}>
                                                <PDFCanvas file={pdf} controls={[
                                                    {
                                                        icon: <UsersIcon />,
                                                        onClick: () => { setFixedOthersOpen(prev => !prev) },
                                                        active: fixedOthersOpen
                                                    }
                                                ]} />
                                            </div>
                                        }
                                        {(hasCam(fullScreenParticipant) || isSharing(fullScreenParticipant)) &&
                                            <DailyVideo
                                                key={`video-full-${fullScreenParticipant}`}
                                                controls={false}
                                                type={isSharing(fullScreenParticipant) ? 'screenVideo' : 'video'}
                                                sessionId={fullScreenParticipant}
                                                className={styles.participantVideo}
                                                automirror={!isSharing(fullScreenParticipant) && fullScreenParticipant === localSessionId}
                                                style={{ objectFit: isSharing(fullScreenParticipant) ? 'contain' : 'cover' }} />
                                        }
                                        <PinIcon className={`${styles.participantPin} ${pinnedIds.includes(fullScreenParticipant) ? styles.pinned : ''}`}
                                            onClick={() => {
                                                togglePinned(fullScreenParticipant)
                                            }} />
                                        {!hasCam(fullScreenParticipant) && !isSharing(fullScreenParticipant) && !whiteboard && !pdf &&
                                            <CamOffIcon className={styles.participantCamOff} />
                                        }
                                        <div className={styles.participantIndicators}>
                                            {networkQualityMap?.[fullScreenParticipant] === 'warning' &&
                                                <WifiWarningIcon className={styles.participantNetwork} style={{ color: 'var(--sf-yellow)' }} />
                                            }
                                            {networkQualityMap?.[fullScreenParticipant] === 'bad' &&
                                                <WifiOffIcon className={styles.participantNetwork} style={{ color: 'var(--sf-red)' }} />
                                            }
                                            {handRaisedIds.includes(fullScreenParticipant) &&
                                                <HandIcon className={styles.participantHand} />
                                            }
                                            {(hasCam(fullScreenParticipant) || isSharing(fullScreenParticipant)) && !whiteboard &&
                                                <ScreenMinimizeIcon className={styles.participantFullscreen} onClick={() => {
                                                    setSelfCamExpanded(false)
                                                    setFullScreenParticipant(null)
                                                }} />
                                            }
                                        </div>
                                        {isMuted(fullScreenParticipant) && !whiteboard && !pdf &&
                                            <div className={`${styles.participantMuted} ${isMuted(fullScreenParticipant) ? styles.disabled : ''}`}>
                                                <SpeakerOffIcon />
                                            </div>
                                        }
                                        {isSharing(fullScreenParticipant) && hasCam(fullScreenParticipant) && !whiteboard && !pdf &&
                                            <div
                                                className={`${styles.participantCam} ${selfCamExpanded ? styles.expanded : ''}`}
                                                ref={selfCamRef}
                                                onPointerDown={onSelfCamPointerDown}
                                                onPointerMove={onSelfCamPointerMove}
                                                onPointerUp={onSelfCamPointerUp}
                                                onPointerCancel={onSelfCamPointerUp}
                                                onClick={(ev) => {
                                                    if (selfCamClickPreventRef.current) {
                                                        ev.preventDefault()
                                                        ev.stopPropagation()
                                                        selfCamClickPreventRef.current = false
                                                        return
                                                    }
                                                    setSelfCamExpanded(prev => !prev)
                                                    setExpanded(!expanded)
                                                }}
                                            >
                                                {/* <ScreenSharePersonIcon /> */}
                                                <div className={styles.selfView}>
                                                    <DailyVideo
                                                        controls={false}
                                                        type={'video'}
                                                        sessionId={fullScreenParticipant}
                                                        automirror={fullScreenParticipant === localSessionId}
                                                        style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
                                                </div>
                                            </div>
                                        }
                                        {!whiteboard && !pdf &&
                                            <div className={`${styles.participantMic} ${!hasMic(fullScreenParticipant) ? styles.disabled : ''}`}>
                                                {hasMic(fullScreenParticipant) &&
                                                    <MicIcon onClick={() => {
                                                        call.updateParticipant(fullScreenParticipant, { setAudio: false })
                                                    }} />
                                                }
                                                {!hasMic(fullScreenParticipant) &&
                                                    <MicOffIcon onClick={() => {
                                                        if (fullScreenParticipant === localSessionId) {
                                                            call.updateParticipant(fullScreenParticipant, { setAudio: true })
                                                        }
                                                        else {
                                                            return
                                                            // setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                        }
                                                    }} />
                                                }
                                            </div>
                                        }
                                        {!whiteboard && !pdf &&
                                            <div className={styles.participantName}>
                                                {getUser(fullScreenParticipant)?.role && !whiteboard && !pdf &&
                                                    <div className={styles.participantNameText}>
                                                        {getUser(fullScreenParticipant)?.isTeacher && <TeacherIcon className={styles.participantIcon} />}
                                                        {getUser(fullScreenParticipant)?.isTutor && <TutorIcon className={styles.participantIcon} />}
                                                        {getUser(fullScreenParticipant)?.isAdmin && <CopIcon className={styles.participantIcon} />}
                                                        {getUser(fullScreenParticipant)?.name} {fullScreenParticipant === localSessionId ? `${getUser(fullScreenParticipant)?.surname} (Tu)` : getUser(fullScreenParticipant)?.surname}
                                                    </div>
                                                }
                                                {!getUser(fullScreenParticipant)?.role && !whiteboard && !pdf &&
                                                    <div className={styles.participantNameText}>
                                                        <UserIcon className={styles.participantIcon} />
                                                        {getUser(fullScreenParticipant)?.name} {fullScreenParticipant === localSessionId ? `${getUser(fullScreenParticipant)?.surname} (Tu)` : (getUser(fullScreenParticipant)?.surname ? (isSharing(localSessionId) ? `${getUser(fullScreenParticipant)?.surname?.[0]}.` : getUser(fullScreenParticipant)?.surname) : '')}
                                                    </div>
                                                }
                                            </div>
                                        }
                                        <AudioObserver key={`audio-observer-full-${fullScreenParticipant}`} session_id={fullScreenParticipant} onVolumeChange={(level) => {
                                            const id = fullScreenParticipant
                                            const lvl = parseFloat(level) || 0
                                            remoteAudioLevels.current[id] = lvl
                                            setSpeakingMap(prev => {
                                                const prevSpeaking = !!prev[id]
                                                const nowSpeaking = prevSpeaking ? (lvl > SPEAK_OFF) : (lvl > SPEAK_ON)
                                                if (nowSpeaking === prevSpeaking) return prev
                                                return { ...prev, [id]: nowSpeaking }
                                            })
                                            if (id === localSessionId) {
                                                setLocalAudioLevel(lvl)
                                            }
                                        }} />

                                    </div>


                                    {(fullScreenParticipant || whiteboard || pdf) && visibleParticipants.filter(p => p !== fullScreenParticipant).slice(0, MAX_VISIBLE_FIXED + 1).length > 0 &&

                                        <div className={`${styles.fullScreenOthers} ${sidebar ? styles.withSidebar : ''} ${fixedOthersOpen ? styles.open : ''}`} ref={fixedParticipantsContainerRef}>
                                            {visibleParticipants.filter(p => p !== fullScreenParticipant).slice(0, MAX_VISIBLE_FIXED + 1).map((session_id, index) => {
                                                return (
                                                    <div key={session_id} className={`${styles.fixedParticipant} ${(shouldHighlightWhenSpeaks(session_id) && speakingMap?.[session_id] > 0) ? styles.active : ''}`}>
                                                        <div className={theme === 'light' ? styles.participantBackground : styles.participantBackgroundDark}
                                                            style={{
                                                                '--color': isSharing(session_id) ? '#212121' : getUser(session_id)?.color ?? '#212121',
                                                                '--colorDark': isSharing(session_id) ? '#212121' : getUser(session_id)?.darkColor ?? '#212121'
                                                            }} />
                                                        {(hasCam(session_id) || isSharing(session_id)) &&
                                                            <DailyVideo
                                                                key={`video-${session_id}`}
                                                                controls={false}
                                                                type={isSharing(session_id) ? 'screenVideo' : 'video'}
                                                                sessionId={session_id}
                                                                className={styles.participantVideo}
                                                                automirror={!isSharing(session_id) && session_id === localSessionId}
                                                                style={{ objectFit: isSharing(session_id) ? 'contain' : 'cover' }} />
                                                        }
                                                        <PinIcon className={`${styles.participantPin} ${pinnedIds.includes(session_id) ? styles.pinned : ''}`}
                                                            onClick={() => {
                                                                togglePinned(session_id)
                                                            }} />
                                                        {!hasCam(session_id) && !isSharing(session_id) &&
                                                            <CamOffIcon className={styles.participantCamOff} />
                                                        }
                                                        <div className={styles.participantIndicators}>
                                                            {networkQualityMap?.[session_id] === 'warning' &&
                                                                <WifiWarningIcon className={styles.participantNetwork} style={{ color: 'var(--sf-yellow)' }} />
                                                            }
                                                            {networkQualityMap?.[session_id] === 'bad' &&
                                                                <WifiOffIcon className={styles.participantNetwork} style={{ color: 'var(--sf-red)' }} />
                                                            }
                                                            {handRaisedIds.includes(session_id) &&
                                                                <HandIcon className={styles.participantHand} />
                                                            }

                                                        </div>
                                                        {isMuted(session_id) &&
                                                            <div className={`${styles.participantMuted} ${isMuted(session_id) ? styles.disabled : ''}`}>
                                                                <SpeakerOffIcon />
                                                            </div>
                                                        }
                                                        {isSharing(session_id) && view === 'full' && index === 0 && hasCam(session_id) &&
                                                            <div className={styles.participantCam} onClick={() => {
                                                                setToggleSelfView(!toggleSelfView)
                                                            }}>
                                                                <ScreenSharePersonIcon />
                                                            </div>
                                                        }
                                                        <div className={`${styles.participantMic} ${!hasMic(session_id) ? styles.disabled : ''}`}>
                                                            {hasMic(session_id) &&
                                                                <MicIcon onClick={() => {
                                                                    call.updateParticipant(session_id, { setAudio: false })
                                                                }} />
                                                            }
                                                            {!hasMic(session_id) &&
                                                                <MicOffIcon onClick={() => {
                                                                    if (session_id === localSessionId) {
                                                                        call.updateParticipant(session_id, { setAudio: true })
                                                                    }
                                                                    else {
                                                                        return
                                                                        // setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                                    }
                                                                }} />
                                                            }
                                                        </div>
                                                        <div className={styles.participantName}>
                                                            {getUser(session_id)?.role &&
                                                                <div className={styles.participantNameText}>
                                                                    {getUser(session_id)?.isTeacher && <TeacherIcon className={styles.participantIcon} />}
                                                                    {getUser(session_id)?.isTutor && <TutorIcon className={styles.participantIcon} />}
                                                                    {getUser(session_id)?.isAdmin && <CopIcon className={styles.participantIcon} />}
                                                                    {getUser(session_id)?.name} {session_id === localSessionId ? `${getUser(session_id)?.surname} (Tu)` : getUser(session_id)?.surname}
                                                                </div>
                                                            }
                                                            {!getUser(session_id)?.role &&
                                                                <div className={styles.participantNameText}>
                                                                    <UserIcon className={styles.participantIcon} />
                                                                    {getUser(session_id)?.name} {session_id === localSessionId ? `${getUser(session_id)?.surname} (Tu)` : (getUser(session_id)?.surname ? (isSharing(localSessionId) ? `${getUser(session_id)?.surname?.[0]}.` : getUser(session_id)?.surname) : '')}
                                                                </div>
                                                            }
                                                        </div>
                                                        <AudioObserver key={`audio-observer-${session_id}`} session_id={session_id} onVolumeChange={(level) => {
                                                            const lvl = parseFloat(level) || 0
                                                            remoteAudioLevels.current[session_id] = lvl
                                                            setSpeakingMap(prev => {
                                                                const prevSpeaking = !!prev[session_id]
                                                                const nowSpeaking = prevSpeaking ? (lvl > SPEAK_OFF) : (lvl > SPEAK_ON)
                                                                if (nowSpeaking === prevSpeaking) return prev
                                                                return { ...prev, [session_id]: nowSpeaking }
                                                            })
                                                            if (session_id === localSessionId) {
                                                                setLocalAudioLevel(lvl)
                                                            }
                                                        }} />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    }
                                </>
                            }

                            {audioErrors.length > 0 &&
                                <div className={styles.overlay}>
                                    <p>
                                        Sembra ci siano degli errori con l'audio di alcuni partecipanti,
                                        <span><Button appearance="text" style={{ padding: '0 0.25rem', whiteSpace: 'nowrap' }} onClick={onPlayRetry}>CLICCA QUI</Button></span>per riprovare</p>
                                </div>
                            }
                        </>
                    }

                    {['left-meeting', 'error'].includes(meetingState) &&
                        <div className={styles.noMeeting}>
                            {meetingState === 'left-meeting' &&
                                <>
                                    <div className={styles.leftMeeting}>
                                        Lezione Terminata
                                    </div>
                                    <Button style={{ padding: '1rem 3rem', fontSize: '1.125rem' }} onClick={() => { window.location.href = '/' }}>TORNA ALLA HOME</Button>
                                    <Button appearance="text" style={{ padding: 0 }} onClick={() => { window.location.reload() }}>RIENTRA NELLA LEZIONE</Button>
                                </>
                            }
                        </div>
                    }

                    <Each of={floatingReactions.filter(fr => fr.group === selectedGroup)} render={(fr) => {
                        return <div id={`floating-reaction-${fr.id}`} key={fr.id} className={styles.floatingReaction} style={{
                            left: `${fr.left}%`
                        }} >
                            <div className={styles.reactionEmoji}>
                                {fr.reaction}
                            </div>
                            <div className={styles.reactionUser}>
                                {fr.user?.name ?? ''} {fr.user?.surname ? (isSharing(localSessionId) ? `${fr.user.surname[0]}.` : `${fr.user.surname}`) : ''}
                            </div>
                        </div>
                    }} />

                </div>

                {/* SIDEBAR */}
                <div className={`${styles.side} ${sidebar ? styles.open : ''} ${((fullScreenParticipant || whiteboard || pdf) && width > 768) ? styles.fixed : ''}`}>
                    <CloseIcon className={styles.closeSide} onClick={() => setSidebar(false)} />
                    <TabIconSwitcher
                        names={width > 768}
                        theme={theme}
                        tabs={[
                            { icon: <UsersIcon />, name: 'Utenti', hidden: accessState !== DailyAccessState.Full, badge: waitingParticipants.length + Object.keys(screenSharingRequests).length + handRaisedIds.length > 0 ? waitingParticipants.length + Object.keys(screenSharingRequests).length + handRaisedIds.length : null },
                            { icon: <ChatIcon />, name: 'Chat', badge: (unread + lobbyUnread + teachersUnread) > 0 ? (unread + lobbyUnread + teachersUnread) : null },
                            { icon: <FolderIcon />, name: 'Materiali', badge: materialBadge > 0 ? materialBadge : null, hidden: accessState !== DailyAccessState.Full },
                            { icon: <SettingsIcon />, name: 'Impostazioni', hidden: accessState !== DailyAccessState.Full },
                        ]}
                        selected={selectedTab}
                        onSelect={(index) => {
                            setSelectedTab(index)
                            if (index === 1) {
                                setUnread(0)
                            }
                            if (index === 2) {
                                setMaterialBadge(0)
                            }
                        }}
                    />
                    {selectedTab === 0 &&
                        <div className={styles.users}>
                            <div className={styles.settingsSection}>
                                <div className={styles.sectionTitle}>
                                    <TeacherIcon className={styles.sectionIcon} />
                                    docenti e tutor ({teachers.length})
                                </div>
                                <Each of={teachers}
                                    render={(session_id, index) => {
                                        const user = getUser(session_id)
                                        const isTeacher = user?.role === 'teacher'
                                        const isTutor = user?.role === 'tutor'
                                        const isAdmin = user?.role && !['teacher', 'tutor'].includes(user?.role)
                                        return (
                                            <div className={styles.user} key={`list-${session_id}`}>
                                                <div className={styles.userPictureWrapper}>
                                                    <img className={styles.userPicture} src={getUser(session_id)?.picture ?? UserPlaceholder} alt="User" />
                                                    <PinIcon className={`${styles.userPin} ${pinnedIds.includes(session_id) ? styles.pinned : ''} ${isMobile ? styles.mobile : ''}`} onClick={() => {
                                                        togglePinned(session_id)
                                                    }} />
                                                </div>
                                                <div className={styles.userInfo}>
                                                    <div className={styles.userName}>{getUser(session_id)?.name ?? ''} {getUser(session_id)?.surname ?? ''} {session_id === localSessionId ? '(Tu)' : ''}</div>
                                                    <div className={styles.userRole}>
                                                        {isAdmin && <CopIcon className={styles.userIcon} style={{ width: '14px', height: '14px', minHeight: '14px', minWidth: '14px' }} />}
                                                        {isTeacher && <TeacherIcon className={styles.userIcon} style={{ width: '14px', height: '14px', minHeight: '14px', minWidth: '14px' }} />}
                                                        {isTutor && <TutorIcon className={styles.userIcon} style={{ width: '14px', height: '14px', minHeight: '14px', minWidth: '14px' }} />}
                                                        {isTeacher && 'Docente'}
                                                        {isTutor && 'Tutor'}
                                                        {isAdmin && 'Amministratore'}
                                                    </div>
                                                    <div className={styles.userRole}>
                                                        {sessionData?.groups && sessionData?.[`teachers_group_${session_id}`] &&
                                                            `${groups.find((g) => sessionData?.[`teachers_group_${session_id}`] === g.id)?.name}`
                                                        }
                                                        {sessionData?.groups && !sessionData?.[`teachers_group_${session_id}`] &&
                                                            `Stanza principale`
                                                        }
                                                    </div>
                                                </div>
                                                {hasHandRaised(session_id) &&
                                                    <HandIcon className={styles.userIcon} onClick={() => {
                                                        handleRaiseHand(session_id)
                                                    }} />
                                                }
                                                {isSharing(session_id) &&
                                                    <ScreenShareStopIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setScreenShare: false }) }} />
                                                }
                                                {hasMic(session_id) &&
                                                    <MicIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setAudio: false }) }} />
                                                }
                                                {!hasMic(session_id) &&
                                                    <MicOffIcon className={`${styles.userIcon} ${session_id !== localSessionId ? styles.disabled : ''}`} onClick={() => {
                                                        if (session_id === localSessionId) {
                                                            call.updateParticipant(session_id, { setAudio: true })
                                                        }
                                                        if ((isTeacher || isTutor) && session_id !== localSessionId) {
                                                            setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                        }
                                                    }} />
                                                }
                                                {hasCam(session_id) &&
                                                    <CamIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setVideo: false }) }} />
                                                }
                                                {!hasCam(session_id) &&
                                                    <CamOffIcon className={`${styles.userIcon} ${session_id !== localSessionId ? styles.disabled : ''}`} onClick={() => {
                                                        if (session_id === localSessionId) {
                                                            call.updateParticipant(session_id, { setVideo: true })
                                                        }
                                                        if ((isTeacher || isTutor) && session_id !== localSessionId) {
                                                            setPrivacyUser({ session_id: session_id, media: 'Videocamera' })
                                                        }
                                                    }} />
                                                }
                                                {(session_id !== localSessionId && !isAdmin) &&
                                                    <MeatBallsMenu menuIconStyle={{ width: '20px', height: '20px', minWidth: '20px', minHeight: '20px', color: '#aaaaaa' }} actions={[
                                                        { label: "Rimuovi", icon: PersonDeleteIcon, style: { color: "var(--sf-red)", fontWeight: 500 }, onClick: () => { setRemoveParticipant(session_id) } }
                                                    ]} />
                                                }
                                            </div>
                                        )
                                    }} />
                            </div>
                            {waitingParticipants.length > 0 &&
                                <div className={styles.settingsSection}>
                                    <div className={styles.sectionTitle}>
                                        <HourglassIcon className={styles.sectionIcon} />
                                        in attesa ({waitingParticipants.length})
                                        <div className={styles.spacer}></div>
                                        <Button appearance="text" style={{ fontSize: '0.75rem' }} onClick={async () => {
                                            for (let w of waitingParticipants) {
                                                grantAccess(w.id)
                                                await acceptBackendParticipant(w.id)
                                            }
                                        }}>ACCETTA TUTTI</Button>
                                    </div>
                                    <Each of={waitingParticipants.sort((a, b) => {
                                        return a.name.localeCompare(b.name)
                                    })} render={(wp, index) => {
                                        return (
                                            <div className={styles.waitingParticipant} key={`waiting-${wp.id}`}>
                                                <img src={UserPlaceholder} className={styles.waitingParticipantPicture} alt="User" />
                                                <div className={styles.waitingParticipantName}>
                                                    {wp.name}
                                                </div>
                                                <TooltipWrapper text="Accetta">
                                                    <PeopleCheckIcon className={styles.userIcon} onClick={async () => {
                                                        grantAccess(wp.id)
                                                        await acceptBackendParticipant(wp.id)
                                                    }} />
                                                </TooltipWrapper>
                                            </div>
                                        )
                                    }} />
                                </div>
                            }
                            {Object.keys(screenSharingRequests).length > 0 &&
                                <div className={styles.settingsSection}>
                                    <div className={styles.sectionTitle}>
                                        <ScreenShareIcon className={styles.sectionIcon} />
                                        richieste di condivisione ({Object.keys(screenSharingRequests ?? {}).length})
                                    </div>
                                    <Each of={Object.keys(screenSharingRequests)}
                                        render={(session_id, index) => {
                                            if (session_id !== localSessionId) {
                                                return (
                                                    <div className={styles.user} key={`list-screenshare-${session_id}`}>
                                                        <img className={styles.userPicture} src={getUser(session_id)?.picture ?? UserPlaceholder} alt="User" />
                                                        {getUser(session_id)?.role &&
                                                            <div className={styles.userName}>{getUser(session_id)?.name ?? ''} {getUser(session_id)?.surname ?? ''} {session_id === localSessionId ? '(Tu)' : ''}</div>
                                                        }
                                                        {!getUser(session_id)?.role &&
                                                            <div className={styles.userName}>
                                                                {getUser(session_id)?.name ?? ''}
                                                                {getUser(session_id)?.surname ? (isSharingScreen ? ` ${getUser(session_id)?.surname?.[0]}.` : ` ${getUser(session_id)?.surname}`) : ''}
                                                            </div>
                                                        }

                                                        <CheckmarkCircleIcon className={`${styles.userIcon} ${styles.accept}`} onClick={() => { acceptScreenSharingRequest(session_id) }} />

                                                        <DismissCircleIcon className={`${styles.userIcon} ${styles.decline}`} onClick={() => { denyScreenSharingRequest(session_id) }} />

                                                    </div>
                                                )
                                            }
                                        }} />
                                </div>
                            }
                            <div className={styles.settingsSection}>
                                <div className={styles.sectionTitle}>
                                    <UsersIcon className={styles.sectionIcon} />
                                    presenti ({participants.filter((session_id) => {
                                        const user = getUser(session_id)
                                        if (!user?.role) {
                                            return true
                                        }
                                        return false
                                    }).length})
                                    <div className={styles.spacer} />
                                    <Button appearance="text" style={{ fontSize: '0.75rem' }} onClick={() => {
                                        setGroupsDialog(true)
                                    }}>{sessionData?.groups ? 'MODIFICA GRUPPI' : 'DIVIDI IN GRUPPI'}</Button>
                                </div>
                                {sessionData?.groups && sessionData?.groups?.length > 0 &&
                                    <>
                                        <div style={{ display: 'flex', flexDirection: 'column', border: '1px solid rgba(var(--text-rgb), 12%)', borderRadius: '0.5rem', padding: '0.5rem' }} >
                                            <div className={styles.sectionTitle} style={{ padding: '0.25rem' }}>
                                                Stanza principale ({
                                                    participants.filter(p =>
                                                        !groupsMap?.current?.[`students_group_${p}`] && !getUser(p)?.role
                                                    ).length
                                                })
                                            </div>
                                            <Each of={
                                                participants.filter(p =>
                                                    !groupsMap?.current?.[`students_group_${p}`] && !getUser(p)?.role
                                                )}
                                                render={(session_id) => {
                                                    const user = getUser(session_id)
                                                    if (!user?.role) {
                                                        return (
                                                            <div className={styles.user} key={`groups-main-room-${session_id}`}>
                                                                <div className={styles.userPictureWrapper}>
                                                                    <img className={styles.userPicture} src={getUser(session_id)?.picture ?? UserPlaceholder} alt="User" />
                                                                    <PinIcon className={`${styles.userPin} ${pinnedIds.includes(session_id) ? styles.pinned : ''} ${isMobile ? styles.mobile : ''}`} onClick={() => {
                                                                        togglePinned(session_id)
                                                                    }} />
                                                                </div>
                                                                <div className={styles.userInfo}>
                                                                    <div className={styles.userName}>
                                                                        {getUser(session_id)?.name ?? ''}
                                                                        {getUser(session_id)?.surname ? (isSharingScreen ? ` ${getUser(session_id)?.surname?.[0]}.` : ` ${getUser(session_id)?.surname}`) : ''}
                                                                    </div>
                                                                    {groups.find((g) => g.participants.includes(user?.id)) &&
                                                                        <div className={styles.userRole}>{groups.find((g) => g.participants.includes(user?.id)).name}</div>
                                                                    }
                                                                    {!groups.find((g) => g.participants.includes(user?.id)) &&
                                                                        <div className={styles.userRole}>Nessun Gruppo</div>
                                                                    }
                                                                </div>
                                                                {session_id === localSessionId &&
                                                                    <div className={styles.userName}>{context.user?.name ?? ''} {context.user?.surname ?? ''} (Tu)</div>
                                                                }
                                                                {hasHandRaised(session_id) &&
                                                                    <HandIcon className={styles.userIcon} onClick={() => {
                                                                        handleRaiseHand(session_id)
                                                                    }} />
                                                                }
                                                                {isSharing(session_id) &&
                                                                    <ScreenShareStopIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setScreenShare: false }) }} />
                                                                }
                                                                {hasMic(session_id) &&
                                                                    <MicIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setAudio: false }) }} />
                                                                }
                                                                {!hasMic(session_id) &&
                                                                    <MicOffIcon className={`${styles.userIcon}`} onClick={() => {
                                                                        return
                                                                        // window.parent.focus()
                                                                        // setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                                    }} />
                                                                }
                                                                {hasCam(session_id) &&
                                                                    <CamIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setVideo: false }) }} />
                                                                }
                                                                {!hasCam(session_id) &&
                                                                    <CamOffIcon className={`${styles.userIcon}`} onClick={() => {
                                                                        return
                                                                        // window.parent.focus()
                                                                        // setPrivacyUser({ session_id: session_id, media: 'Videocamera' })
                                                                    }
                                                                    } />
                                                                }
                                                                {session_id !== localSessionId &&
                                                                    <MeatBallsMenu menuIconStyle={{ width: '20px', height: '20px', minWidth: '20px', minHeight: '20px', color: '#aaaaaa' }} actions={[
                                                                        { label: "Rimuovi", icon: PersonDeleteIcon, style: { color: "var(--sf-red)", fontWeight: 500 }, onClick: () => { setRemoveParticipant(session_id) } }
                                                                    ]} />
                                                                }
                                                            </div>
                                                        )
                                                    }
                                                }} />
                                        </div>
                                        <Each of={sessionData?.groups} render={(group) => {
                                            return (
                                                <>
                                                    <div style={{ display: 'flex', flexDirection: 'column', border: '1px solid rgba(var(--text-rgb), 12%)', borderRadius: '0.5rem', padding: '0.5rem' }} >
                                                        <div className={styles.sectionTitle} style={{ padding: '0.25rem' }}>
                                                            {group.name} ({
                                                                participants.filter(p =>
                                                                    groupsMap?.current?.[`students_group_${p}`] === group.id && !getUser(p)?.role
                                                                ).length
                                                            })
                                                        </div>
                                                        <Each of={
                                                            participants.filter(p =>
                                                                groupsMap?.current?.[`students_group_${p}`] === group.id && !getUser(p)?.role
                                                            )
                                                        } render={(session_id, index) => {
                                                            const user = getUser(session_id)
                                                            if (!user?.role) {
                                                                return (
                                                                    <div className={styles.user} key={`group-${group.id}-${session_id}`}>
                                                                        <div className={styles.userPictureWrapper}>
                                                                            <img className={styles.userPicture} src={getUser(session_id)?.picture ?? UserPlaceholder} alt="User" />
                                                                            <PinIcon className={`${styles.userPin} ${pinnedIds.includes(session_id) ? styles.pinned : ''} ${isMobile ? styles.mobile : ''}`} onClick={() => {
                                                                                togglePinned(session_id)
                                                                            }} />
                                                                        </div>
                                                                        <div className={styles.userName}>
                                                                            {getUser(session_id)?.name ?? ''}
                                                                            {getUser(session_id)?.surname ? (isSharingScreen ? ` ${getUser(session_id)?.surname?.[0]}.` : ` ${getUser(session_id)?.surname}`) : ''}
                                                                        </div>
                                                                        {session_id === localSessionId &&
                                                                            <div className={styles.userName}>{context.user?.name ?? ''} {context.user?.surname ?? ''} (Tu)</div>
                                                                        }
                                                                        {hasHandRaised(session_id) &&
                                                                            <HandIcon className={styles.userIcon} onClick={() => {
                                                                                handleRaiseHand(session_id)
                                                                            }} />
                                                                        }
                                                                        {isSharing(session_id) &&
                                                                            <ScreenShareStopIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setScreenShare: false }) }} />
                                                                        }
                                                                        {hasMic(session_id) &&
                                                                            <MicIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setAudio: false }) }} />
                                                                        }
                                                                        {!hasMic(session_id) &&
                                                                            <MicOffIcon className={`${styles.userIcon}`} onClick={() => {
                                                                                return
                                                                                // window.parent.focus()
                                                                                // setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                                            }} />
                                                                        }
                                                                        {hasCam(session_id) &&
                                                                            <CamIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setVideo: false }) }} />
                                                                        }
                                                                        {!hasCam(session_id) &&
                                                                            <CamOffIcon className={`${styles.userIcon}`} onClick={() => {
                                                                                return
                                                                                // window.parent.focus()
                                                                                // setPrivacyUser({ session_id: session_id, media: 'Videocamera' })
                                                                            }
                                                                            } />
                                                                        }
                                                                        {session_id !== localSessionId &&
                                                                            <MeatBallsMenu menuIconStyle={{ width: '20px', height: '20px', minWidth: '20px', minHeight: '20px', color: '#aaaaaa' }} actions={[
                                                                                { label: "Rimuovi", icon: PersonDeleteIcon, style: { color: "var(--sf-red)", fontWeight: 500 }, onClick: () => { setRemoveParticipant(session_id) } }
                                                                            ]} />
                                                                        }
                                                                    </div>
                                                                )
                                                            }
                                                        }} />
                                                    </div>
                                                </>
                                            )
                                        }} />
                                    </>
                                }
                                {(!sessionData?.groups || sessionData?.groups?.length === 0) &&
                                    <Each of={participants}
                                        render={(session_id, index) => {
                                            const user = getUser(session_id)
                                            if (!user?.role) {
                                                return (
                                                    <div className={styles.user} key={`online-${session_id}`}>
                                                        <div className={styles.userPictureWrapper}>
                                                            <img className={styles.userPicture} src={getUser(session_id)?.picture ?? UserPlaceholder} alt="User" />
                                                            <PinIcon className={`${styles.userPin} ${pinnedIds.includes(session_id) ? styles.pinned : ''} ${isMobile ? styles.mobile : ''}`} onClick={() => {
                                                                togglePinned(session_id)
                                                            }} />
                                                        </div>
                                                        {getUser(session_id)?.role &&
                                                            <div className={styles.userName}>{getUser(session_id)?.name ?? ''} {getUser(session_id)?.surname ?? ''} {session_id === localSessionId ? '(Tu)' : ''}</div>
                                                        }
                                                        {!getUser(session_id)?.role &&
                                                            <div className={styles.userName}>
                                                                {getUser(session_id)?.name ?? ''}
                                                                {getUser(session_id)?.surname ? (isSharingScreen ? ` ${getUser(session_id)?.surname?.[0]}.` : ` ${getUser(session_id)?.surname}`) : ''}
                                                            </div>
                                                        }
                                                        {session_id === localSessionId &&
                                                            <div className={styles.userName}>{context.user?.name ?? ''} {context.user?.surname ?? ''} (Tu)</div>
                                                        }
                                                        {hasHandRaised(session_id) &&
                                                            <HandIcon className={styles.userIcon} onClick={() => {
                                                                handleRaiseHand(session_id)
                                                            }} />
                                                        }
                                                        {isSharing(session_id) &&
                                                            <ScreenShareStopIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setScreenShare: false }) }} />
                                                        }
                                                        {hasMic(session_id) &&
                                                            <MicIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setAudio: false }) }} />
                                                        }
                                                        {!hasMic(session_id) &&
                                                            <MicOffIcon className={`${styles.userIcon}`} onClick={() => {
                                                                return
                                                                // window.parent.focus()
                                                                // setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                            }} />
                                                        }
                                                        {hasCam(session_id) &&
                                                            <CamIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setVideo: false }) }} />
                                                        }
                                                        {!hasCam(session_id) &&
                                                            <CamOffIcon className={`${styles.userIcon}`} onClick={() => {
                                                                return
                                                                // window.parent.focus()
                                                                // setPrivacyUser({ session_id: session_id, media: 'Videocamera' })
                                                            }
                                                            } />
                                                        }
                                                        {session_id !== localSessionId &&
                                                            <MeatBallsMenu menuIconStyle={{ width: '20px', height: '20px', minWidth: '20px', minHeight: '20px', color: '#aaaaaa' }} actions={[
                                                                { label: "Rimuovi", icon: PersonDeleteIcon, style: { color: "var(--sf-red)", fontWeight: 500 }, onClick: () => { setRemoveParticipant(session_id) } }
                                                            ]} />
                                                        }
                                                    </div>
                                                )
                                            }
                                        }} />
                                }
                            </div>

                            <div className={styles.settingsSection}>
                                <div className={styles.sectionTitle}>
                                    <PersonDeleteIcon className={styles.sectionIcon} />
                                    assenti ({students?.filter((s) => !isOnline(s.id)).length})
                                </div>
                                <Each of={students?.filter((s) => !isOnline(s.id))}
                                    render={(student, index) => {
                                        return (
                                            <div className={styles.user} key={`offline-${student.id}`}>
                                                <div className={styles.userPictureWrapper}>
                                                    <img className={styles.userPicture} src={student?.picture ?? UserPlaceholder} alt="User" />
                                                </div>
                                                <div className={styles.userName}>
                                                    {student?.name ?? ''}
                                                    {student?.surname ? (isSharingScreen ? ` ${student?.surname?.[0]}.` : ` ${student?.surname}`) : ''}
                                                </div>
                                                {!notified.includes(student.id) &&
                                                    <NotificationIcon className={styles.userIcon} onClick={async () => { await notifyAbsents([student.id]) }} />
                                                }
                                                {notified.includes(student.id) &&
                                                    <NotificationOffIcon className={`${styles.userIcon} ${styles.disabled}`} />
                                                }
                                            </div>
                                        )

                                    }} />
                            </div>

                        </div>
                    }
                    {selectedTab === 1 &&
                        <>
                            <div className={styles.chat}>
                                <div className={styles.chatTabs}>
                                    <div className={`${styles.chatTab} ${selectedChatTab === 0 ? styles.active : ''}`} onClick={() => {
                                        setSelectedChatTab(0)
                                        setUnread(0)
                                    }}>
                                        <ChatIcon className={styles.chatTabIcon} />
                                        <div className={styles.chatTabLabel}>Chat</div>
                                        {unread > 0 &&
                                            <div className={styles.unread} style={{ right: 0 }}>{unread}</div>
                                        }
                                    </div>
                                    {waitingParticipants.length > 0 &&
                                        <div className={`${styles.chatTab} ${selectedChatTab === 1 ? styles.active : ''}`} onClick={() => {
                                            setSelectedChatTab(1)
                                            setLobbyUnread(0)
                                        }}>
                                            <ChatHourglassIcon className={styles.chatTabIcon} />
                                            <div className={styles.chatTabLabel}>Sala d'attesa</div>
                                            {lobbyUnread > 0 &&
                                                <div className={styles.unread} style={{ right: 0 }}>{lobbyUnread}</div>
                                            }
                                        </div>
                                    }
                                    <div className={`${styles.chatTab} ${selectedChatTab === 2 ? styles.active : ''}`} onClick={() => {
                                        setSelectedChatTab(2)
                                        setTeachersUnread(0)
                                    }}>
                                        <TeacherIcon className={styles.chatTabIcon} />
                                        <div className={styles.chatTabLabel}>Docenti</div>
                                        {teachersUnread > 0 &&
                                            <div className={styles.unread} style={{ right: 0 }}>{teachersUnread}</div>
                                        }
                                    </div>
                                </div>
                                {selectedChatTab === 1 &&
                                    <div className={typo.caption} style={{ color: 'var(--text)', padding: '0.5rem 0' }}>
                                        Questa è la chat della sala d'attesa, puoi inviare messaggi a tutti gli utenti in attesa di entrare nella lezione.
                                    </div>
                                }
                                {selectedChatTab === 2 && !chatLocked &&
                                    <div className={typo.caption} style={{ color: 'var(--text)', padding: '0.5rem 0' }}>
                                        Questa è la chat dei docenti, i messaggi inviati qui saranno visibili solo ai docenti e ai tutor di questa lezione.
                                    </div>
                                }
                                {selectedGroup && selectedChatTab === 0 &&
                                    <div className={typo.caption} style={{ color: 'var(--text)', padding: '0.5rem 0' }}>
                                        Questa è la chat del gruppo, i messaggi inviati qui saranno visibili solo agli utenti di questo gruppo.
                                    </div>
                                }
                                <div className={styles.messages} ref={messageRef}>
                                    {isSharingScreen && !whiteboard && !pdf && selectedChatTab === 2 && chatLocked &&
                                        <div className={styles.chatBlockedMessage}>
                                            <ChatWarningIcon className={styles.chatBlockedIcon} />
                                            <div className={styles.chatBlockedText}>
                                                <b>Attenzione!</b> <br /><br /> Stai condividendo lo schermo, i messaggi della chat dei docenti sono stati temporaneamente nascosti per <span><b>proteggere la tua privacy.</b></span> Cliccando sul bottone sotto potrai visualizzarli nuovamente, ma ricorda che <b><u>se hai condiviso questa finestra o l'intero schermo</u></b> tutti i partecipanti alla lezione potranno vedere ciò che è mostrato sul tuo schermo.
                                            </div>
                                            <div className={styles.chatBlockAction} onClick={() => {
                                                setChatLocked(false)
                                            }}>VISUALIZZA MESSAGGI</div>
                                        </div>
                                    }
                                    {((selectedChatTab === 2 && !isSharingScreen) || selectedChatTab !== 2 || !chatLocked) &&
                                        <Each of={selectedChatTab === 0 ? (selectedGroup ? groupMessages : messages.filter(m => !m.group)) : (selectedChatTab === 2 ? teachersMessages : lobbyMessages)} render={(msg, index) => {
                                            const m = selectedChatTab === 0 ? (selectedGroup ? groupMessages : messages.filter(m => !m.group)) : (selectedChatTab === 2 ? teachersMessages : lobbyMessages)
                                            const prev = m[index - 1];
                                            const next = m[index + 1];
                                            const isFirstOfGroup = !prev || prev.sender.id !== msg.sender.id;
                                            const isLastOfGroup = !next || next.sender.id !== msg.sender.id;
                                            return (
                                                <div className={`${styles.message} ${styles[msg.type]} ${isFirstOfGroup ? styles.first : ''} ${isLastOfGroup ? styles.last : ''}`} key={index}>
                                                    <div className={`${styles.messageBody} ${isFirstOfGroup ? styles.first : ''} ${isLastOfGroup ? styles.last : ''}`}>
                                                        {isLastOfGroup && msg.type === 'received' &&
                                                            <div className={`${styles.sender} ${msg.sender?.role ? styles[['teacher', 'tutor'].includes(msg.sender?.role) ? msg.sender?.role : 'admin'] : ''}`}>
                                                                {msg.sender.role &&
                                                                    <>
                                                                        {msg.sender.role === 'teacher' && <TeacherIcon className={styles.senderIcon} />}
                                                                        {msg.sender.role === 'tutor' && <TutorIcon className={styles.senderIcon} />}
                                                                        {!['teacher', 'tutor'].includes(msg.sender.role) && <CopIcon className={styles.senderIcon} />}
                                                                        {msg.sender.name} {msg.sender.surname}
                                                                    </>
                                                                }
                                                                {!msg.sender.role &&
                                                                    <>{msg.sender.name} {msg.sender.surname ? (isSharingScreen ? `${msg.sender.surname?.[0]}.` : msg.sender.surname) : ''}</>
                                                                }
                                                            </div>
                                                        }
                                                        {msg.media &&
                                                            <div className={styles.file}>
                                                                <div className={styles.fileInfo}>
                                                                    <div className={styles.fileName}>
                                                                        {msg.media?.name}
                                                                    </div>
                                                                    <div className={styles.fileSize}>
                                                                        {formatFileSize(msg.media?.size)}
                                                                    </div>
                                                                </div>
                                                                <button className={styles.fileDownload} onClick={async () => {
                                                                    const outsideRes = await fetch(msg.media?.url);
                                                                    const blob = await outsideRes.blob();
                                                                    const url = URL.createObjectURL(blob);

                                                                    const link = document.createElement("a");
                                                                    link.href = url;
                                                                    link.download = msg.media?.name;
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    if (link.parentNode) link.parentNode.removeChild(link);
                                                                    URL.revokeObjectURL(url);
                                                                }}>
                                                                    <DownloadIcon />
                                                                </button>
                                                            </div>
                                                        }
                                                        <div className={styles.messageText}>
                                                            <Linkify>{msg.body}</Linkify>
                                                            <div className={`${styles.messageTime} ${farMultipleOf(msg.body, messageLength) ? styles.absolute : ''}`}>{formatTimeV2(msg.created_at, null, 'it', false)}</div>
                                                        </div>
                                                    </div>
                                                    {isFirstOfGroup && msg.type !== 'sent' &&
                                                        <img className={styles.messagePicture} src={msg.sender.picture ?? UserPlaceholder} alt="User" />
                                                    }
                                                </div>
                                            )
                                        }} />
                                    }
                                </div>
                                {file &&
                                    <div className={styles.file}>
                                        <div className={styles.fileInfo}>
                                            <div className={styles.fileName}>
                                                {file.name}
                                            </div>
                                            <div className={styles.fileSize}>
                                                {formatFileSize(file.size)}
                                            </div>
                                        </div>
                                        <button className={styles.fileDelete} onClick={() => {
                                            setFile(null)
                                        }}>
                                            <CloseIcon />
                                        </button>
                                    </div>
                                }
                                <div className={styles.input}>
                                    <input disabled={sending} type='file' id='file' ref={fileRef} style={{ display: 'none' }} onChange={handleFileChange} multiple={false} />
                                    <FileIcon className={styles.fileIcon} onClick={() => {
                                        if (fileRef && fileRef.current) {
                                            fileRef.current.click()
                                        }
                                    }} />
                                    <TextareaAutosize
                                        style={{ height: 'unset' }}
                                        ref={inputRef}
                                        value={message.body}
                                        minRows={1}
                                        maxRows={message.body !== '' ? 5 : 1}
                                        type="text"
                                        className={styles.messageInput}
                                        placeholder="messaggio..."
                                        onChange={handleMessageChange}
                                        onKeyDown={handleMessageKeyDown} />
                                    <SendIcon className={`${styles.sendIcon} ${sendDisabled ? styles.disabled : ''}`} onClick={sendMessage} />
                                </div>
                            </div>
                        </>
                    }
                    {selectedTab === 2 &&
                        <div className={styles.materials}>
                            {lesson?.materials &&

                                <div className={styles.settingsSection}>
                                    <div className={styles.sectionTitle}>
                                        <LessonIcon className={styles.sectionIcon} />
                                        lezione
                                    </div>
                                    <Each of={lesson?.materials ?? []} render={(material, index) => {
                                        return (
                                            <div className={styles.file} key={`lesson-material-${material.id}`}>
                                                <div className={styles.fileInfo}>
                                                    <div className={styles.fileName}>
                                                        {material.name}
                                                    </div>
                                                    <div className={styles.fileSize}>
                                                        {formatFileSize(material.size)}
                                                    </div>
                                                </div>
                                                <button className={styles.fileDownload} onClick={async () => {
                                                    const outsideRes = await fetch(material.url);
                                                    const blob = await outsideRes.blob();
                                                    const url = URL.createObjectURL(blob);

                                                    const link = document.createElement("a");
                                                    link.href = url;
                                                    link.download = material.name;
                                                    document.body.appendChild(link);
                                                    link.click();
                                                    if (link.parentNode) link.parentNode.removeChild(link);
                                                    URL.revokeObjectURL(url);
                                                }}>
                                                    <DownloadIcon />
                                                </button>
                                            </div>
                                        )
                                    }} />
                                </div>

                            }
                            {lesson?.module_materials &&

                                <div className={styles.settingsSection}>
                                    <div className={styles.sectionTitle}>
                                        <ModuleIcon className={styles.sectionIcon} />
                                        modulo
                                    </div>
                                    <Each of={lesson?.module_materials?.sort((a, b) => {
                                        return new Date(b.created_at) - new Date(a.created_at)
                                    }) ?? []} render={(material, index) => {
                                        return (
                                            <div className={styles.file} key={`module-material-${material.id}`}>
                                                <div className={styles.fileInfo}>
                                                    <div className={styles.fileName}>
                                                        {material.name}
                                                    </div>
                                                    <div className={styles.fileSize}>
                                                        {formatFileSize(material.size)}
                                                    </div>
                                                </div>
                                                <button className={styles.fileDownload} onClick={async () => {
                                                    const outsideRes = await fetch(material.url);
                                                    const blob = await outsideRes.blob();
                                                    const url = URL.createObjectURL(blob);

                                                    const link = document.createElement("a");
                                                    link.href = url;
                                                    link.download = material.name;
                                                    document.body.appendChild(link);
                                                    link.click();
                                                    if (link.parentNode) link.parentNode.removeChild(link);
                                                    URL.revokeObjectURL(url);
                                                }}>
                                                    <DownloadIcon />
                                                </button>
                                            </div>
                                        )
                                    }} />
                                </div>

                            }

                        </div>
                    }
                    {selectedTab === 3 &&
                        <div className={styles.settings}>
                            {width < 768 &&
                                <div className={styles.settingsSection}>
                                    <div className={styles.sectionTitle}>
                                        <NetworkCheckIcon className={styles.sectionIcon} />
                                        stato
                                    </div>
                                    <div className={styles.settingsStats}>
                                        <>
                                            {networkState === 'good' &&
                                                <TooltipWrapper style={tooltipStyle} html={"<b>Connessione buona</b>"}>
                                                    <WifiIcon className={`${styles.controlButton}`} style={{ color: 'var(--sf-green)', cursor: 'default', border: '1px solid rgba(var(--text-rgb), 12%)' }} />
                                                </TooltipWrapper>
                                            }
                                            {networkState === 'warning' &&
                                                <TooltipWrapper style={tooltipStyle} html={"<b>Connessione scarsa:</b><br>Potresti riscontrare ritardi nel video o nell'audio."}>
                                                    <WifiWarningIcon className={`${styles.controlButton}`} style={{ color: 'var(--sf-yellow)', cursor: 'default', border: '1px solid rgba(var(--text-rgb), 12%)' }} />
                                                </TooltipWrapper>
                                            }
                                            {networkState === 'bad' &&
                                                <TooltipWrapper style={tooltipStyle} html={"<b>Connessione molto scarsa:</b><br>Potresti non vedere o sentire i partecipanti."}>
                                                    <WifiOffIcon className={`${styles.controlButton}`} style={{ color: 'var(--sf-red)', cursor: 'default', border: '1px solid rgba(var(--text-rgb), 12%)' }} />
                                                </TooltipWrapper>
                                            }
                                            {state === 'high' &&
                                                <TooltipWrapper style={tooltipStyle} html={"<b>Carico CPU:</b> alto"}>
                                                    <PulseIcon className={`${styles.controlButton}`} style={{ color: 'var(--sf-yellow)', cursor: 'default', border: '1px solid rgba(var(--text-rgb), 12%)' }} />
                                                </TooltipWrapper>
                                            }
                                            {state === 'low' &&
                                                <TooltipWrapper style={tooltipStyle} html={"<b>Carico CPU:</b> basso"}>
                                                    <PulseIcon className={`${styles.controlButton}`} style={{ color: 'var(--sf-green)', cursor: 'default', border: '1px solid rgba(var(--text-rgb), 12%)' }} />
                                                </TooltipWrapper>
                                            }
                                        </>
                                    </div>
                                </div>
                            }
                            <div className={styles.settingsSection}>
                                <div className={styles.sectionTitle}>
                                    <MicIcon className={styles.sectionIcon} />
                                    microfono
                                </div>
                                <Select theme={theme}
                                    style={{ fontSize: '0.875rem' }}
                                    placeholder={"Nessun Microfono"}
                                    options={microphones}
                                    selected={microphones.find((m) => m.selected)}
                                    onSelect={(value) => {
                                        devices.setMicrophone(value.id)
                                    }}
                                />
                            </div>
                            <div className={styles.settingsSection}>
                                <div className={styles.sectionTitle}>
                                    <CamIcon className={styles.sectionIcon} />
                                    videocamera
                                </div>
                                <Select theme={theme}
                                    style={{ fontSize: '0.875rem' }}
                                    placeholder={"Nessuna Videocamera"}
                                    options={cameras}
                                    selected={cameras.find((c) => c.selected)}
                                    onSelect={(value) => {
                                        devices.setCamera(value.id)
                                    }}
                                />
                            </div>
                            <div className={styles.settingsSection}>
                                <div className={styles.sectionTitle}>
                                    <SpeakerIcon className={styles.sectionIcon} />
                                    altoparlante
                                </div>
                                <Select theme={theme}
                                    style={{ fontSize: '0.875rem' }}
                                    placeholder={'Predefinito'}
                                    options={speakers}
                                    selected={speakers.find((s) => s.selected)}
                                    onSelect={(value) => {
                                        devices.setSpeaker(value.id)
                                    }}
                                />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '1rem' }}>
                                <div className={styles.settingsSection}>
                                    <div className={styles.sectionTitle}>
                                        <ThemeIcon className={styles.sectionIcon} />
                                        aspetto
                                    </div>
                                    <TabIconSwitcher
                                        theme={theme}
                                        tabs={[
                                            { icon: <SunIcon />, name: 'Chiaro' },
                                            { icon: <MoonIcon />, name: 'Scuro' },
                                        ]} selected={theme === 'light' ? 0 : 1} onSelect={(index) => {
                                            setTheme(index === 0 ? 'light' : 'dark')
                                        }} />
                                </div>
                                {width <= 768 &&
                                    <div className={styles.settingsSection}>
                                        <div className={styles.sectionTitle}>
                                            <DesktopIcon className={styles.sectionIcon} />
                                            visuale
                                        </div>
                                        <TabIconSwitcher
                                            theme={theme}
                                            tabs={[
                                                { icon: <FullIcon />, name: 'Attivo' },
                                                { icon: <GridIcon />, name: 'Griglia' },
                                            ]} selected={view === 'full' ? 0 : 1} onSelect={(index) => {
                                                setView(index === 0 ? 'full' : 'grid')
                                            }} />
                                    </div>
                                }
                            </div>
                            <div className={styles.settingsSection}>
                                <div className={styles.sectionTitle}>
                                    <BackgroundEffectsIcon className={styles.sectionIcon} />
                                    effetti sfondo
                                </div>
                                <Select theme={theme}
                                    style={{ fontSize: '0.875rem' }}
                                    placeholder={'Nessuno'}
                                    options={backgroundEffects}
                                    selected={backgroundEffects.find((be) => be.value === selectedBackgroundEffect)}
                                    onSelect={(value) => {
                                        setSelectedBackgroundEffect(value.value)
                                        if (value.value === 'none') {
                                            call.updateInputSettings({
                                                video: {
                                                    processor: {
                                                        type: 'none',
                                                        config: {},
                                                    },
                                                },
                                            });
                                            setSelectedBackgroundImage(null)
                                        }
                                        if (value.value === 'blur') {
                                            setSelectedBackgroundImage(null)
                                            call.updateInputSettings({
                                                video: {
                                                    processor: {
                                                        type: 'background-blur',
                                                        config: { strength: blurStrength / 100 },
                                                    },
                                                },
                                            });
                                        }
                                        if (value.value === 'image') {
                                            setOpenBackgroundsDialog(true)
                                        }
                                    }}
                                />
                                {selectedBackgroundEffect === 'blur' &&

                                    <Slider
                                        theme={theme}
                                        level={blurStrength}
                                        onChange={(value) => {
                                            setBlurStrength(value < 1 ? 1 : value)
                                            call.updateInputSettings({
                                                video: {
                                                    processor: {
                                                        type: 'background-blur',
                                                        config: { strength: (value < 1 ? 1 : value) / 100 },
                                                    },
                                                },
                                            });
                                        }} />
                                }
                                {selectedBackgroundImage &&
                                    <div className={styles.backgroundWrapper} style={{ flexBasis: '100%', width: '100%' }}>
                                        <img className={`${styles.background}`} src={selectedBackgroundImage} alt="" style={{ cursor: 'default' }} />
                                        <div className={styles.backgroundEdit}>
                                            <EditIcon className={styles.editIcon} onClick={() => {
                                                setOpenBackgroundsDialog((true))
                                            }}></EditIcon>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className={styles.settingsSection}>
                                <div className={styles.sectionTitle}>
                                    <NoiseCancellationIcon className={styles.sectionIcon} />
                                    cancellazione del rumore (beta)

                                    <TooltipWrapper html={`<p style="text-transform: none; font-weight: 500;">La cancellazione del rumore attenua i rumori di fondo indesiderati, come il rumore della tastiera o il rumore del ventilatore. <br><br>È una funzionalità <b>beta</b>, se dovessi riscontrare problemi relativi all'audio, disattivala.</p>`}>
                                        <InfoIcon className={styles.sectionIcon} />
                                    </TooltipWrapper>
                                </div>
                                <Toggle checked={noiseCancellation} theme={theme} onChange={(checked) => {
                                    setNoiseCancellation(checked)
                                    call.updateInputSettings({
                                        audio: {
                                            processor: {
                                                type: checked ? 'noise-cancellation' : 'none'
                                            },
                                        },
                                    });
                                }} />
                            </div>
                        </div>
                    }
                </div>
            </div>

            {/* CONTROLS */}
            {
                !['left-meeting', 'error'].includes(meetingState) &&
                <div className={styles.controls}>
                    <TooltipWrapper text="Esci o Termina" style={tooltipStyle}>
                        <ExitIcon className={styles.exitButton} onClick={() => { setExitDialog(true) }} />
                    </TooltipWrapper>
                    <div className={styles.spacer} />

                    <div className={styles.warningWrapper}>
                        <TooltipWrapper text={localParticipant[0] ? 'Disattiva Microfono' : 'Attiva Microfono'} style={tooltipStyle}>
                            <div
                                style={{ position: 'relative' }}
                                className={styles.micWrapper}
                                onClick={() => {
                                    let audio = localParticipant[0]
                                    if (audio) {
                                        // setRemoteAudioLevels({ ...remoteAudioLevels, [localSessionId]: 0 })
                                        remoteAudioLevels.current[localSessionId] = 0
                                        setLocalAudioLevel(0)
                                        setSpeakingMap({ ...speakingMap, [localSessionId]: 0 })
                                    }
                                    call.setLocalAudio(!localParticipant[0])
                                }}>
                                {localParticipant[0] &&
                                    <>
                                        <div className={styles.audioLevel} style={{ height: `${localAudioLevel * 100}%` }}></div>
                                        <MicIcon className={styles.controlButton} style={{ backgroundColor: 'transparent' }} />
                                    </>
                                }
                                {!localParticipant[0] &&
                                    <MicOffIcon className={`${styles.controlButton} ${styles.disabled}`} />
                                }
                            </div>
                        </TooltipWrapper>
                        {micWarning &&
                            <TooltipWrapper html={`<p style="font-weight: 700">ATTENZIONE</p><p>Questo microfono è disattivato, controlla le impostazioni di sistema del tuo dispositivo.</p>`}>
                                <div className={styles.warning}>!</div>
                            </TooltipWrapper>
                        }
                    </div>

                    <TooltipWrapper text={localParticipant[1] ? 'Disattiva Videocamera' : 'Attiva Videocamera'} style={tooltipStyle}>
                        <div onClick={() => {
                            call.setLocalVideo(!localParticipant[1])
                        }}>
                            {localParticipant[1] &&
                                <CamIcon className={styles.controlButton} />
                            }
                            {!localParticipant[1] &&
                                <CamOffIcon className={`${styles.controlButton} ${styles.disabled}`} />
                            }
                        </div>
                    </TooltipWrapper>


                    <TooltipWrapper text={muted ? 'Attiva Audio' : 'Disattiva Audio'} style={tooltipStyle}>
                        <div onClick={() => {
                            setMuted(!muted)
                        }}>
                            {muted &&
                                <SpeakerOffIcon className={`${styles.controlButton} ${styles.disabled}`} />
                            }
                            {!muted &&
                                <SpeakerIcon className={styles.controlButton} />
                            }
                        </div>
                    </TooltipWrapper>


                    {accessState === DailyAccessState.Full &&
                        <>
                            {/* <HandIcon className={`${styles.controlButton} ${handRaisedIds.includes(localSessionId) ? styles.active : ''}`} onClick={() => { handleRaiseHand(localSessionId) }} /> */}
                            <Reactions reactions={reactions.reverse()} open={reactionsOpen} onClick={() => {
                                setReactionsOpen(!reactionsOpen)
                            }} onSend={(r) => {
                                sendAppMessage({ type: 'reaction', body: r, group: selectedGroup }, '*')
                                setFloatingReactions((prev) => [...prev, { id: uuidv4(), left: Math.floor(Math.random() * (30 - 10 + 1)) + 10, sessionId: localSessionId, user: { name: 'Tu' }, reaction: r, timestamp: Date.now(), group: selectedGroup }])

                            }} onClickOutside={() => {
                                setReactionsOpen(false)
                            }} tooltipStyle={tooltipStyle} />

                            <div className={styles.controlButtonWrapper} style={{ position: 'relative' }} ref={sharingRef}>
                                <div className={`${styles.reactions} ${sharingOpen ? styles.open : ''}`} >

                                    <TooltipWrapper text={whiteboard ? 'Chiudi Lavagna' : 'Lavagna'} style={tooltipStyle}>
                                        <div onClick={() => {
                                            if (whiteboard) {
                                                stopScreenShare()
                                                // Ferma anche le tracce della cattura per far sparire la barra di Chrome
                                                stopCapture()
                                                setWhiteboard(false)
                                                setFullScreenParticipant(null)
                                            }
                                            else {
                                                if (isSharingScreen) {
                                                    setScreenShareAlert('whiteboard')
                                                }
                                                else {
                                                    setView('full')
                                                    setFullScreenParticipant(localSessionId)
                                                    setWhiteboard(true)
                                                    // Richiesta di condivisione su gesto utente, per far apparire "Questa scheda"
                                                    startShareWithCrop('.excalidraw__canvas.static')
                                                }
                                            }
                                            setSharingOpen(false)
                                        }}>
                                            {whiteboard &&
                                                <WhiteboardIcon className={`${styles.controlButton} ${styles.disabled}`} />
                                            }
                                            {!whiteboard &&
                                                <WhiteboardIcon className={styles.controlButton} />
                                            }
                                        </div>
                                    </TooltipWrapper>

                                    <TooltipWrapper text={pdf ? 'Chiudi PDF' : 'PDF'} style={tooltipStyle}>
                                        <div onClick={() => {
                                            if (pdf) {
                                                stopScreenShare()
                                                stopCapture()
                                                setPdf(null)
                                                setFullScreenParticipant(null)
                                            }
                                            else {
                                                if (isSharingScreen) {
                                                    setScreenShareAlert('pdf')
                                                }
                                                else {
                                                    setView('full')
                                                    setFullScreenParticipant(localSessionId)
                                                    pickPdfFile()
                                                }
                                            }
                                            setSharingOpen(false)

                                        }}>
                                            {pdf &&
                                                <DocumentIcon className={`${styles.controlButton} ${styles.disabled}`} />
                                            }
                                            {!pdf &&
                                                <DocumentIcon className={styles.controlButton} />
                                            }
                                        </div>
                                    </TooltipWrapper>

                                    {!isMobile && !isTablet &&
                                        <TooltipWrapper text={(isSharingScreen && !whiteboard && !pdf) ? 'Disattiva Condivisione' : 'Schermo o Finestra'} style={tooltipStyle}>
                                            <div onClick={() => {
                                                if (isSharingScreen) {
                                                    if (whiteboard) {
                                                        setWhiteboardAlert(true)
                                                    }
                                                    else if (pdf) {
                                                        setPdfAlert(true)
                                                    }
                                                    else {
                                                        stopScreenShare()
                                                    }
                                                }
                                                else {
                                                    startScreenShare({ displayMediaOptions: { audio: true, systemAudio: 'include' } })
                                                    if (isSupported) {
                                                        startPiP()
                                                    }
                                                }
                                                setSharingOpen(false)

                                            }}>
                                                {isSharingScreen && !whiteboard && !pdf &&
                                                    <ScreenShareStopIcon className={`${styles.controlButton} ${styles.disabled}`} />
                                                }
                                                {(!isSharingScreen || (isSharingScreen && (whiteboard || pdf))) &&
                                                    <DesktopIcon className={styles.controlButton} />
                                                }
                                            </div>
                                        </TooltipWrapper>
                                    }
                                </div>
                                <TooltipWrapper text={'Condividi'} style={{ ...tooltipStyle, display: (sharingOpen || isMobile) ? 'none' : 'block' }}>
                                    <div style={{ position: 'relative' }}>
                                        <ScreenShareIcon className={`${styles.controlButton} ${sharingOpen ? styles.active : ''}`} onClick={() => {
                                            setSharingOpen(!sharingOpen)
                                        }} />
                                    </div>
                                </TooltipWrapper >
                            </div >

                            {width > 768 &&
                                <>

                                    <div className={styles.spacer} />

                                    <TooltipWrapper text="Utenti" style={tooltipStyle}>
                                        <div style={{ position: 'relative' }}>
                                            <UsersIcon className={`${styles.controlButton} ${sidebar && selectedTab === 0 ? styles.active : ''}`} onClick={() => {
                                                setSidebar(true)
                                                setSelectedTab(0)

                                            }} />
                                            {waitingParticipants.length + Object.keys(screenSharingRequests).length + handRaisedIds.length > 0 &&
                                                <div className={styles.unread}>{waitingParticipants.length + Object.keys(screenSharingRequests).length + handRaisedIds.length}</div>
                                            }
                                        </div>
                                    </TooltipWrapper>

                                    <TooltipWrapper text="Chat" style={tooltipStyle}>
                                        <div style={{ position: 'relative' }}>
                                            <ChatIcon
                                                className={`${styles.controlButton} ${sidebar && selectedTab === 1 ? styles.active : ''}`}
                                                onClick={() => {
                                                    setSidebar(true)
                                                    setSelectedTab(1)
                                                    if (selectedChatTab === 0) {
                                                        setUnread(0)
                                                    }
                                                    else if (selectedChatTab === 1) {
                                                        setLobbyUnread(0)
                                                    }
                                                    else if (selectedChatTab === 2) {
                                                        setTeachersUnread(0)
                                                    }
                                                }} />
                                            {(unread + lobbyUnread + teachersUnread) > 0 &&
                                                <div className={styles.unread}>{unread + lobbyUnread + teachersUnread}</div>
                                            }
                                        </div>
                                    </TooltipWrapper>

                                    <TooltipWrapper text="Materiali" style={tooltipStyle}>
                                        <div style={{ position: 'relative' }}>
                                            <FolderIcon className={`${styles.controlButton} ${sidebar && selectedTab === 2 ? styles.active : ''}`} onClick={() => {
                                                setSidebar(true)
                                                setSelectedTab(2)
                                                setMaterialBadge(0)
                                            }} />
                                            {materialBadge > 0 &&
                                                <div className={styles.unread}>{materialBadge}</div>
                                            }
                                        </div>
                                    </TooltipWrapper>

                                    <TooltipWrapper text="Impostazioni" style={tooltipStyle}>
                                        <div style={{ position: 'relative' }}>
                                            <SettingsIcon className={`${styles.controlButton} ${sidebar && selectedTab === 3 ? styles.active : ''}`} onClick={() => {
                                                setSidebar(true)
                                                setSelectedTab(3)
                                            }} />
                                        </div>
                                    </TooltipWrapper>
                                </>
                            }
                            {(fullScreenParticipant || whiteboard) && width <= 768 &&
                                <div style={{ position: 'relative' }}>
                                    <ChatIcon
                                        className={`${styles.controlButton} ${sidebar && selectedTab === 1 ? styles.active : ''}`}
                                        onClick={() => {
                                            setSidebar(true)
                                            setSelectedTab(1)
                                            setUnread(0)
                                        }} />
                                    {unread + teachersUnread + lobbyUnread > 0 &&
                                        <div className={styles.unread}>{unread + teachersUnread + lobbyUnread}</div>
                                    }
                                </div>
                            }
                        </>
                    }
                    {![DailyAccessState.Full, DailyAccessState.Lobby].includes(accessState) &&
                        <div className={styles.spacer} />

                    }
                </div>
            }

            {
                deviceError &&
                <>
                    {deviceError.type === 'permissions' &&
                        <AlertDialog
                            open={deviceError}
                            status={DialogStatus.Error}
                            errorMessage="Permessi Videocamera e Microfono"
                            text="Permessi videocamera o microfono non concessi. Aggiona i permessi dalle impostazioni del browser e ricarica la pagina."
                            onClose={() => {
                                setDeviceError(null)
                            }} />
                    }
                    {deviceError.type === 'not-found' &&
                        <AlertDialog
                            open={deviceError}
                            status={DialogStatus.Error}
                            errorMessage={"Dispositivo non trovato"}
                            text={deviceNotFoundText}
                            onClose={() => {
                                setDeviceError(null)
                            }} />
                    }
                </>
            }
            {
                nonFatalError &&
                <AlertDialog
                    open={nonFatalError}
                    status={DialogStatus.Error}
                    errorMessage={nonFatalError.title}
                    text={nonFatalError.message}
                    onClose={() => {
                        setNonFatalError(null)
                        if (isSharingScreen) {
                            stopScreenShare()
                        }
                    }} />
            }
            {
                fileAlert &&
                <AlertDialog
                    open={fileAlert}
                    errorMessage="File troppo grande"
                    text="La dimensione massima per i file è 16Mb."
                    status={DialogStatus.Error}
                    onClose={() => { setFileAlert(false) }}
                />
            }
            {whiteboardAlert &&

                <AlertDialog
                    open={whiteboardAlert}
                    title={"Chiudere la lavagna?"}
                    text="Avviando la condivisione schermo verrà chiusa la lavagna. Vuoi procedere?"
                    onClose={() => { setWhiteboardAlert(false) }}
                    actions={[
                        {
                            label: 'ANNULLA',
                            accentColor: 'var(--sf-red)',
                            onClick: () => {
                                setWhiteboardAlert(false)
                            }
                        },
                        {
                            label: 'CONFERMA',
                            onClick: () => {
                                setWhiteboardAlert(false)
                                // Chiudi la cattura corrente della lavagna per evitare doppie catture e barra persistente
                                stopCapture()
                                setWhiteboard(false)
                                setFullScreenParticipant(null)
                                startScreenShare({ displayMediaOptions: { audio: true, systemAudio: 'include' } })
                            }
                        }
                    ]}
                />
            }

            {pdfAlert &&

                <AlertDialog
                    open={pdfAlert}
                    title={"Chiudere il pdf?"}
                    text="Avviando la condivisione schermo verrà chiusa la visualizzazione del pdf. Vuoi procedere?"
                    onClose={() => { setPdfAlert(false) }}
                    actions={[
                        {
                            label: 'ANNULLA',
                            accentColor: 'var(--sf-red)',
                            onClick: () => {
                                setPdfAlert(false)
                            }
                        },
                        {
                            label: 'CONFERMA',
                            onClick: () => {
                                setPdfAlert(false)
                                // Chiudi la cattura corrente della lavagna per evitare doppie catture e barra persistente
                                stopCapture()
                                setPdf(null)
                                setFullScreenParticipant(null)
                                startScreenShare({ displayMediaOptions: { audio: true, systemAudio: 'include' } })
                            }
                        }
                    ]}
                />
            }

            {screenShareAlert &&

                <AlertDialog
                    open={screenShareAlert}
                    title={screenShareAlert === 'whiteboard' ? "Passare alla lavagna?" : "Passare al pdf?"}
                    text={`Attenzione, avviando ${screenShareAlert === 'whiteboard' ? 'la lavagna' : 'il visualizzatore pdf'} verrà terminata la condivisione attuale. Vuoi procedere?`}
                    onClose={() => { setScreenShareAlert(false) }}
                    actions={[
                        {
                            label: 'ANNULLA',
                            accentColor: 'var(--sf-red)',
                            onClick: () => {
                                setScreenShareAlert(false)
                            }
                        },
                        {
                            label: 'CONFERMA',
                            onClick: () => {
                                setScreenShareAlert(false)
                                stopScreenShare()
                                stopCapture()
                                setView('full')
                                if (screenShareAlert === 'whiteboard') {
                                    setWhiteboard(true)
                                    setFullScreenParticipant(localSessionId)
                                    setPdf(null)
                                }
                                if (screenShareAlert === 'pdf') {
                                    pickPdfFile()
                                    setWhiteboard(false)
                                }
                                // Richiesta di condivisione su gesto utente, per far apparire "Questa scheda"

                                if (screenShareAlert === 'whiteboard') {
                                    startShareWithCrop('.excalidraw__canvas.static')
                                }

                            }
                        }
                    ]}
                />

            }
            <Dialog open={openBackgroundsDialog} title={"Scegli uno sfondo"} onClose={() => { setOpenBackgroundsDialog(false) }}>
                <div className={styles.backgroundsDialog}>
                    <div className={styles.backgrounds}>
                        <Each of={backgroundImages} render={(bg, index) => {
                            return (
                                <div className={styles.backgroundWrapper} key={bg.url}>
                                    <img className={`${styles.background} ${bg.url === selectedBackgroundImage ? styles.selected : ''}`} src={bg.url} alt="" onClick={() => {
                                        setSelectedBackgroundImage(bg.url)
                                        call.updateInputSettings({
                                            video: {
                                                processor: {
                                                    type: 'background-image',
                                                    config: {
                                                        source: bg.url,
                                                    },
                                                },
                                            },
                                        });
                                    }} />
                                </div>
                            )
                        }} />
                    </div>
                </div>
            </Dialog>
            {
                exitDialog &&
                <AlertDialog
                    open={exitDialog}
                    title={"Uscire o Terminare?"}
                    text="Vuoi lasciare la lezione o terminarla per tutti?"
                    onClose={() => {
                        setExitDialog(false)
                    }}
                    actions={[
                        {
                            label: 'ESCI',
                            onClick: () => {
                                setExitDialog(false)
                                window.location.href = '/'
                            }
                        },
                        {
                            label: 'TERMINA',
                            accentColor: 'var(--sf-red)',
                            onClick: () => {
                                setExitDialog(false)
                                setConfirmTerminateLessonDialog(true)
                            }
                        }
                    ]}
                />
            }

            {
                confirmTerminateLessonDialog &&
                <AlertDialog
                    open={confirmTerminateLessonDialog}
                    title={"Terminare la lezione?"}
                    text="Terminando la lezione tutti i partecipanti saranno espulsi. Questa azione non può essere annullata"
                    onClose={() => {
                        setExitDialog(false)
                        setConfirmTerminateLessonDialog(false)
                        setTerminateStatus(null)
                    }}
                    actions={[
                        {
                            label: 'ANNULLA',
                            onClick: () => {
                                setExitDialog(false)
                                setConfirmTerminateLessonDialog(false)
                                setTerminateStatus(null)
                            }
                        },
                        {
                            label: 'TERMINA',
                            accentColor: 'var(--sf-red)',
                            status: terminateStatus,
                            disabled: terminateStatus === ButtonStatus.Loading,
                            onClick: async () => {
                                if (terminateStatus === ButtonStatus.Loading) {
                                    return
                                }

                                setTerminateStatus(ButtonStatus.Loading)

                                try {
                                    setSidebar(false)
                                    let updateList = {};
                                    for (let id in call.participants()) {
                                        if (id === 'local') {
                                            continue;
                                        }
                                        updateList[id] = { eject: true };
                                    }

                                    await terminateLesson(lesson.id);
                                    call.updateParticipants(updateList);
                                    call.leave()
                                    setExitDialog(false)
                                    setConfirmTerminateLessonDialog(false)
                                } catch (e) {
                                    console.error(e)
                                    setTerminateStatus(ButtonStatus.Error)
                                }
                            }
                        }
                    ]}
                />
            }

            {
                removeParticipant &&
                <AlertDialog
                    open={removeParticipant}
                    title={`Rimuovere ${getUser(removeParticipant)?.name} ${getUser(removeParticipant)?.surname}?`}
                    text="L'utente sarà rimosso dalla chiamata e avvisato. Potrà comunque rientrare."
                    onClose={() => {
                        setRemoveParticipant(null)
                    }}
                    actions={[
                        {
                            label: 'ANNULLA',
                            onClick: () => {
                                setRemoveParticipant(null)
                            }
                        },
                        {
                            label: 'RIMUOVI',
                            accentColor: 'var(--sf-red)',
                            onClick: async () => {
                                call.updateParticipant(removeParticipant, { eject: true });
                                setRemoveParticipant(null)
                            }
                        }
                    ]}
                />
            }

            {
                pipSupportDialog && !isMobile &&
                <AlertDialog
                    open={pipSupportDialog}
                    errorMessage="Funzionalità limitate"
                    text="Questo browser non supporta la funzionalità Document-Picture-in-Picture. Per utilizzare velv al massimo delle sue funzionalità, ti consigliamo di utilizzare Google Chrome dalla versione 116 in poi."
                    status={DialogStatus.Default}
                    actions={[
                        {
                            label: 'VAI AL DOWNLOAD',
                            onClick: () => {
                                window.open('https://www.google.it/intl/it/chrome/?_gl=1*cw009j*_up*MQ..&gclid=Cj0KCQjw2N2_BhCAARIsAK4pEkVD3-I0zoOuWEmHVgl_PXix28TwsFhxoJYpy5OcTuIKHGUY2QhqJ_AaAjC_EALw_wcB&gclsrc=aw.ds', '_blank')
                            }

                        }
                    ]}
                    onClose={() => { setPipSupportDialog(false) }}
                />
            }

            {
                privacyUser &&
                <AlertDialog
                    open={privacyUser}
                    title={`Attivare ${privacyUser.media}?`}
                    text={`Stai attivando ${privacyUser.media === 'Videocamera' ? 'la Videocamera' : 'il Microfono'} dell'utente, procedi solo se necessario.`}
                    status={DialogStatus.Default}
                    actions={[
                        {
                            label: 'ATTIVA',
                            onClick: () => {
                                if (privacyUser.media === 'Videocamera') {
                                    call.updateParticipant(privacyUser.session_id, { setVideo: true });
                                }
                                else {
                                    call.updateParticipant(privacyUser.session_id, { setAudio: true });
                                }
                                setPrivacyUser(null)
                            }

                        }
                    ]}
                    onClose={() => { setPrivacyUser(null) }}
                />
            }

            {
                unlockRoom &&
                <AlertDialog
                    open={unlockRoom}
                    title={roomLocked ? "Sbloccare la stanza?" : "Bloccare la stanza?"}
                    text={roomLocked ? `Procedendo ammetterai tutti i partecipanti in attesa e sbloccherai la stanza. Non sarà più necessario ammettere gli studenti alla lezione.` : 'Procedendo bloccherai la stanza. L\'accesso agli studenti che non hai già ammesso dovrà essere sempre approvato manualmente da un docente o da un tutor.'}
                    status={DialogStatus.Default}
                    actions={[
                        {
                            label: roomLocked ? 'SBLOCCA' : 'BLOCCA',
                            onClick: async () => {
                                roomLocked ? lockRoom(false) : lockRoom(true)
                                if (roomLocked) {
                                    for (let w of waitingParticipants) {
                                        grantAccess(w.id)
                                        await acceptBackendParticipant(w.id)
                                    }
                                }
                                setUnlockRoom(false)
                            }
                        }
                    ]}
                    onClose={() => { setUnlockRoom(false) }}
                />
            }

            <Dialog open={groupsDialog} title={"Gruppi di lavoro"}
                onClose={() => {
                    setGroups(sessionData?.groups ?? lesson?.options?.groups ?? [])
                    setGroupOptions(sessionData?.groupOptions ?? lesson?.options?.groupOptions ?? { autoDivision: false, nGroups: null, autoDivisionType: 'random', allowGroupChange: false })
                    setGroupsDialog(false)
                    setEditGroups(sessionData?.groups ?? lesson?.options?.groups ?? [])
                    setEditGroupOptions(sessionData?.groupOptions ?? lesson?.options?.groupOptions ?? { autoDivision: false, nGroups: null, autoDivisionType: 'random', allowGroupChange: false })
                }}
                action={
                    <div className={styles.groupsDialogActions} style={{ justifyContent: sessionData?.groups ? 'space-between' : 'flex-end' }}>
                        {sessionData?.groups &&
                            <Button
                                accentColor={'var(--sf-red)'}
                                onClick={async () => {
                                    setConfirmGroupsDeleteDialog(true)
                                }}>ELIMINA GRUPPI</Button>
                        }
                        <Button
                            disabled={!editGroups || editGroups.length === 0}
                            onClick={async () => {
                                if (meetingState === 'joined-meeting') {
                                    call.setMeetingSessionData({ groups: editGroups, groupOptions: editGroupOptions }, 'shallow-merge')
                                    setGroupsDialog(false)
                                }
                                try {
                                    setGroups([...editGroups])
                                    setGroupOptions({ ...editGroupOptions })
                                    await api.put(`/teacher/lessons/${lesson.id}`, { name: lesson.name, description: lesson.description, options: { groups: editGroups, groupOptions: editGroupOptions } })
                                }
                                catch (e) {
                                    console.error(e)
                                }
                            }}>CONFERMA</Button>
                    </div>
                }
            >
                <div className={styles.groupsDialog}>
                    <Checkbox label={"Assegna automaticamente i partecipanti ai gruppi"} value={groupOptions.autoDivision} labelPosition="end" onChange={(checked) => {
                        setEditGroupOptions({ ...groupOptions, autoDivision: checked })
                    }} />
                    {editGroupOptions.autoDivision &&
                        <>
                            <div className={styles.wrapper}>
                                <div className={typo.caption}>N. GRUPPI (MAX 15)</div>
                                <TextInput value={editGroupOptions.nGroups} type="number" placeholder={"N. di gruppi"} max={15} min={2} onKeyUp={(v) => {
                                    setEditGroupOptions({ ...editGroupOptions, nGroups: v })
                                }} />
                            </div>
                            <div className={styles.wrapper}>
                                <div className={typo.caption}>DIVIDI PER</div>
                                <Select options={groupDivisionOptions} selected={groupDivisionOptions.find(o => o.value === editGroupOptions.autoDivisionType) ?? groupDivisionOptions[0]} onSelect={(item) => {
                                    setEditGroupOptions({ ...editGroupOptions, autoDivisionType: item.value })
                                }} />
                            </div>
                        </>
                    }
                    <Button
                        disabled={!editGroupOptions.nGroups || editGroupOptions.nGroups < 2 || editGroupOptions.nGroups > 15 || !editGroupOptions.autoDivision || !editGroupOptions.autoDivisionType}
                        onClick={() => {
                            if (sessionData?.groups?.length > 0) {
                                setConfirmGroupReplace(true)
                            }
                            else {
                                if (editGroupOptions.nGroups >= 2 && editGroupOptions.nGroups <= 15) {
                                    generateGroups()
                                }
                            }
                        }}>GENERA GRUPPI</Button>

                    <div className={styles.dialogDivider}></div>
                    <div className={styles.wrapper}>
                        <div className={typo.caption}>GRUPPI</div>
                        <div className={styles.groups}>
                            <Each of={editGroups} render={(group, index) => (
                                <div className={`${styles.group} ${group.selected ? styles.selected : ''}`} key={index} onClick={() => {
                                    setEditGroups(editGroups.map((g, i) => {
                                        if (i === index) {
                                            return { ...g, selected: true }
                                        }
                                        return { ...g, selected: false }
                                    }))
                                }}>
                                    {group.name}
                                    <CloseIcon className={styles.deleteGroup} onClick={(e) => {
                                        e.stopPropagation()
                                        e.preventDefault()
                                        onGroupDelete(group.id)
                                    }} />

                                </div>
                            )} />
                            {editGroups.length < 15 &&
                                <button className={styles.addGroup} onClick={() => {
                                    setEditGroups([...editGroups.map((g) => {
                                        g.selected = false
                                        return g
                                    }), { id: uuidv4(), name: `Gruppo ${editGroups.length + 1}`, participants: [], selected: true, adding: false, toAdd: [] }])
                                }}>
                                    <CloseIcon className={styles.addGroupIcon} />
                                    <div className={typo.button}>AGGIUNGI GRUPPO</div>
                                </button>
                            }
                        </div>
                        {editGroups.find((g) => g.selected) &&
                            <div className={styles.groupParticipants}>
                                <div className={styles.groupParticipantsTitle}>
                                    <>
                                        {editGroups.find((g) => g.selected)?.participants?.length === 0 ?
                                            <div className={typo.headline}>Nessun partecipante</div> :
                                            <div className={typo.headline}>{editGroups.find((g) => g.selected).participants.length} partecipanti</div>
                                        }
                                        <Button
                                            disabled={!students?.find((s) => !editGroups.flatMap((g) => g.participants || []).includes(s.id))}
                                            appearance="text"
                                            onClick={() => {
                                                setEditGroups(editGroups.map((g) => {
                                                    if (g.selected) {
                                                        return { ...g, adding: true }
                                                    }
                                                    return g
                                                }))
                                            }}>AGGIUNGI</Button>
                                    </>
                                </div>
                                {editGroups.find((g) => g.selected)?.participants.length > 0 &&
                                    <Each of={editGroups.find((g) => g.selected)?.participants} render={(student, index) => {
                                        let user = students.find((s) => s.id === student)
                                        if (user) {
                                            return (
                                                <div className={styles.user} key={`groupParticipant-${user.id}`}>
                                                    <div className={styles.userPictureWrapper}>
                                                        <img className={styles.userPicture} src={user.picture ?? UserPlaceholder} alt="User" />
                                                    </div>
                                                    <div className={styles.userName} style={{ color: 'var(--text-color)' }}>
                                                        {user.name ?? ''}
                                                        {user.surname ? (isSharingScreen ? ` ${user.surname?.[0]}.` : ` ${user.surname}`) : ''}
                                                    </div>
                                                    <CloseIcon className={styles.removeGroupParticipant} onClick={() => {
                                                        setEditGroups(editGroups.map((g) => {
                                                            if (g.selected) {
                                                                return { ...g, participants: g.participants.filter((s) => s !== user.id) }
                                                            }
                                                            return g
                                                        }))
                                                    }} />
                                                </div>
                                            )
                                        }
                                    }} />
                                }
                            </div>
                        }
                    </div>
                    {/* </>
                    } */}
                </div>
            </Dialog>

            {
                editGroups.find((g) => g.adding) &&
                <Dialog
                    open={editGroups.find((g) => g.adding)} title={`Aggiungi partecipanti a ${editGroups.find((g) => g.adding).name}`} onClose={() => {
                        setEditGroups(editGroups.map((g) => {
                            if (g.adding) {
                                return { ...g, adding: false }
                            }
                            return g
                        }))
                    }}
                    action={<Button onClick={async () => {
                        setEditGroups(editGroups.map((g) => {
                            if (g.adding) {
                                return { ...g, adding: false, participants: [...g.participants, ...g.toAdd], toAdd: [] }
                            }
                            return g
                        }))
                    }}>CONFERMA</Button>}
                >
                    <div style={{ display: 'flex', padding: '1rem', width: '100%' }}>
                        <TextInput type="search" placeholder="Cerca..." onKeyUp={setAddGroupParticipantQuery} style={{ width: '100%' }} />
                    </div>
                    <div className={styles.addGroupsParticipantsDialog}>
                        <Each of={studentsParticipants.map(s => getUser(s)).filter((s) => !editGroups.flatMap((g) => g.participants || []).includes(s.id) && (`${s.name.trim().toLowerCase()}${s.surname.trim().toLowerCase()}`.includes(addGroupParticipantQuery.trim().toLowerCase()) || `${s.surname.trim().toLowerCase()}${s.name.trim().toLowerCase()}`.includes(addGroupParticipantQuery.trim().toLowerCase()))).sort((a, b) => {
                            return a.name?.localeCompare(b.name)
                        })} render={(user, index) => {
                            if (!user?.role) {
                                return (
                                    <div className={styles.user} style={{ cursor: 'pointer' }} key={`addGroupParticipant-${user.id}`} onClick={() => {
                                        setEditGroups(editGroups.map((g) => {
                                            if (g.adding) {
                                                if (g.toAdd.includes(user.id)) {
                                                    return { ...g, toAdd: g.toAdd.filter((s) => s !== user.id) }
                                                }
                                                return { ...g, toAdd: [...g.toAdd, user.id] }
                                            }
                                            return g
                                        }))
                                    }}>
                                        <div className={styles.userPictureWrapper}>
                                            <img className={styles.userPicture} src={user.picture ?? UserPlaceholder} alt="User" />
                                        </div>
                                        <div className={styles.userName} style={{ color: 'var(--text-color)' }}>
                                            {user.name ?? 'Nome'}
                                            {user.surname ? (isSharingScreen ? ` ${user.surname?.[0]}.` : ` ${user.surname}`) : ' Cognome'}
                                        </div>
                                        {editGroups.find((g) => g.adding)?.toAdd.includes(user.id) &&
                                            <CheckmarkCircleIcon />
                                        }
                                    </div>
                                )
                            }
                        }} />
                        {studentsParticipants.map(s => getUser(s)).filter((s) => !editGroups.flatMap((g) => g.participants || []).includes(s.id) && (`${s.name.trim().toLowerCase()}${s.surname.trim().toLowerCase()}`.includes(addGroupParticipantQuery.trim().toLowerCase()) || `${s.surname.trim().toLowerCase()}${s.name.trim().toLowerCase()}`.includes(addGroupParticipantQuery.trim().toLowerCase()))).length === 0 &&
                            <>Nessun partecipante trovato</>
                        }
                    </div>
                </Dialog>
            }

            {
                confirmGroupsDeleteDialog &&
                <AlertDialog
                    open={confirmGroupsDeleteDialog}
                    title={"Eliminare i gruppi di lavoro?"}
                    text="Tutti gli studenti saranno riportati nella stanza principale."
                    onClose={() => { setConfirmGroupsDeleteDialog(false) }}
                    actions={[
                        {
                            label: 'ANNULLA',
                            onClick: () => {
                                setConfirmGroupsDeleteDialog(false)
                            }
                        },
                        {
                            label: 'ELIMINA',
                            accentColor: 'var(--sf-red)',
                            disabled: deleteGroupsLoading,
                            onClick: async () => {
                                setDeleteGroupsLoading(true)
                                setGroupOptions({ autoDivision: false, nGroups: null, autoDivisionType: 'random', allowGroupChange: false })
                                setEditGroupOptions({ autoDivision: false, nGroups: null, autoDivisionType: 'random', allowGroupChange: false })
                                if (meetingState === 'joined-meeting') {
                                    call.setMeetingSessionData({ groups: null, groupOptions: null }, 'shallow-merge')
                                }
                                try {
                                    await api.put(`/teacher/lessons/${lesson.id}`, { name: lesson.name, description: lesson.description, options: { groups: null, groupOptions: null } })
                                }
                                catch (e) {
                                    console.error(e)
                                }
                                setDeleteGroupsLoading(false)
                                setConfirmGroupsDeleteDialog(false)
                                setGroupsDialog(false)
                                setSelectedGroup(null)
                            }
                        }
                    ]}
                />
            }

            {
                confirmGroupReplace &&
                <AlertDialog
                    open={confirmGroupReplace}
                    title={"Sono presenti dei gruppi"}
                    text="Attenzione, sono presenti dei gruppi di lavoro. Sostituendoli cambierai la divisione degli utenti. Potrai comunque annullare questa operazione non confermando le modifiche."
                    onClose={() => { setConfirmGroupReplace(false) }}
                    actions={[
                        {
                            label: 'ANNULLA',
                            onClick: () => {
                                setConfirmGroupReplace(false)
                            }
                        },
                        {
                            label: 'SOSTITUISCI',
                            accentColor: 'var(--sf-red)',
                            disabled: deleteGroupsLoading,
                            onClick: () => {
                                generateGroups()
                                setConfirmGroupReplace(false)
                            }
                        }
                    ]}
                />
            }

            {
                pipWindow && !pipWindow.closed && (
                    <PiPWindow
                        onOpen={(w, h) => {
                            setPipWidth(w)
                            setPipHeight(h)
                        }}
                        onResize={(w, h) => {
                            setPipWidth(w)
                            setPipHeight(h)
                        }}
                        pipWindow={pipWindow}
                        className={`${styles.container} ${theme === 'dark' ? styles.dark : ''}`}
                        styles={theme === 'dark' ?
                            {
                                '--background': 'var(--background-color)',
                                '--background-rgb': 'var(--background-color-rgb)',
                                '--background-secondary': 'var(--background-secondary-color)',
                                '--background-secondary-rgb': 'var(--background-secondary-color-rgb)',
                                '--text': 'var(--text-color)',
                                '--text-rgb': 'var(--text-color-rgb)',
                                '--audio-color': 'var(--primary-rgb)'
                            } :
                            {
                                '--background': ' var(--text-color)',
                                '--background-rgb': 'var(--text-color-rgb)',
                                '--background-secondary': 'rgb(58, 58, 58)',
                                '--background-secondary-rgb': '58, 58, 58',
                                '--text': 'var(--background-color)',
                                '--text-rgb': 'var(--background-color-rgb)',
                                '--audio-color': 'var(--secondary-rgb)'
                            }
                        }>
                        <div className={styles.pipWindow}>
                            <div className={styles.pipControls}>
                                <div className={styles.warningWrapper}>
                                    <div
                                        style={{ position: 'relative' }}
                                        className={styles.micWrapper}
                                        onClick={() => {
                                            let audio = localParticipant[0]
                                            if (audio) {
                                                // setRemoteAudioLevels({ ...remoteAudioLevels, [localSessionId]: 0 })
                                                remoteAudioLevels.current[localSessionId] = 0
                                                setLocalAudioLevel(0)
                                                setSpeakingMap({ ...speakingMap, [localSessionId]: 0 })
                                            }
                                            call.setLocalAudio(!localParticipant[0])
                                        }}>
                                        {localParticipant[0] &&
                                            <>
                                                <div className={styles.audioLevel} style={{ height: `${localAudioLevel * 100}%` }}></div>
                                                <MicIcon className={styles.controlButton} style={{ backgroundColor: 'transparent' }} />
                                            </>
                                        }
                                        {!localParticipant[0] &&
                                            <MicOffIcon className={`${styles.controlButton} ${styles.disabled}`} />
                                        }
                                    </div>
                                    {micWarning &&
                                        <div className={styles.warning}>!</div>
                                    }
                                </div>

                                <div onClick={() => {
                                    call.setLocalVideo(!localParticipant[1])
                                }}>
                                    {localParticipant[1] &&
                                        <CamIcon className={styles.controlButton} />
                                    }
                                    {!localParticipant[1] &&
                                        <CamOffIcon className={`${styles.controlButton} ${styles.disabled}`} />
                                    }
                                </div>

                                <div onClick={() => {
                                    setMuted(!muted)
                                }}>
                                    {muted &&
                                        <SpeakerOffIcon className={`${styles.controlButton} ${styles.disabled}`} />
                                    }
                                    {!muted &&
                                        <SpeakerIcon className={styles.controlButton} />
                                    }
                                </div>
                                <div onClick={() => {
                                    if (isSharingScreen) {
                                        stopScreenShare()
                                    } else {
                                        startScreenShare({ displayMediaOptions: { audio: true, systemAudio: 'include' } })
                                    }
                                }}>
                                    {isSharingScreen &&
                                        <ScreenShareStopIcon className={`${styles.controlButton} ${styles.disabled}`} />
                                    }
                                    {!isSharingScreen &&
                                        <ScreenShareIcon className={styles.controlButton} />
                                    }
                                </div>
                            </div>
                            {sessionData?.groups &&
                                <div className={styles.sessionGroups}>
                                    <div className={`${styles.sessionGroup} ${selectedGroup === null ? styles.selected : ''}`} onClick={() => {
                                        setSelectedGroup(null)
                                    }}>Stanza Principale</div>
                                    <Each of={sessionData.groups} render={(group, index) => {
                                        return (
                                            <div className={`${styles.sessionGroup} ${selectedGroup === group.id ? styles.selected : ''}`} key={index} onClick={() => {
                                                setSelectedGroup(group.id)
                                            }}>
                                                {group.name}
                                            </div>
                                        )
                                    }} />
                                </div>
                            }
                            {!pipSidebar &&
                                <div className={styles.pipParticipants} ref={mainPipRef}>
                                    <PackedGrid
                                        boxAspectRatio={16 / 9}
                                        className={styles.grid}
                                        updateLayoutRef={pipParticipantsRef}
                                        boxClassName={styles.participant}
                                    >
                                        {pipVisibleParticipants.map((session_id, index) => {
                                            let appendix = null
                                            const element = <div className={`${(shouldHighlightWhenSpeaks(session_id) && speakingMap?.[session_id] > 0) ? styles.active : ''}`} key={session_id}
                                            >
                                                <div className={theme === 'light' ? styles.participantBackground : styles.participantBackgroundDark}
                                                    style={{
                                                        '--color': isSharing(session_id) ? '#212121' : getUser(session_id)?.color ?? '#212121',
                                                        '--colorDark': isSharing(session_id) ? '#212121' : getUser(session_id)?.darkColor ?? '#212121'
                                                    }} />
                                                {(hasCam(session_id) || isSharing(session_id)) &&
                                                    <DailyVideo
                                                        key={`video-${session_id}`}
                                                        controls={false}
                                                        type={isSharing(session_id) ? 'screenVideo' : 'video'}
                                                        sessionId={session_id}
                                                        className={styles.participantVideo}
                                                        automirror={!isSharing(session_id) && session_id === localSessionId}
                                                        style={{ objectFit: isSharing(session_id) ? 'contain' : 'cover' }} />
                                                }

                                                <PinIcon className={`${styles.participantPin} ${pinnedIds.includes(session_id) ? styles.pinned : ''}`}
                                                    onClick={() => {
                                                        togglePinned(session_id)
                                                    }} />
                                                {!hasCam(session_id) && !isSharing(session_id) &&
                                                    <CamOffIcon className={styles.participantCamOff} />
                                                }
                                                <div className={styles.participantIndicators}>
                                                    {networkQualityMap?.[session_id] === 'warning' &&
                                                        <WifiWarningIcon className={styles.participantNetwork} style={{ color: 'var(--sf-yellow)' }} />
                                                    }
                                                    {networkQualityMap?.[session_id] === 'bad' &&
                                                        <WifiOffIcon className={styles.participantNetwork} style={{ color: 'var(--sf-red)' }} />
                                                    }
                                                    {handRaisedIds.includes(session_id) &&
                                                        <HandIcon className={styles.participantHand} />
                                                    }
                                                    {/* {(hasCam(session_id) || isSharing(session_id)) &&
                                                        <ScreenMaximizeIcon className={styles.participantFullscreen} onClick={() => {
                                                            setFullScreenParticipant(session_id)
                                                        }} />
                                                    } */}
                                                </div>
                                                {isMuted(session_id) &&
                                                    <div className={`${styles.participantMuted} ${isMuted(session_id) ? styles.disabled : ''}`}>
                                                        <SpeakerOffIcon />
                                                    </div>
                                                }
                                                <div className={`${styles.participantMic} ${!hasMic(session_id) ? styles.disabled : ''}`}>
                                                    {hasMic(session_id) &&
                                                        <MicIcon />
                                                    }
                                                    {!hasMic(session_id) &&
                                                        <MicOffIcon />
                                                    }
                                                </div>
                                                <div className={styles.participantName}>
                                                    {getUser(session_id)?.role &&
                                                        <div className={styles.participantNameText}>
                                                            {getUser(session_id)?.isTeacher && <TeacherIcon className={styles.participantIcon} />}
                                                            {getUser(session_id)?.isTutor && <TutorIcon className={styles.participantIcon} />}
                                                            {getUser(session_id)?.isAdmin && <CopIcon className={styles.participantIcon} />}
                                                            {getUser(session_id)?.name} {session_id === localSessionId ? `${getUser(session_id)?.surname} (Tu)` : getUser(session_id)?.surname}
                                                            {isSharing(session_id) && ' - Condivisione'}
                                                        </div>
                                                    }
                                                    {!getUser(session_id)?.role &&
                                                        <div className={styles.participantNameText}>
                                                            <UserIcon className={styles.participantIcon} />
                                                            {getUser(session_id)?.name} {session_id === localSessionId ? `${getUser(session_id)?.surname} (Tu)` : (getUser(session_id)?.surname ? (isSharing(localSessionId) ? `${getUser(session_id)?.surname?.[0]}.` : getUser(session_id)?.surname) : '')}
                                                            {isSharing(session_id) && ' - Condivisione'}
                                                        </div>
                                                    }
                                                </div>
                                                <AudioObserver key={`audio-observer-${session_id}`} session_id={session_id} onVolumeChange={(level) => {
                                                    const lvl = parseFloat(level) || 0
                                                    remoteAudioLevels.current[session_id] = lvl
                                                    setSpeakingMap(prev => {
                                                        const prevSpeaking = !!prev[session_id]
                                                        const nowSpeaking = prevSpeaking ? (lvl > SPEAK_OFF) : (lvl > SPEAK_ON)
                                                        if (nowSpeaking === prevSpeaking) return prev
                                                        return { ...prev, [session_id]: nowSpeaking }
                                                    })
                                                    if (session_id === localSessionId) {
                                                        setLocalAudioLevel(lvl)
                                                    }
                                                }} />
                                            </div>

                                            if (isSharing(session_id) && hasCam(session_id)) {
                                                appendix = <div id={`appendix-${session_id}`} key={`appendix-${session_id}`}>
                                                    <div className={theme === 'light' ? styles.participantBackground : styles.participantBackgroundDark}
                                                        style={{
                                                            '--color': isSharing(session_id) ? '#212121' : getUser(session_id)?.color ?? '#212121',
                                                            '--colorDark': isSharing(session_id) ? '#212121' : getUser(session_id)?.darkColor ?? '#212121'
                                                        }} />
                                                    {(hasCam(session_id) || isSharing(session_id)) &&
                                                        <DailyVideo
                                                            key={`video-${session_id}`}
                                                            controls={false}
                                                            type={'video'}
                                                            sessionId={session_id}
                                                            className={styles.participantVideo}
                                                            automirror={session_id === localSessionId}
                                                            style={{ objectFit: 'cover' }} />
                                                    }
                                                    {pinnedIds.includes(session_id) &&
                                                        <PinIcon className={styles.participantPin} />
                                                    }
                                                    {!hasCam(session_id) && !isSharing(session_id) &&
                                                        <CamOffIcon className={styles.participantCamOff} />
                                                    }
                                                    {isMuted(session_id) &&
                                                        <div className={`${styles.participantMuted} ${isMuted(session_id) ? styles.disabled : ''}`}>
                                                            <SpeakerOffIcon />
                                                        </div>
                                                    }
                                                    <div className={styles.participantIndicators}>
                                                        {networkQualityMap?.[session_id] === 'warning' &&
                                                            <WifiWarningIcon className={styles.participantNetwork} style={{ color: 'var(--sf-yellow)' }} />
                                                        }
                                                        {networkQualityMap?.[session_id] === 'bad' &&
                                                            <WifiOffIcon className={styles.participantNetwork} style={{ color: 'var(--sf-red)' }} />
                                                        }
                                                        {handRaisedIds.includes(session_id) &&
                                                            <HandIcon className={styles.participantHand} />
                                                        }
                                                        {/* {(hasCam(session_id) || isSharing(session_id)) &&
                                                            <ScreenMaximizeIcon className={styles.participantFullscreen} onClick={() => {
                                                                setFullScreenParticipant(session_id)
                                                            }} />
                                                        } */}
                                                    </div>
                                                    <div className={`${styles.participantMic} ${!hasMic(session_id) ? styles.disabled : ''}`}>
                                                        {hasMic(session_id) &&
                                                            <MicIcon onClick={() => {
                                                                call.updateParticipant(session_id, { setAudio: false })
                                                            }} />
                                                        }
                                                        {!hasMic(session_id) &&
                                                            <MicOffIcon onClick={() => {
                                                                if (session_id === localSessionId) {
                                                                    call.updateParticipant(session_id, { setAudio: true })
                                                                }
                                                                else {
                                                                    return
                                                                    // setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                                }
                                                            }} />
                                                        }
                                                    </div>
                                                    <div className={styles.participantName}>
                                                        {getUser(session_id)?.role &&
                                                            <div className={styles.participantNameText}>
                                                                {getUser(session_id)?.isTeacher && <TeacherIcon className={styles.participantIcon} />}
                                                                {getUser(session_id)?.isTutor && <TutorIcon className={styles.participantIcon} />}
                                                                {getUser(session_id)?.isAdmin && <CopIcon className={styles.participantIcon} />}
                                                                {getUser(session_id)?.name} {session_id === localSessionId ? `${getUser(session_id)?.surname} (Tu)` : getUser(session_id)?.surname}
                                                            </div>
                                                        }
                                                        {!getUser(session_id)?.role &&
                                                            <div className={styles.participantNameText}>
                                                                <UserIcon className={styles.participantIcon} />
                                                                {getUser(session_id)?.name} {session_id === localSessionId ? `${getUser(session_id)?.surname} (Tu)` : (getUser(session_id)?.surname ? (isSharing(localSessionId) ? `${getUser(session_id)?.surname?.[0]}.` : getUser(session_id)?.surname) : '')}
                                                            </div>
                                                        }
                                                    </div>
                                                    <AudioObserver key={`audio-observer-${session_id}`} session_id={session_id} onVolumeChange={(level) => {
                                                        const lvl = parseFloat(level) || 0
                                                        remoteAudioLevels.current[session_id] = lvl
                                                        setSpeakingMap(prev => {
                                                            const prevSpeaking = !!prev[session_id]
                                                            const nowSpeaking = prevSpeaking ? (lvl > SPEAK_OFF) : (lvl > SPEAK_ON)
                                                            if (nowSpeaking === prevSpeaking) return prev
                                                            return { ...prev, [session_id]: nowSpeaking }
                                                        })
                                                        if (session_id === localSessionId) {
                                                            setLocalAudioLevel(lvl)
                                                        }
                                                    }} />
                                                </div>
                                            }

                                            return appendix ? [element, appendix] : element

                                        })}

                                    </PackedGrid>
                                </div>
                            }
                            {pipSidebar &&
                                <>
                                    {selectedPipTab === 1 &&
                                        <div className={styles.chat}>
                                            <div className={styles.chatTabs}>
                                                <div className={`${styles.chatTab} ${selectedChatTab === 0 ? styles.active : ''}`} onClick={() => {
                                                    setSelectedChatTab(0)
                                                    setUnread(0)
                                                }}>
                                                    <ChatIcon className={styles.chatTabIcon} />
                                                    <div className={styles.chatTabLabel}>Chat</div>
                                                    {unread > 0 &&
                                                        <div className={styles.unread} style={{ right: 0 }}>{unread}</div>
                                                    }
                                                </div>
                                                {waitingParticipants.length > 0 &&
                                                    <div className={`${styles.chatTab} ${selectedChatTab === 1 ? styles.active : ''}`} onClick={() => {
                                                        setSelectedChatTab(1)
                                                        setLobbyUnread(0)
                                                    }}>
                                                        <ChatHourglassIcon className={styles.chatTabIcon} />
                                                        <div className={styles.chatTabLabel}>Sala d'attesa</div>
                                                        {lobbyUnread > 0 &&
                                                            <div className={styles.unread} style={{ right: 0 }}>{lobbyUnread}</div>
                                                        }
                                                    </div>
                                                }
                                                <div className={`${styles.chatTab} ${selectedChatTab === 2 ? styles.active : ''}`} onClick={() => {
                                                    setSelectedChatTab(2)
                                                    setTeachersUnread(0)
                                                }}>
                                                    <TeacherIcon className={styles.chatTabIcon} />
                                                    <div className={styles.chatTabLabel}>Docenti</div>
                                                    {teachersUnread > 0 &&
                                                        <div className={styles.unread} style={{ right: 0 }}>{teachersUnread}</div>
                                                    }
                                                </div>
                                            </div>
                                            {selectedChatTab === 1 &&
                                                <div className={typo.caption} style={{ color: 'var(--text)', padding: '0.5rem 0' }}>
                                                    Questa è la chat della sala d'attesa, puoi inviare messaggi a tutti gli utenti in attesa di entrare nella lezione.
                                                </div>
                                            }
                                            {selectedChatTab === 2 &&
                                                <div className={typo.caption} style={{ color: 'var(--text)', padding: '0.5rem 0' }}>
                                                    Questa è la chat dei docenti, i messaggi inviati qui saranno visibili solo ai docenti e ai tutor di questa lezione.
                                                </div>
                                            }
                                            {selectedGroup && selectedChatTab === 0 &&
                                                <div className={typo.caption} style={{ color: 'var(--text)', padding: '0.5rem 0' }}>
                                                    Questa è la chat del gruppo, i messaggi inviati qui saranno visibili solo agli utenti di questo gruppo.
                                                </div>
                                            }
                                            <div className={styles.messages} ref={pipMessageRef}>
                                                {isSharingScreen && !whiteboard && !pdf && selectedChatTab === 2 && chatLocked &&
                                                    <div className={styles.chatBlockedMessage}>
                                                        <ChatWarningIcon className={styles.chatBlockedIcon} />
                                                        <div className={styles.chatBlockedText}>
                                                            <b>Attenzione!</b> <br /><br /> Stai condividendo lo schermo, i messaggi della chat dei docenti sono stati temporaneamente nascosti per <span><b>proteggere la tua privacy.</b></span> Cliccando sul bottone sotto potrai visualizzarli nuovamente, ma ricorda che <b><u>se hai condiviso questa finestra o l'intero schermo</u></b> tutti i partecipanti alla lezione potranno vedere ciò che è mostrato sul tuo schermo.
                                                        </div>
                                                        <div className={styles.chatBlockAction} onClick={() => {
                                                            setChatLocked(false)
                                                        }}>VISUALIZZA MESSAGGI</div>
                                                    </div>
                                                }
                                                {((selectedChatTab === 2 && !isSharingScreen) || selectedChatTab !== 2 || !chatLocked) &&
                                                    <Each of={selectedChatTab === 0 ? (selectedGroup ? groupMessages : messages.filter(m => !m.group)) : (selectedChatTab === 2 ? teachersMessages : lobbyMessages)} render={(msg, index) => {
                                                        const m = selectedChatTab === 0 ? (selectedGroup ? groupMessages : messages.filter(m => !m.group)) : (selectedChatTab === 2 ? teachersMessages : lobbyMessages)
                                                        const prev = m[index - 1];
                                                        const next = m[index + 1];
                                                        const isFirstOfGroup = !prev || prev.sender.id !== msg.sender.id;
                                                        const isLastOfGroup = !next || next.sender.id !== msg.sender.id;

                                                        return (
                                                            <div className={`${styles.message} ${styles[msg.type]} ${isFirstOfGroup ? styles.first : ''} ${isLastOfGroup ? styles.last : ''}`} key={index}>
                                                                <div className={`${styles.messageBody} ${isFirstOfGroup ? styles.first : ''} ${isLastOfGroup ? styles.last : ''}`}>
                                                                    {isLastOfGroup && msg.type === 'received' &&
                                                                        <div className={`${styles.sender} ${msg.sender?.role ? styles[['teacher', 'tutor'].includes(msg.sender?.role) ? msg.sender?.role : 'admin'] : ''}`}>
                                                                            {msg.sender.role &&
                                                                                <>
                                                                                    {msg.sender.role === 'teacher' && <TeacherIcon className={styles.senderIcon} />}
                                                                                    {msg.sender.role === 'tutor' && <TutorIcon className={styles.senderIcon} />}
                                                                                    {!['teacher', 'tutor'].includes(msg.sender.role) && <CopIcon className={styles.senderIcon} />}
                                                                                    {msg.sender.name} {msg.sender.surname}
                                                                                </>
                                                                            }
                                                                            {!msg.sender.role &&
                                                                                <>{msg.sender.name} {msg.sender.surname ? (isSharingScreen ? `${msg.sender.surname?.[0]}.` : msg.sender.surname) : ''}</>
                                                                            }
                                                                        </div>
                                                                    }
                                                                    {msg.media &&
                                                                        <div className={styles.file}>
                                                                            <div className={styles.fileInfo}>
                                                                                <div className={styles.fileName}>
                                                                                    {msg.media?.name}
                                                                                </div>
                                                                                <div className={styles.fileSize}>
                                                                                    {formatFileSize(msg.media?.size)}
                                                                                </div>
                                                                            </div>
                                                                            <button className={styles.fileDownload} onClick={async () => {
                                                                                const outsideRes = await fetch(msg.media?.url);
                                                                                const blob = await outsideRes.blob();
                                                                                const url = URL.createObjectURL(blob);

                                                                                const link = document.createElement("a");
                                                                                link.href = url;
                                                                                link.download = msg.media?.name;
                                                                                document.body.appendChild(link);
                                                                                link.click();
                                                                                if (link.parentNode) link.parentNode.removeChild(link);
                                                                                URL.revokeObjectURL(url);
                                                                            }}>
                                                                                <DownloadIcon />
                                                                            </button>
                                                                        </div>
                                                                    }
                                                                    <div className={styles.messageText}>
                                                                        <Linkify>{msg.body}</Linkify>
                                                                        <div className={`${styles.messageTime} ${farMultipleOf(msg.body, pipMessageLength) ? styles.absolute : ''}`}>{formatTimeV2(msg.created_at, null, 'it', false)}</div>
                                                                    </div>
                                                                </div>
                                                                {isFirstOfGroup && msg.type !== 'sent' &&
                                                                    <img className={styles.messagePicture} src={msg.sender.picture ?? UserPlaceholder} alt="User" />
                                                                }
                                                            </div>
                                                        )
                                                    }} />
                                                }
                                            </div>
                                            {file &&
                                                <div className={styles.file}>
                                                    <div className={styles.fileInfo}>
                                                        <div className={styles.fileName}>
                                                            {file.name}
                                                        </div>
                                                        <div className={styles.fileSize}>
                                                            {formatFileSize(file.size)}
                                                        </div>
                                                    </div>
                                                    <button className={styles.fileDelete} onClick={() => {
                                                        setFile(null)
                                                    }}>
                                                        <CloseIcon />
                                                    </button>
                                                </div>
                                            }
                                            <div className={styles.input}>
                                                <input disabled={sending} type='file' id='file' ref={fileRef} style={{ display: 'none' }} onChange={handleFileChange} multiple={false} />
                                                <FileIcon className={styles.fileIcon} onClick={() => {
                                                    if (fileRef && fileRef.current) {
                                                        fileRef.current.click()
                                                    }
                                                }} />
                                                <TextareaAutosize
                                                    style={{ height: 'unset' }}
                                                    ref={inputRef}
                                                    value={message.body}
                                                    minRows={1}
                                                    maxRows={message.body !== '' ? 5 : 1}
                                                    type="text"
                                                    className={styles.messageInput}
                                                    placeholder="messaggio..."
                                                    onChange={handleMessageChange}
                                                    onKeyDown={handleMessageKeyDown} />
                                                <SendIcon className={`${styles.sendIcon} ${sendDisabled ? styles.disabled : ''}`} onClick={sendMessage} />
                                            </div>
                                        </div>
                                    }
                                    {selectedPipTab === 2 &&
                                        <div className={styles.users}>
                                            <div className={styles.settingsSection}>
                                                <div className={styles.sectionTitle}>
                                                    <TeacherIcon className={styles.sectionIcon} />
                                                    docenti e tutor ({teachers.length})
                                                </div>
                                                <Each of={teachers}
                                                    render={(session_id, index) => {
                                                        const user = getUser(session_id)
                                                        const isTeacher = user?.role === 'teacher'
                                                        const isTutor = user?.role === 'tutor'
                                                        const isAdmin = user?.role && !['teacher', 'tutor'].includes(user?.role)
                                                        return (
                                                            <div className={styles.user} key={`pip-participants-${session_id}`}>
                                                                <div className={styles.userPictureWrapper}>
                                                                    <img className={styles.userPicture} src={getUser(session_id)?.picture ?? UserPlaceholder} alt="User" />
                                                                    <PinIcon className={`${styles.userPin} ${pinnedIds.includes(session_id) ? styles.pinned : ''} ${isMobile ? styles.mobile : ''}`} onClick={() => {
                                                                        togglePinned(session_id)
                                                                    }} />
                                                                </div>
                                                                <div className={styles.userInfo}>
                                                                    <div className={styles.userName}>{getUser(session_id)?.name ?? ''} {getUser(session_id)?.surname ?? ''} {session_id === localSessionId ? '(Tu)' : ''}</div>
                                                                    <div className={styles.userRole}>
                                                                        {isAdmin && <CopIcon className={styles.userIcon} style={{ width: '14px', height: '14px', minHeight: '14px', minWidth: '14px' }} />}
                                                                        {isTeacher && <TeacherIcon className={styles.userIcon} style={{ width: '14px', height: '14px', minHeight: '14px', minWidth: '14px' }} />}
                                                                        {isTutor && <TutorIcon className={styles.userIcon} style={{ width: '14px', height: '14px', minHeight: '14px', minWidth: '14px' }} />}
                                                                        {isTeacher && 'Docente'}
                                                                        {isTutor && 'Tutor'}
                                                                        {isAdmin && 'Amministratore'}
                                                                    </div>
                                                                    <div className={styles.userRole}>
                                                                        {sessionData?.groups && sessionData?.[`teachers_group_${session_id}`] &&
                                                                            `${groups.find((g) => sessionData?.[`teachers_group_${session_id}`] === g.id)?.name}`
                                                                        }
                                                                        {sessionData?.groups && !sessionData?.[`teachers_group_${session_id}`] &&
                                                                            `Stanza principale`
                                                                        }
                                                                    </div>
                                                                </div>
                                                                {hasHandRaised(session_id) &&
                                                                    <HandIcon className={styles.userIcon} onClick={() => {
                                                                        handleRaiseHand(session_id)
                                                                    }} />
                                                                }
                                                                {isSharing(session_id) &&
                                                                    <ScreenShareStopIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setScreenShare: false }) }} />
                                                                }
                                                                {hasMic(session_id) &&
                                                                    <MicIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setAudio: false }) }} />
                                                                }
                                                                {!hasMic(session_id) &&
                                                                    <MicOffIcon className={`${styles.userIcon} ${session_id !== localSessionId ? styles.disabled : ''}`} onClick={() => {
                                                                        if (session_id === localSessionId) {
                                                                            call.updateParticipant(session_id, { setAudio: true })
                                                                        }
                                                                        else {
                                                                            window.parent.focus()
                                                                            setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                                        }
                                                                        // setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                                    }} />
                                                                }
                                                                {hasCam(session_id) &&
                                                                    <CamIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setVideo: false }) }} />
                                                                }
                                                                {!hasCam(session_id) &&
                                                                    <CamOffIcon className={`${styles.userIcon} ${session_id !== localSessionId ? styles.disabled : ''}`} onClick={() => {
                                                                        if (session_id === localSessionId) {
                                                                            call.updateParticipant(session_id, { setVideo: true })
                                                                        }
                                                                        else {
                                                                            window.parent.focus()
                                                                            setPrivacyUser({ session_id: session_id, media: 'Videocamera' })
                                                                        }
                                                                        // call.updateParticipant(session_id, { setVideo: true })
                                                                    }}
                                                                    />
                                                                }
                                                                {(session_id !== localSessionId && !isAdmin) &&
                                                                    <MeatBallsMenu menuIconStyle={{ width: '20px', height: '20px', minWidth: '20px', minHeight: '20px', color: '#aaaaaa' }} actions={[
                                                                        { label: "Rimuovi", icon: PersonDeleteIcon, style: { color: "var(--sf-red)", fontWeight: 500 }, onClick: () => { setRemoveParticipant(session_id) } }
                                                                    ]} />
                                                                }
                                                            </div>
                                                        )
                                                    }} />
                                            </div>
                                            {waitingParticipants.length > 0 &&
                                                <div className={styles.settingsSection}>
                                                    <div className={styles.sectionTitle}>
                                                        <HourglassIcon className={styles.sectionIcon} />
                                                        in attesa ({waitingParticipants.length})
                                                        <div className={styles.spacer}></div>
                                                        <Button appearance="text" style={{ fontSize: '0.75rem' }} onClick={() => {
                                                            for (let w of waitingParticipants) {
                                                                grantAccess(w.id)
                                                            }
                                                        }}>ACCETTA TUTTI</Button>
                                                    </div>
                                                    <Each of={waitingParticipants.sort((a, b) => {
                                                        return a.name.localeCompare(b.name)
                                                    })} render={(wp, index) => {
                                                        return (
                                                            <div className={styles.waitingParticipant} key={`pip-waiting-participant-${wp.id}`}>
                                                                <img src={UserPlaceholder} className={styles.waitingParticipantPicture} alt="User" />
                                                                <div className={styles.waitingParticipantName}>
                                                                    {wp.name}
                                                                </div>
                                                                <TooltipWrapper text="Accetta">
                                                                    <PeopleCheckIcon className={styles.userIcon} onClick={async () => {
                                                                        grantAccess(wp.id)
                                                                        await acceptBackendParticipant(wp.id)
                                                                    }} />
                                                                </TooltipWrapper>
                                                            </div>
                                                        )
                                                    }} />
                                                </div>
                                            }
                                            {Object.keys(screenSharingRequests).length > 0 &&
                                                <div className={styles.settingsSection}>
                                                    <div className={styles.sectionTitle}>
                                                        <ScreenShareIcon className={styles.sectionIcon} />
                                                        richieste di condivisione ({Object.keys(screenSharingRequests ?? {}).length})
                                                    </div>
                                                    <Each of={Object.keys(screenSharingRequests)}
                                                        render={(session_id, index) => {
                                                            if (session_id !== localSessionId) {
                                                                return (
                                                                    <div className={styles.user} key={`pip-screenshare-${session_id}`}>
                                                                        <img className={styles.userPicture} src={getUser(session_id)?.picture ?? UserPlaceholder} alt="User" />
                                                                        {getUser(session_id)?.role &&
                                                                            <div className={styles.userName}>{getUser(session_id)?.name ?? ''} {getUser(session_id)?.surname ?? ''} {session_id === localSessionId ? '(Tu)' : ''}</div>
                                                                        }
                                                                        {!getUser(session_id)?.role &&
                                                                            <div className={styles.userName}>
                                                                                {getUser(session_id)?.name ?? ''}
                                                                                {getUser(session_id)?.surname ? (isSharingScreen ? ` ${getUser(session_id)?.surname?.[0]}.` : ` ${getUser(session_id)?.surname}`) : ''}
                                                                            </div>
                                                                        }

                                                                        <CheckmarkCircleIcon className={`${styles.userIcon} ${styles.accept}`} onClick={() => { acceptScreenSharingRequest(session_id) }} />

                                                                        <DismissCircleIcon className={`${styles.userIcon} ${styles.decline}`} onClick={() => { denyScreenSharingRequest(session_id) }} />

                                                                    </div>
                                                                )
                                                            }
                                                        }} />
                                                </div>
                                            }
                                            <div className={styles.settingsSection}>
                                                <div className={styles.sectionTitle}>
                                                    <UsersIcon className={styles.sectionIcon} />
                                                    presenti ({participants.filter((session_id) => {
                                                        const user = getUser(session_id)
                                                        if (!user?.role) {
                                                            return true
                                                        }
                                                        return false
                                                    }).length})
                                                </div>
                                                {sessionData?.groups && sessionData?.groups?.length > 0 &&
                                                    <>
                                                        <div style={{ display: 'flex', flexDirection: 'column', border: '1px solid rgba(var(--text-rgb), 12%)', borderRadius: '0.5rem', padding: '0.5rem' }} >
                                                            <div className={styles.sectionTitle} style={{ padding: '0.25rem' }}>
                                                                Stanza principale ({
                                                                    participants.filter(p =>
                                                                        !groupsMap?.current?.[`students_group_${p}`] && !getUser(p)?.role
                                                                    ).length
                                                                })
                                                            </div>
                                                            <Each of={participants.filter(p =>
                                                                !groupsMap?.current?.[`students_group_${p}`] && !getUser(p)?.role
                                                            )} render={(session_id) => {
                                                                const user = getUser(session_id)
                                                                if (!user?.role) {
                                                                    return (
                                                                        <div className={styles.user} key={`pip-groups-${session_id}`}>
                                                                            <div className={styles.userPictureWrapper}>
                                                                                <img className={styles.userPicture} src={getUser(session_id)?.picture ?? UserPlaceholder} alt="User" />
                                                                                <PinIcon className={`${styles.userPin} ${pinnedIds.includes(session_id) ? styles.pinned : ''} ${isMobile ? styles.mobile : ''}`} onClick={() => {
                                                                                    togglePinned(session_id)
                                                                                }} />
                                                                            </div>
                                                                            <div className={styles.userInfo}>
                                                                                <div className={styles.userName}>
                                                                                    {getUser(session_id)?.name ?? ''}
                                                                                    {getUser(session_id)?.surname ? (isSharingScreen ? ` ${getUser(session_id)?.surname?.[0]}.` : ` ${getUser(session_id)?.surname}`) : ''}
                                                                                </div>
                                                                                {groups.find((g) => g.participants.includes(user?.id)) &&
                                                                                    <div className={styles.userRole}>{groups.find((g) => g.participants.includes(user?.id)).name}</div>
                                                                                }
                                                                                {!groups.find((g) => g.participants.includes(user?.id)) &&
                                                                                    <div className={styles.userRole}>Nessun Gruppo</div>
                                                                                }
                                                                            </div>
                                                                            {session_id === localSessionId &&
                                                                                <div className={styles.userName}>{context.user?.name ?? ''} {context.user?.surname ?? ''} (Tu)</div>
                                                                            }
                                                                            {hasHandRaised(session_id) &&
                                                                                <HandIcon className={styles.userIcon} onClick={() => {
                                                                                    handleRaiseHand(session_id)
                                                                                }} />
                                                                            }
                                                                            {isSharing(session_id) &&
                                                                                <ScreenShareStopIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setScreenShare: false }) }} />
                                                                            }
                                                                            {hasMic(session_id) &&
                                                                                <MicIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setAudio: false }) }} />
                                                                            }
                                                                            {!hasMic(session_id) &&
                                                                                <MicOffIcon className={`${styles.userIcon}`} onClick={() => {
                                                                                    return
                                                                                    // window.parent.focus()
                                                                                    // setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                                                }} />
                                                                            }
                                                                            {hasCam(session_id) &&
                                                                                <CamIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setVideo: false }) }} />
                                                                            }
                                                                            {!hasCam(session_id) &&
                                                                                <CamOffIcon className={`${styles.userIcon}`} onClick={() => {
                                                                                    return
                                                                                    // window.parent.focus()
                                                                                    // setPrivacyUser({ session_id: session_id, media: 'Videocamera' })
                                                                                }
                                                                                } />
                                                                            }
                                                                            {session_id !== localSessionId &&
                                                                                <MeatBallsMenu menuIconStyle={{ width: '20px', height: '20px', minWidth: '20px', minHeight: '20px', color: '#aaaaaa' }} actions={[
                                                                                    { label: "Rimuovi", icon: PersonDeleteIcon, style: { color: "var(--sf-red)", fontWeight: 500 }, onClick: () => { setRemoveParticipant(session_id) } }
                                                                                ]} />
                                                                            }
                                                                        </div>
                                                                    )
                                                                }
                                                            }} />
                                                        </div>
                                                        <Each of={sessionData?.groups} render={(group) => {
                                                            return (
                                                                <>
                                                                    <div style={{ display: 'flex', flexDirection: 'column', border: '1px solid rgba(var(--text-rgb), 12%)', borderRadius: '0.5rem', padding: '0.5rem' }} >
                                                                        <div className={styles.sectionTitle} style={{ padding: '0.25rem' }}>
                                                                            {group.name} ({
                                                                                participants.filter(p =>
                                                                                    groupsMap?.current?.[`students_group_${p}`] === group.id && !getUser(p)?.role
                                                                                )
                                                                                    .length})
                                                                        </div>
                                                                        <Each of={
                                                                            participants.filter(p =>
                                                                                groupsMap?.current?.[`students_group_${p}`] === group.id && !getUser(p)?.role
                                                                            )
                                                                        } render={(session_id, index) => {
                                                                            const user = getUser(session_id)
                                                                            if (!user?.role) {
                                                                                return (
                                                                                    <div className={styles.user} key={`list2-${session_id}`}>
                                                                                        <div className={styles.userPictureWrapper}>
                                                                                            <img className={styles.userPicture} src={getUser(session_id)?.picture ?? UserPlaceholder} alt="User" />
                                                                                            <PinIcon className={`${styles.userPin} ${pinnedIds.includes(session_id) ? styles.pinned : ''} ${isMobile ? styles.mobile : ''}`} onClick={() => {
                                                                                                togglePinned(session_id)
                                                                                            }} />
                                                                                        </div>
                                                                                        <div className={styles.userName}>
                                                                                            {getUser(session_id)?.name ?? ''}
                                                                                            {getUser(session_id)?.surname ? (isSharingScreen ? ` ${getUser(session_id)?.surname?.[0]}.` : ` ${getUser(session_id)?.surname}`) : ''}
                                                                                        </div>
                                                                                        {session_id === localSessionId &&
                                                                                            <div className={styles.userName}>{context.user?.name ?? ''} {context.user?.surname ?? ''} (Tu)</div>
                                                                                        }
                                                                                        {hasHandRaised(session_id) &&
                                                                                            <HandIcon className={styles.userIcon} onClick={() => {
                                                                                                handleRaiseHand(session_id)
                                                                                            }} />
                                                                                        }
                                                                                        {isSharing(session_id) &&
                                                                                            <ScreenShareStopIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setScreenShare: false }) }} />
                                                                                        }
                                                                                        {hasMic(session_id) &&
                                                                                            <MicIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setAudio: false }) }} />
                                                                                        }
                                                                                        {!hasMic(session_id) &&
                                                                                            <MicOffIcon className={`${styles.userIcon}`} onClick={() => {
                                                                                                return
                                                                                                // window.parent.focus()
                                                                                                // setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                                                            }} />
                                                                                        }
                                                                                        {hasCam(session_id) &&
                                                                                            <CamIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setVideo: false }) }} />
                                                                                        }
                                                                                        {!hasCam(session_id) &&
                                                                                            <CamOffIcon className={`${styles.userIcon}`} onClick={() => {
                                                                                                return
                                                                                                // window.parent.focus()
                                                                                                // setPrivacyUser({ session_id: session_id, media: 'Videocamera' })
                                                                                            }
                                                                                            } />
                                                                                        }
                                                                                        {session_id !== localSessionId &&
                                                                                            <MeatBallsMenu menuIconStyle={{ width: '20px', height: '20px', minWidth: '20px', minHeight: '20px', color: '#aaaaaa' }} actions={[
                                                                                                { label: "Rimuovi", icon: PersonDeleteIcon, style: { color: "var(--sf-red)", fontWeight: 500 }, onClick: () => { setRemoveParticipant(session_id) } }
                                                                                            ]} />
                                                                                        }
                                                                                    </div>
                                                                                )
                                                                            }
                                                                        }} />
                                                                    </div>
                                                                </>
                                                            )
                                                        }} />
                                                    </>
                                                }
                                                {(!sessionData?.groups || sessionData?.groups?.length === 0) &&
                                                    <Each of={participants}
                                                        render={(session_id, index) => {
                                                            const user = getUser(session_id)
                                                            if (!user?.role) {
                                                                return (
                                                                    <div className={styles.user} key={`pip-participant-${session_id}`}>
                                                                        <div className={styles.userPictureWrapper}>
                                                                            <img className={styles.userPicture} src={getUser(session_id)?.picture ?? UserPlaceholder} alt="User" />
                                                                            <PinIcon className={`${styles.userPin} ${pinnedIds.includes(session_id) ? styles.pinned : ''} ${isMobile ? styles.mobile : ''}`} onClick={() => {
                                                                                togglePinned(session_id)
                                                                            }} />
                                                                        </div>
                                                                        {getUser(session_id)?.role &&
                                                                            <div className={styles.userName}>{getUser(session_id)?.name ?? ''} {getUser(session_id)?.surname ?? ''} {session_id === localSessionId ? '(Tu)' : ''}</div>
                                                                        }
                                                                        {!getUser(session_id)?.role &&
                                                                            <div className={styles.userName}>
                                                                                {getUser(session_id)?.name ?? ''}
                                                                                {getUser(session_id)?.surname ? (isSharingScreen ? ` ${getUser(session_id)?.surname?.[0]}.` : ` ${getUser(session_id)?.surname}`) : ''}
                                                                            </div>
                                                                        }
                                                                        {session_id === localSessionId &&
                                                                            <div className={styles.userName}>{context.user?.name ?? ''} {context.user?.surname ?? ''} (Tu)</div>
                                                                        }
                                                                        {hasHandRaised(session_id) &&
                                                                            <HandIcon className={styles.userIcon} onClick={() => {
                                                                                handleRaiseHand(session_id)
                                                                            }} />
                                                                        }
                                                                        {isSharing(session_id) &&
                                                                            <ScreenShareStopIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setScreenShare: false }) }} />
                                                                        }
                                                                        {hasMic(session_id) &&
                                                                            <MicIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setAudio: false }) }} />
                                                                        }
                                                                        {!hasMic(session_id) &&
                                                                            <MicOffIcon className={`${styles.userIcon}`} onClick={() => {
                                                                                return
                                                                                // window.parent.focus()
                                                                                // setPrivacyUser({ session_id: session_id, media: 'Microfono' })
                                                                            }} />
                                                                        }
                                                                        {hasCam(session_id) &&
                                                                            <CamIcon className={styles.userIcon} onClick={() => { call.updateParticipant(session_id, { setVideo: false }) }} />
                                                                        }
                                                                        {!hasCam(session_id) &&
                                                                            <CamOffIcon className={`${styles.userIcon}`} onClick={() => {
                                                                                return
                                                                                // window.parent.focus()
                                                                                // setPrivacyUser({ session_id: session_id, media: 'Videocamera' })
                                                                            }} />
                                                                        }
                                                                        {session_id !== localSessionId &&
                                                                            <MeatBallsMenu menuIconStyle={{ width: '20px', height: '20px', minWidth: '20px', minHeight: '20px', color: '#aaaaaa' }} actions={[
                                                                                { label: "Rimuovi", icon: PersonDeleteIcon, style: { color: "var(--sf-red)", fontWeight: 500 }, onClick: () => { setRemoveParticipant(session_id) } }
                                                                            ]} />
                                                                        }
                                                                    </div>
                                                                )
                                                            }
                                                        }} />
                                                }
                                            </div>

                                            <div className={styles.settingsSection}>
                                                <div className={styles.sectionTitle}>
                                                    <PersonDeleteIcon className={styles.sectionIcon} />
                                                    assenti ({students?.filter((s) => !isOnline(s.id)).length})
                                                </div>
                                                <Each of={students?.filter((s) => !isOnline(s.id))}
                                                    render={(student, index) => {
                                                        return (
                                                            <div className={styles.user} key={`pip-students-${student.id}`}>
                                                                <div className={styles.userPictureWrapper}>
                                                                    <img className={styles.userPicture} src={student?.picture ?? UserPlaceholder} alt="User" />
                                                                </div>
                                                                <div className={styles.userName}>
                                                                    {student?.name ?? ''}
                                                                    {student?.surname ? (isSharingScreen ? ` ${student?.surname?.[0]}.` : ` ${student?.surname}`) : ''}
                                                                </div>
                                                                {!notified.includes(student.id) &&
                                                                    <NotificationIcon className={styles.userIcon} onClick={async () => { await notifyAbsents([student.id]) }} />
                                                                }
                                                                {notified.includes(student.id) &&
                                                                    <NotificationOffIcon className={`${styles.userIcon} ${styles.disabled}`} />
                                                                }
                                                            </div>
                                                        )

                                                    }} />
                                            </div>

                                        </div>
                                    }
                                </>
                            }
                            <TabIconSwitcher
                                style={{ '--background': 'rgba(0,0,0,0.1)' }}
                                names={true}
                                theme={theme}
                                tabs={[
                                    { icon: <GridIcon />, name: 'Griglia' },
                                    { icon: <ChatIcon />, name: 'Chat', badge: unread > 0 ? unread : null },
                                    { icon: <UsersIcon />, name: 'Utenti', badge: waitingParticipants.length + Object.keys(screenSharingRequests).length + handRaisedIds.length > 0 ? waitingParticipants.length + Object.keys(screenSharingRequests).length + handRaisedIds.length : null },
                                ]}
                                selected={selectedPipTab}
                                onSelect={(index) => {
                                    setSelectedPipTab(index)
                                    if (index === 0) {
                                        setPipSidebar(false)
                                    }
                                    if (index === 1) {
                                        setPipSidebar(true)
                                        setUnread(0)
                                    }
                                    if (index === 2) {
                                        setPipSidebar(true)
                                    }
                                }}
                            />
                        </div>
                    </PiPWindow>
                )
            }
        </div >
    )

}

export default Room;